/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint no-var: off */
/* eslint eqeqeq: off */
/* eslint no-prototype-builtins: off */
/* eslint no-useless-escape: off */
/* eslint no-shadow-restricted-names: off */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/no-empty-function */

interface Document {
    documentMode?: any;
}

interface Window {
    console: any;
    JSON: any;
    clipboardData: any;
    minimizeModal: (title: string) => void;
}

interface KeyboardEvent {
    isKeyCodePrintableCharacter: () => boolean;
}

interface Number {
    format: (format: string) => string;
    toMoney: () => string;
}

interface Object {
    byString: (o: any, s: string) => any;
}

interface String {
    replaceAll: (target, replacement) => string;
    reverse: () => string;
    leftPad: (size, ch) => String;
    rightPad: (size, ch) => String;
    trimRight: () => string;
    trimLeft: () => string;
    escape: (str: string) => string;
    stripTags: () => string;
    escapeHTML: () => string;
    unescapeHTML: () => string;
    toTitleCase: () => string;
    escapeXML: () => string;
    unescapeXML: () => string;
    repeat: (num: number) => string;
}

interface DateConstructor {
    firstDayOfWeek: number;
    format: string;
}

interface JQueryStatic {
    attr: (element: any, name: string) => any;
    browser: any;
    css: any;
    curCSS: any;
    datepicker: any;
    jqm: (options: any) => any;
}

interface JQuery {
    autocomplete: (url: string, config: any) => any;
    cloneSelects: any;
    datepicker: (options: any) => any;
    inputmask: (options: any) => any;
    maskedInput: (options?: any) => any;
    maskedDateInput: () => any;
    hoverIntent: (config: any) => void;
    jqm: (options: any) => any;
    jqmAddTrigger: (options: any) => any;
    jqmHide: any;
    jqmShow: any;
    live: (event: string, callback: () => any) => any;
    preventDoubleSubmission: () => any;
    qtip: (options: any) => any;
    size(): number;
    sortable: (options: any) => void;
    timeEntry: (options: any) => void;
    unautocomplete: () => void;
    origamiSpinner: (any) => void;
    dialog: (...any) => JQuery;
}

declare var getCurrentAccountLogin: () => any;
declare var afterCloseIframeModal: () => void;
declare var clearRadioButtons: () => void;
declare var evaluateFormExpressions: (element: any) => void; //($(this).closest("div.origamiform"));
declare var enableEssentialCookiesOnly: boolean;
declare var getFieldsFromFormula: (string: any) => string;
declare var getCurrentClientID: () => string;
declare var getControllerName: () => string;
declare var getControllerAction: () => string;
declare var getRecordID: () => number;  // currently only works on edit pages
declare var getCurrentSessionKey: () => string;
declare var getCurrentUserUsesAssistiveTechnology: () => number;
declare var getCurrentUserNumberGroupSeparator: () => string;
declare var getCurrentUserNumberDecimalSeparator: () => string;
declare var getDefaultPhoneCountry: () => string;
declare var getEnableTimeoutWarning: () => boolean;
declare var getTimeoutDuration: () => number;
declare var getToolTipTheme: () => string;
declare var getTPAClientID: () => string;
declare var gridHandleDroppedElement: () => void;
declare var initMaskedInput: () => void;
declare var isValidEmail: (email: string) => boolean;
declare var inputnameprefix: string;
declare var getServerAppRoot: () => string;
declare var Highcharts: any;
declare var removeFieldsFromDefinitionAlreadyInView: () => void;
declare var tippy: (o: any, useOptions: any) => any;
declare var toggleFieldChanged: (propName: string, x: boolean) => void;
declare var TryHideParentPopup: () => void;
declare var _userJqueryDateFormat: string;
declare var _userDateFormatMask: string;
declare var libphonenumber: any;
declare var Inputmask: any;
declare var initializeMap: (node: any) => void;
declare var skipCodeDependencySetup: (input: any) => boolean;
declare var ajaxGridPost: boolean;
declare var resizeModal: () => void;
declare var getSensitiveFieldChanges: () => object[]; // only works on edit pages, defined in Edit.cshtml
declare var formulaFieldChangeFunction: () => void; // defined in formformulas.js

if (!window.console) window.console = {};
if (!window.console.log) window.console.log = function () { };

//#region number and string helper functions
/**
* Formats the number according to the ‘format’ string;
* adherses to the american number standard where a comma
* is inserted after every 3 digits.
*  note: there should be only 1 contiguous number in the format,
* where a number consists of digits, period, and commas
*        any other characters can be wrapped around this number, including ‘$’, ‘%’, or text
*        examples (123456.789):
*          ‘0′ - (123456) show only digits, no precision
*          ‘0.00′ - (123456.78) show only digits, 2 precision
*          ‘0.0000′ - (123456.7890) show only digits, 4 precision
*          ‘0,000′ - (123,456) show comma and digits, no precision
*          ‘0,000.00′ - (123,456.78) show comma and digits, 2 precision
*          ‘0,0.00′ - (123,456.78) shortcut method, show comma and digits, 2 precision
*
* @method format
* @param format {string} the way you would like to format this text
* @return {string} the formatted number
* @public
*/

if (typeof KeyboardEvent != 'undefined') {
    KeyboardEvent.prototype.isKeyCodePrintableCharacter = function () {
        var that: any = this;
        var keycode: number = that.keyCode;

        var printable =
            (keycode > 47 && keycode < 58) || // number keys
            keycode == 32 || keycode == 13 || // spacebar & return key(s) (if you want to allow carriage returns)
            (keycode > 64 && keycode < 91) || // letter keys
            (keycode > 95 && keycode < 112) || // numpad keys
            (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
            (keycode > 218 && keycode < 223);   // [\]' (in order)

        return printable;
    };
}

Number.prototype.format = function(format) {
    var hasComma = -1 < format.indexOf(','),
        hasDecimal = -1 < format.indexOf('.'),
        psplit = format.replace(/[^0-9\u2013\-\.]/g, '').split('.'),
        that: any = this;

    // compute precision
    if (1 < psplit.length) {
        // fix number precision
        that = that.toFixed(psplit[1].length);
    }
    // error: too many periods
    else if (2 < psplit.length) {
        throw ('NumberFormatException: invalid format, formats should have no more than 1 period: ' + format);
    }
    // remove precision
    else {
        that = that.toFixed(0);
    }

    // get the string now that precision is correct
    var fnum = that.toString();

    // format has comma, then compute commas
    if (hasComma) {
        // remove precision for computation
        psplit = fnum.split('.');

        var cnum = psplit[0],
            parr = [],
            j = cnum.length,
            m = Math.floor(j / 3),
            n = (cnum.length % 3) || 3; // n cannot be ZERO or causes infinite loop

        // break the number into chunks of 3 digits; first chunk may be less than 3
        for (var i = 0; i < j; i += n) {
            if (0 !== i) { n = 3; }
            parr[parr.length] = cnum.substr(i, n);
            m -= 1;
        }

        // put chunks back together, separated by comma
        fnum = parr.join(',');

        if (fnum.substr(0, 2) == "-,")
            fnum = "-" + fnum.substr(2);

        // add the precision back in
        if (psplit[1]) { fnum += '.' + psplit[1]; }
    }

    // replace the number portion of the format with fnum
    var invariantResult = format.replace(/[\d,?\.?]+/, fnum);

    if (!hasComma && !hasDecimal)
        return invariantResult;


    var groupSeparator = UseGroupSeparator();
    var decimalSeparator = UseDecimalSeparator();

    if (invariantGroupSeparator == groupSeparator && invariantDecimalSeparator == decimalSeparator)
        return invariantResult;

    var decParts = invariantResult.split(invariantDecimalSeparator);
    var groupParts = decParts[0].split(invariantGroupSeparator);

    decParts[0] = groupParts.join(groupSeparator);

    return decParts.join(decimalSeparator);

};

Number.prototype.toMoney = function () {

    return this.format("0,0.00");

};

Object.byString = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
}

Math.trunc = Math.trunc || function (x) {
    if (isNaN(x)) {
        return NaN;
    }
    if (x > 0) {
        return Math.floor(x);
    }
    return Math.ceil(x);
};

var invariantGroupSeparator = ",";
var invariantDecimalSeparator = ".";

function dynamicLoadJavascript(url, callback) {
    jQuery.ajax({
        url: url,
        dataType: 'script',
        success: callback,
        cache: true,
        async: true
    });
}

function GetRawInvariantNumber(input)
{
    if (input == null)
        return null;

    var groupSeparator = UseGroupSeparator();
    var decimalSeparator = UseDecimalSeparator();

    input = input.replaceAll('&nbsp;', ' ');

    var removeNonNumeric = new RegExp("[^0-9" + groupSeparator + decimalSeparator + "\-]", "g");
    input = input.replace(removeNonNumeric, '');

    var decParts = input.split(decimalSeparator);
    var groupPart = decParts[0].replaceAll(groupSeparator,'');

    if(decParts.length == 1)
        return groupPart;

    var result = groupPart.concat('.', decParts[1]);

    return result;
}

function GetUserNumberFromInvariant(input) {
    if (isNaN(input))
        return input;

    var val = eval(input);

    var decParts = input.toString().split(invariantDecimalSeparator);
    var useformat = "0,000";

    if (decParts.length == 1)
        return val.format(useformat);

    var numDecimals = decParts[1].length;

    if (numDecimals > 0) {
        for (let i = 0; i < numDecimals; i++) {
            if (i == 0)
                useformat = useformat + ".0";
            else
                useformat = useformat + "0";
        }
    }

    return val.format(useformat);
}

function SafeParseFloat(input) {
    if (input === null || input === 'undefined') {
        return NaN;
    }
    input = GetRawInvariantNumber(input);
    if (isNaN(input)) {
        return NaN;
    }
    return parseFloat(input);
}


function UseGroupSeparator()
{
    return (typeof getCurrentUserNumberGroupSeparator == 'function') ? getCurrentUserNumberGroupSeparator() : invariantGroupSeparator;
}

function UseDecimalSeparator()
{
    return (typeof getCurrentUserNumberDecimalSeparator == 'function') ? getCurrentUserNumberDecimalSeparator() : invariantDecimalSeparator;
}

function getSelectedTextOfElement(elem) {
    try {
        if (elem.tagName === "TEXTAREA" ||
            (elem.tagName === "INPUT" && elem.type === "text")) {
            return elem.value.substring(elem.selectionStart,
                elem.selectionEnd);
        }
        return null;
    }
    catch {
        return null;
    }
}

function GetFormattedPhoneNumberView(origPhone, defaultCountry) {
    try {
        const defaultCountrySet = typeof defaultCountry != 'undefined';
        const useCountry = defaultCountrySet ? defaultCountry : (typeof getDefaultPhoneCountry == 'function' ? getDefaultPhoneCountry() : 'US');
        const parseNumber = new libphonenumber.parsePhoneNumber(origPhone, useCountry);

        if (typeof parseNumber === 'undefined')
            return origPhone;

        console.log(parseNumber);
        return parseNumber.formatNational();
    }
    catch (error) {
        // Not a phone number, non-existent country, etc.
        console.log(error);
        return origPhone;
    }
}

/* string helper functions */
String.prototype.replaceAll = function(target, replacement) {
  return this.split(target).join(replacement);
};

String.prototype.trim = function () {
    return this.replace(/^\s*/, "").replace(/\s*$/, "");
}
String.prototype.trimLeft =
function() {
    return this.replace(/^\s+/, '');
}
String.prototype.trimRight =
function() {
    return this.replace(/\s+$/, '');
}

String.prototype.reverse = function() {
    var res = "";
    for (var i = this.length; i > 0; --i) {
        res += this.charAt(i - 1);
    }
    return res;
}

String.prototype.leftPad = function(size, ch) {
    var result = new String(this);
    if (ch == null) {
        ch = " ";
    }
    while (result.length < size) {
        result = ch + result;
    }
    return result;
}

String.prototype.rightPad = function(size, ch) {
    var result = new String(this);
    if (ch == null) {
        ch = " ";
    }
    while (result.length < size) {
        result = result + ch;
    }
    return result;
}

String.prototype.repeat = function (num) {
    return new Array(num + 1).join(this);
}

String.prototype.escape = function(string) {
    return string.replace(/('|\\)/g, "\\$1");
}

String.prototype.stripTags = function() {
    return this.replace(/<\/?[^>]+>/gi, '');
}

String.prototype.escapeHTML = function() {
    var div = document.createElement('div');
    var text = document.createTextNode(this);
    div.appendChild(text);
    return div.innerHTML;
}

String.prototype.escapeXML = function() {
    var unsafe = this;
    return unsafe.replace(/[<>&'"]/g, function(c) {
        switch(c) {
            case '<': return '&lt;';
            case '>': return '&gt;';
            case '&': return '&amp;';
            case '\'': return '&apos;';
            case '"': return '&quot;';
        }
    });
}

String.prototype.unescapeXML = function () {
    var unsafe = this;
    return unsafe.replace(/[<>&'"]/g, function (c) {
        switch (c) {
            case '&lt;': return '<';
            case '&gt;': return '>';
            case '&amp;': return '&';
            case '&apos;': return '\'';
            case '&quot;': return '"';
        }
    });
}

String.prototype.unescapeHTML = function() {
    var div = document.createElement('div');
    div.innerHTML = this.stripTags();
    return div.childNodes[0].nodeValue;
}

String.prototype.startsWith = function (str) {
    return this.indexOf(str) == 0;
};

String.prototype.endsWith = function (suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};

/* To Title Case © 2018 David Gouch | https://github.com/gouch/to-title-case */

// eslint-disable-next-line no-extend-native
String.prototype.toTitleCase = function () {
    'use strict'
    var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i
    var alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/
    var wordSeparators = /([ :–—-])/

    return this.split(wordSeparators)
        .map(function (current, index, array) {
            if (
                /* Check for small words */
                current.search(smallWords) > -1 &&
                /* Skip first and last word */
                index !== 0 &&
                index !== array.length - 1 &&
                /* Ignore title end and subtitle start */
                array[index - 3] !== ':' &&
                array[index + 1] !== ':' &&
                /* Ignore small words that start a hyphenated phrase */
                (array[index + 1] !== '-' ||
                    (array[index - 1] === '-' && array[index + 1] === '-'))
            ) {
                return current.toLowerCase()
            }

            /* Ignore intentional capitalization */
            if (current.substr(1).search(/[A-Z]|\../) > -1) {
                return current
            }

            /* Ignore URLs */
            if (array[index + 1] === ':' && array[index + 2] !== '') {
                return current
            }

            /* Capitalize the first letter */
            return current.replace(alphanumericPattern, function (match) {
                return match.toUpperCase()
            })
        })
        .join('')
}

//#endregion

//#region url manipulation
//https://css-tricks.com/snippets/javascript/get-url-variables/
function getParameterByName(variable) {
    if (variable == null)
        return null;

    var searchtext = window.location.search;
    if (searchtext == null || searchtext == "")
        return null;

    var query = searchtext.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0].toLowerCase() == variable.toLowerCase()) { return decodeURIComponent(pair[1].replace(/\+/g, " ")); }
    }

    return null;
}

function propagateHrefParameter(selector, name) {
    var value = getParameterByName(name);
    if (value == null || value == "")
        return;

    $(selector).each(function () {
        var href = $(this).attr("href");
        if (href == null || href == "" && href == undefined)
            return;

        if (href.toLowerCase().indexOf(name.toLowerCase()) !== -1)
            return;

        href = insertParameterToUrl(href, name, value);
        $(this).attr("href", href);
    });
}

function insertParameterToUrl(url, key, value) {
    var tempArray = url.split("?");
    var baseUrl = tempArray[0];
    var additionalUrl = tempArray[1];

    if (additionalUrl == null || additionalUrl == undefined)
        return baseUrl + "?" + [escape(key), encodeURIComponent(value)].join('=');
    else {
        var newAdditionalUrl = insertParameter(additionalUrl, key, value);
        return baseUrl + "?" + newAdditionalUrl;
    }
}

function removeParameterFromUrl(url, key) {
    var tempArray = url.split("?");
    var baseUrl = tempArray[0];
    var additionalUrl = tempArray[1];

    if (additionalUrl != null && additionalUrl != undefined) {
        var newAdditionalUrl = removeParameter(additionalUrl, key);
        return baseUrl + "?" + newAdditionalUrl;
    }
}

function insertParameter(paramString, key, value) {
    key = escape(key); value = encodeURIComponent(value);

    var kvp = paramString.split('&');

    var i = kvp.length; var x; while (i--) {
        x = kvp[i].split('=');

        if (x[0].toLowerCase() == key.toLowerCase()) {
            x[1] = value;
            kvp[i] = x.join('=');
            break;
        }
    }

    if (i < 0) { kvp[kvp.length] = [key, value].join('='); }

    return kvp.join('&');
}

function removeParameter(paramString, key) {
    key = escape(key);

    var kvp = paramString.split('&');

    var i = kvp.length; var x; while (i--) {
        x = kvp[i].split('=');

        if (x[0].toLowerCase() == key.toLowerCase()) {
            kvp.splice(i, 1);
            break;
        }
    }

    if (i < 0) { kvp.splice(kvp.length, 1); }

    if (kvp.length == 0)
        return kvp;
    else
        return kvp.join('&');
}

function urlParametersFromDiv(divID, dateFormat, inputPrefix) {
    return urlParametersFromElement($("#" + divID), dateFormat, inputPrefix);
}

function urlParametersFromElement(element, dateFormat, inputPrefix) {
    var urlParam = "";

    // Clear the hidden inputs for the multi-select searches
    $('input[type=hidden][name^=__multiselectsearch_]').each(function () {
        $(this).val('');
    });

    const inputSelector = $(element).find("input[name],select[name]");
    $(inputSelector).each(function () {
        var type = $(this).attr('type');
        var name = $(this).attr('name');

        if (type == 'button' || type == 'submit')
            return;

        if (type != null)
            type = type.toLowerCase();

        var test = "";
        if ($(this).hasClass('date') || $(this).hasClass('inputDate') || $(this).hasClass('searchInputDate')) {
            test = $(this).val();
            if (test.startsWith('='))
                test = '=' + convertUserDateValueToUrlDate(test.substring(1));
            else
                test = convertUserDateValueToUrlDate(test);

        }
        else if (type == 'checkbox' && !name.startsWith('__multiselectsearch_')) {
            if ($(this).prop('checked'))
                test = "on";
            else
                test = "off";
        }
        else if (type == 'checkbox' && name.startsWith('__multiselectsearch_')) {
            var hiddenInput = $("input[type='hidden'][name='" + name + "']");

            var hiddenValue = hiddenInput.val();

            if ($(this).prop('checked')) {
                var addValue = $(this).val() + ',';
                if (hiddenInput.val().indexOf(addValue) < 0)
                    hiddenInput.val(hiddenValue + addValue);
            }

        }
        else if (type == 'radio') {
            if ($(this).prop('checked'))
                test = $(this).val();
            else
                test = "";
        }
        else {
            if ($(this).val() == null)
                test = "";
            else
                test = $(this).val();
        }
        if ($(this).attr("alt") == "integer")
            test = GetRawInvariantNumber(test);

        if ((test.length > 0) || $(this).hasClass('alwaysInclude')) {
            if (urlParam != "")
                urlParam += "&";

            if ($(this).parent('span.containsSearch').length > 0 && !test.startsWith('%'))
                test = '%' + test;

            var useName = $(this).attr('name');

            if (useName.startsWith('__multiselectsearch_')) {
                useName = useName.replace('__multiselectsearch_', '');
                if (test.endsWith(','))
                    test = test.slice(0, -1);
            }

            if (type != 'hidden' && typeof inputPrefix != 'undefined' && inputPrefix > '')
                useName = inputPrefix + useName;
            urlParam += useName + '=' + encodeURIComponent(test);
        }
    });

    return urlParam;
}

function urlCheckboxParametersFromDiv(divID, fieldname) {
    var urlCheckboxParam = "";

    const inputSelector = "#" + divID + " input[name]";
    $(inputSelector).each(function () {

        var checkboxID = $(this).attr('id');
        if (typeof checkboxID === 'undefined')
            checkboxID = $(this).attr('value');

        var type = $(this).attr('type');
        var checked = $(this).prop('checked');

        if (type != 'checkbox')
            return;

        if (checked == true) {
            if (urlCheckboxParam.length > 0) {
                urlCheckboxParam += ",";
            }

            urlCheckboxParam += checkboxID;
        }

    });

    if (urlCheckboxParam.length > 0) {
        urlCheckboxParam = "&" + fieldname + "=" + urlCheckboxParam;
    }

    return urlCheckboxParam;
}
//#endregion

//#region index request logs
//http://stackoverflow.com/questions/11214404/how-to-detect-if-browser-supports-html5-local-storage
function browserSupportsLocalStorage() {
    var mod = 'modernizr';
    try {
        localStorage.setItem(mod, mod);
        localStorage.removeItem(mod);
        return true;
    } catch (e) {
        return false;
    }
}

function browserSupportsJSON() {
    return (typeof JSON === 'object' && typeof JSON.parse === 'function');
}

function getIndexLog(sessionKey) {
    // check if this is a new origami session.  if it is, just clear out
    // prior indexLogs.
    var key = window.localStorage.sessionKey;
    if (key == null || sessionKey !== key) {
        window.localStorage.indexLog = null;
        window.localStorage.sessionKey = sessionKey;

        return [];
    }

    var json = window.localStorage.indexLog;
    if (json == null || typeof json == "undefined")
        return [];

    return window.JSON.parse(json);
}

function saveIndexRequestLog(controllerName, queryString) {
    // if browser does not support localStorage, GTFO
    if (!browserSupportsLocalStorage() || !browserSupportsJSON())
        return;

    if (typeof getCurrentSessionKey != 'function')
        return;

    var sessionKey = getCurrentSessionKey();
    var current = getIndexLog(sessionKey) || [];

    var updated = false;
    for (var i in current) {
        var pair = current[i];
        if (pair.key == controllerName) {
            pair.value = queryString;
            updated = true;
            break;
        }
    }
    if (!updated)
        current.push({ key: controllerName, value: queryString });

    window.localStorage.indexLog = window.JSON.stringify(current);
}

function updateLinksWithSearchList(subset) {
    //ORDEV-29330 - initializeAll is being called twice on the document queue index page resulting in this function
    //              executing twice and not restricted to the subset.  This caused duplicate _searchList parameter to be added to each link
    //              when it should only have been added a single time.
    var searchList = $("table.dataGrid a.searchlist", subset).first().closest('tbody[searchList]').attr('searchList');

    if (typeof searchList == 'undefined' || searchList == null || searchList == '')
        return;

    var encodedString = encodeURIComponent(searchList);
    $("table.dataGrid a.searchlist").each(function () {
        var url = $(this).attr("href");
        if (url.split("?").length > 1)
            url += "&_searchList=" + encodedString;
        else
            url += "?_searchList=" + encodedString;

        $(this).attr("href", url);
    });

    $("table.dataGrid a.searchlist[data-editurl]").each(function () {
        var url = $(this).attr("data-editurl");
        if (url.split("?").length > 1)
            url += "&_searchList=" + encodedString;
        else
            url += "?_searchList=" + encodedString;

        $(this).attr("data-editurl", url);
    });
}

function updateBreadCrumbsWithIndexRequestLog() {
    // if browser does not support localStorage, GTFO
    if (!browserSupportsLocalStorage() || !browserSupportsJSON())
        return;

    if (typeof getCurrentSessionKey != 'function')
        return;

    // no need to update breadcrumbs if nothing in log
    var sessionKey = getCurrentSessionKey();
    var list = getIndexLog(sessionKey) || [];

    if (list==null || list.length == 0)
        return;

    // Handle case where a form that defaults to edit mode needs to respect index log settings when it auto-redirects to index page after save
    var controllerNameControl = $("#controllerName");
    var controllerName = null;
    if (controllerNameControl.length != -1)
        controllerName = controllerNameControl.val();

    if (controllerName != null && controllerName != "") {
        var queryString = null;
        for (var i in list) {
            if (list[i].key == controllerName) {
                queryString = list[i].value;
            }
        }
        if (queryString != null && typeof (queryString) != "undefined" && queryString != "") {
            var indexLogControl = $("#indexLog");
            if (indexLogControl.length > 0)
                indexLogControl.val(queryString);
        }
    }

    $("div.breadcrumbs a.indexrequest").each(function () {

        controllerName = $(this).data("controllername");
        if (controllerName == null || controllerName == "")
            return;

        var queryString = null;
        for (var i in list) {
            if (list[i].key == controllerName) {
                queryString = list[i].value;
                break;
            }
        }
        if (queryString == null || typeof queryString === "undefined" || queryString == "")
            return;

        var url = $(this).attr("href");

        var tempArray = url.split("?");
        var baseUrl = tempArray[0];
        var additionalUrl = tempArray[1];

        var newUrl = url;

        // if leading to a list of associations, add Associated to the breadcrumb
        if (queryString.indexOf("AssociationSource") >= 0 && queryString.indexOf("AssociationSourceInstanceID") >= 0) {
            var curText = $(this).text();
            $(this).text(`Associated ${curText}`);
        }

        // if nothing to merge because the breadcrumb url does not have any params
        if (additionalUrl == null || additionalUrl.trim().length == 0) {
            $(this).attr("href", baseUrl + "?" + queryString);
            return;
        }

        var originalKeys = urlParamsToKeyValueArray(queryString);
        var newKeys = urlParamsToKeyValueArray(additionalUrl);
        var newParams = [];

        for (var i in originalKeys) {
            var okey = originalKeys[i][0];
            var ovalue = originalKeys[i][1];

            // check if newKeys has it
            var added = false;
            for (var x in newKeys) {
                var nkey = newKeys[x][0];
                var nvalue = newKeys[x][1];
                if (nkey.toLowerCase() == okey.toLowerCase()) {
                    if (nvalue !== ovalue)
                        return;
                    else {
                        newParams.push(newKeys[x].join('='));
                        added = true;
                        break;
                    }
                }
            }

            if (!added)
                newParams.push(originalKeys[i].join('='));
        }

        $(this).attr("href", baseUrl + "?" + newParams.join("&"));
    });
}

function updateButtonValueFromModal(buttonId, buttonInnerHtml, buttonHref) {
    var button = document.getElementById(buttonId);
    if (!button) {
        console.error('Button with ID "' + buttonId + '" not found.');
        return;
    }

    button.setAttribute("href", buttonHref);
    button.innerHTML = buttonInnerHtml;
}

function urlParamsToKeyValueArray(paramString) {
    var kvp = paramString.split('&');

    var result = [];
    for (var i in kvp) {
        var test = kvp[i];
        if (test.length == 0)
            continue;

        var p = test.split('=');
        if (p.length == 1)
            result.push(p[0], '')
        else
            result.push([p[0], p[1]]);
    }

    return result;
}

//#endregion

//#region status messages

function isMobileDevice() {
    return navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i);
}

function isResponsiveMobileMode() {

    return (window.matchMedia('only screen and (max-width: 768px)').matches);
}

function clearStatusMessage() {
    $("#message").removeClass("error");
    $("#message").removeClass("notification");
    $("#message").removeClass("success");
    $("#message").removeClass("information");
    $("#message").removeClass("warning");
    $("#message").addClass("hidden");
}

function statusErrorMessage(message, fadeOut?, messageIsAlreadyHtmlEncoded?) {
    statusMessage("error", message, fadeOut, messageIsAlreadyHtmlEncoded);
}

function statusNotificationMessage(message, fadeOut) {
    statusMessage("notification", message, fadeOut);
}

function statusSuccessMessage(message, fadeOut) {
    statusMessage("success", message, fadeOut);
}
function statusMessage(style, message, fadeOut?, messageIsAlreadyHtmlEncoded?) {
	var escapedMessage = "";
	if(messageIsAlreadyHtmlEncoded)
		escapedMessage = message;
	else
        escapedMessage = message.escapeHTML();

    statusMessageHtml(style, escapedMessage, fadeOut);
}

function statusMessageHtml(style, messageHtml, fadeOut?) {
    if (style === "error") {
        let customMessage: string = window.origami.data.CustomRequiredFieldMessage ?? "";
        customMessage = htmlStringNewLineHelper(customMessage);
        messageHtml = (customMessage !== "") ? customMessage : messageHtml;
    }

    $("#message").html(messageHtml).data("messageHtml", messageHtml);

    if (fadeOut != null && typeof fadeOut != 'undefined' && fadeOut == "true")
        setTimeout(function () {
            $("#message").addClass("hidden");
        }, 3000);

    $("#message").removeClass("error");
    $("#message").removeClass("notification");
    $("#message").removeClass("success");
    $("#message").removeClass("hidden");

    $("#message").addClass(style);

    if (getCurrentUserUsesAssistiveTechnology())
        if (!$('#message').hasClass('hidden') && !$('#message').hasClass('notification'))
            alert($('#message').text());
}

function htmlStringNewLineHelper(message: string): string {
    return message.replace("\r\n", "<br/>").replace("\r", "<br/>").replace("\n", "<br/>");
}

function nextStatusErrorMessage(message) {
    nextStatusMessage("error", message);
}

function nextStatusNotificationMessage(message) {
    nextStatusMessage("notification", message);
}

function nextStatusSuccessMessage(message) {
    nextStatusMessage("success", message);
}

function nextStatusMessage(style, message) {
    nextStatusMessageHtml(style, message.escapeHTML());
}

function nextStatusMessageHtml(style, messageHtml) {
    var message = {
        Style: style,
        Html: true,
        Text: messageHtml
    };

    var json = window.JSON.stringify(message);
    eraseCookie('OrigamiTempDataJson64');

    writeCookie("OrigamiScriptTempData", window.btoa(json), 1);
}

// priority must be one of these: polite, assertive, off
function screenReaderMessage(message, assertive) {
    if (!message)
        return;

    var el = document.createElement('div');
    var id = 'sr-accouncement-' + Date.now();
    el.setAttribute('id', id);
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', assertive ? 'assertive' : 'polite');
    el.classList.add('screen-reader');
    document.body.appendChild(el);

    window.setTimeout(function () {
        document.getElementById(id).innerHTML = message;
    }, 100);

    window.setTimeout(function () {
        document.body.removeChild(document.getElementById(id));
    }, 1000);
}

//#endregion

//#region forms and input controls
function setFormFocus(selector, ifVisible?) {
    if (getCurrentUserUsesAssistiveTechnology())
        skipNavigation();
    else {
        var first = $(selector + " :input:not(button):visible:enabled").first();
        if (first.length>0) {
            if (!ifVisible || (ifVisible && isScrolledIntoView(first))) {
                first.trigger("focus");
            }
        }
    }
}

function isScrolledIntoView(elem)
{
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

function setViewFocus(selector) {
    var selected = $(selector + " :tabbable").first();
    $(selector + " :tabbable").first().trigger("focus");
}

function showFormFields(fields, visible) {
    if (visible)
        fields.closest("li").show();
    else
        fields.closest("li").hide();
}

var submitClicked = false;
function onClickSubmit() { submitClicked = true; }

var goBackwards = false;
function onGoBackwards() { goBackwards = true; }

function beforeSaveAndContinueSubmit() : boolean {
    //meant to be overridden, return false to bail
    return true;
}

function afterSaveAndContinueSubmit(): boolean {
    //meant to be overridden, return false to bail
    return true;
}

function afterSaveAndContinueSuccess(data): void {
    //meant to be overridden
}

function afterSaveAndContinueFailure(data): void {
    //meant to be overridden
}


function clearHiddenPanels(formID) {
    var form = $("#" + formID);
    $("div.panel", form).each(function () {
        var isPanelCollapsed = $(this).find("a.expander.collapsed:first").length;
		$("li", this).each(function(){ // field level clearDataIfHidden settings
			var eraseField = $(this).data("clearfield");
            if ((eraseField) && !$(this).is(":visible")) {
                if (isPanelCollapsed && !$(this).hasClass("toggleHidden")) {
                    // if field is not visible only because it is in a collapsed panel
                    // and was not also hidden by some toggle condition, do not clear
                    return;
                }
                clearHiddenInputField(this);
            }
        });

        var toggleField = $(this).data("togglefield");
        var toggleValues = $(this).data("togglevalues");
        var toggleFormula = $(this).data("toggleformula");

        if (!toggleField && !toggleValues && !toggleFormula)
            return;

        if ($(this).is(":visible"))
            return;

        var erase = $(this).hasClass("clearHiddenData"); // panel level clearDataIfHidden setting
        if (erase) {
            clearHiddenInputField(this);
        }
        else if(toggleField || toggleValues){
            $(this).addClass("renamedNames");
            $(":input[name]:not(:button,:submit,:reset)", this).each(function () {
                var closestLi = $(this).closest("li"); // get ancestor li element where the field level clearfield (i.e. clearDataIfHidden) setting would be found if present

                var skipRename = false; // If there's a field level clearDataIfHidden override, then DO send the field to the server to be cleared, even if it's in a hidden panel that does not have clearDataIfHidden set at the panel level
                if (closestLi.length > 0) {
                    var doClear = $(closestLi[0]).data("clearfield");
                    if (doClear) {
                        skipRename = true;
                    }
                }
                if (!skipRename) {
                    var name = $(this).attr("name");
                    name = "__origami_ignore__" + name;

                    $(this).attr("name", name);
                }
            });
        }
    });
}

function clearHiddenInputField(parentElement) {
    //For everything but Radio Buttons, do this
    $(":input", parentElement)
        .not(":button,:submit,:reset,:radio")
        .val("")
        .removeAttr("checked")      //Clear checked on checkbox elements
        .removeAttr("selected");
    $("input:radio:checked", parentElement).each(function () {
        clearRadio($(this), true);
    });
}

function clearRadio($option, isHiddenInput = false) {
    var groupName = $option.attr("name");
    var previouslyChecked = $option.attr("previouslyChecked") === "true";
    var li = $option.closest('li');
    var hiddenText = li.find('input[type="text"][name="' + groupName.substring(2) + '"]');

    if (li.length === 1) {
        var liClass = li.attr('class') || '';

        if (isHiddenInput || (liClass.split(' ').indexOf('required') === -1 && previouslyChecked)) {
            $option.prop("checked", false);
            if ($option.is(':visible')) {
                $option.trigger("change");
            }
            if (hiddenText.length === 1) {
                hiddenText[0].value = null;
                hiddenText.trigger("change");
            }
        }
        else if (hiddenText.length === 1) {
            hiddenText[0].value = $option[0].value;
            hiddenText.trigger("change");
        }
    }
    $option.parent().parent().children().children('input[type="radio"][name="' + groupName + '"]').each(function () {
        $(this).attr("previouslyChecked", String($(this).is(":checked")));
    });
}

function restoreHiddenPanels(formID) {

    $("div.panel.renamedNames :input[name]:not(:button,:submit,:reset)").each(function () {

        var name = $(this).attr("name");
        if (!name.startsWith("__origami_ignore__"))
            return;

        $(this).attr("name", name.substring(18));

    });

    $("div.panel.renamedNames").removeClass("renamedNames");
}

var _skipValidateGridPanels = false;

function resolveGridProperties(triggerPanelID, id, trigger, statusTarget) {
    var targetPanel = $('div.panel[data-panelkey="' + triggerPanelID + '"]');

    var propsData = {};
    propsData["childdomain"] = $(trigger).attr('data-domain');

    $.each($(trigger)[0].attributes, function (i, attrib) {
        if (!attrib.name.startsWith("data-gridprop-"))
            return;

        propsData[attrib.name.substring(14)] = attrib.value;
    });

    propsData["data-origamiurl"] = $(targetPanel).attr('data-origamiurl');

    var gridPropsUrl = appendTPAClientID(getServerAppRoot() + getControllerName() + "/ResolveGridProperties/" + id);
    $.ajax({
        type: 'POST',
        url: gridPropsUrl,
        dataType: 'json',
        data: AddAntiForgeryToken(propsData),
        async: true,
        success: function (result) {

            if (result.status == 'success') {
                $(trigger).closest('div.panel').remove();
                var newURL = $(targetPanel).attr('data-origamiurl');

                var resultOrigamiUrl = result.results.find(item => item.Key === 'data-origamiurl');
                //ORDEV-37132 - GridPanel SaveAndContinue=SaveInline causing error on incident when incident is new.
                //This code modifies the url to attach a parentDomainPrimaryKeyValue value.
                //In this particular instance, when creating a new Incident, we had an InvolvedParty gridpanel with SaveAndContinue=SaveInline.
                //InvolvedParties were being added as orphans without a reference to the IncidentID that was just created via btn to add new InvolvedParty.
                //This code fixes this issue.
                if (resultOrigamiUrl && newURL !== resultOrigamiUrl.Value) {
                   newURL = resultOrigamiUrl.Value;
                }

                for (var key in result.results) {
                    var resultItem = result.results[key];
                    if (newURL.toLowerCase().indexOf(resultItem.Key.toLowerCase() + "=") >= 0) {
                        newURL = insertParameterToUrl(removeParameterFromUrl(newURL, resultItem.Key), resultItem.Key, resultItem.Value);
                    }
                }

                $(targetPanel).attr('data-origamiurl', newURL);
                $(targetPanel).data('origamiurl', newURL);
                $(targetPanel).removeClass('hidden-saveAndContinue');
                ajaxLoadPanel($(targetPanel), true);
                markLoaderStopped(statusTarget);
            }
            else {
                markLoaderStopped(statusTarget);
                setSaveAndContinueInlineError(result.message, trigger, statusTarget, triggerPanelID);
            }
        },
        error: function (xhr: any, status, error) {
            try {
                var err = eval("(" + xhr.responseText + ")");
                console.log(err);
                markLoaderStopped(statusTarget);
                setSaveAndContinueInlineError("Unable to resolve grid properties", trigger, statusTarget, triggerPanelID);
            }
            catch {
                markLoaderStopped(statusTarget);
                setSaveAndContinueInlineError("Unable to resolve grid properties", trigger, statusTarget, triggerPanelID);
            }
        }
    });
}

function saveAndContinueInline(trigger, formid, validateRequired, applyValidations) {
    var triggerPanelID = $(trigger).attr('data-panelid');
    var statusTarget = $(trigger).closest('div.panel');

    if ($('form#' + formid)[0].hasAttribute('data-recordid')) {
        resolveGridProperties(triggerPanelID, $('form#' + formid).attr('data-recordid'), trigger, statusTarget);
        markLoaderRunning(statusTarget, "ld-ring", "ld-spin", "ld-over");
        return;
    }

    onClickSubmit();

    if (validateRequired) {
        if ($('input[name="_validateRequiredContinue"]').length == 0)
            $('form#' + formid).append('<input name="_validateRequiredContinue" class="hidden" value="' + validateRequired + '"/>');
        else
            $('input[name="_validateRequiredContinue"]').val(validateRequired);
    }

    if (applyValidations) {
        if ($('input[name="_applyValidationsContinue"]').length == 0)
            $('form#' + formid).append('<input name="_applyValidationsContinue" class="hidden" value="' + applyValidations + '"/>');
        else
            $('input[name="_applyValidationsContinue"]').val(applyValidations);
    }

    if ($('input[name="_ContinueToEditAfterSave"]').length == 0)
        $('form#' + formid).append('<input name="_ContinueToEditAfterSave" class="hidden" value="true"/>');
    else
        $('input[name="_ContinueToEditAfterSave"]').val('true');

    if (!beforeSaveAndContinueSubmit())
        return false;

    markLoaderRunning(statusTarget, "ld-ring", "ld-spin", "ld-over");

    var ajaxURL = $('form#' + formid).attr("action");
    ajaxURL = appendTPAClientID(ajaxURL);
    ajaxURL = insertParameterToUrl(ajaxURL, 'json', 'true');

    var ajaxSaveInlineSuccessFunction = function (data) {
        console.log(data);
        $('input[name="_ContinueToEditAfterSave"]').val('false');
        $('input[name="_validateRequiredContinue"]').remove();
        $('input[name="_applyValidationsContinue"]').remove();
        $(statusTarget).find("div.inlineSaveError").remove();
        afterSaveAndContinueSuccess(data);
        setFormID(formid, data.ID);
        setFormAutoGenerateValueFromInline(formid, data);
        resolveGridProperties(triggerPanelID, data.ID, trigger, statusTarget);
    }
    var ajaxSaveInlineFailureFunction = function (data) {
        markLoaderStopped(statusTarget);
        $('input[name="_ContinueToEditAfterSave"]').val('false');
        $('input[name="_validateRequiredContinue"]').remove();
        $('input[name="_applyValidationsContinue"]').remove();
        setSaveAndContinueInlineError(data.messageHtml, trigger, statusTarget, triggerPanelID);
        afterSaveAndContinueFailure(data);
    }

    _skipValidateGridPanels = true;
    clearStatusMessage();
    $('form#' + formid).find(":input.input-validation-error").removeClass('input-validation-error');
    submitFormByID(formid, ajaxURL, ajaxSaveInlineSuccessFunction, ajaxSaveInlineFailureFunction);
    if (!afterSaveAndContinueSubmit())
        return false;
}

function setSaveAndContinueInlineError(errorHtml, trigger, statusTarget, triggerPanelID) {
    statusErrorMessage(errorHtml, false, true);
    decorateValidationErrorLinks();
    if ($(statusTarget).find("div.inlineSaveError").length == 0)
        $(trigger).after("<div id='error-'" + triggerPanelID + "' class='inlineSaveError red'>An error occurred. See <span class='clickable' onclick='scrollToTop();' title='Scroll to top of page'><u>error message</u></b> at the top of this page for more details.</div>");
}

function scrollToTop() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
}

function markLoaderRunning(target, loaderIcon, loaderAnimation, loaderPos) {
    //ld-over and ld-ext-right

    $(target).addClass(loaderPos);

    if ($(target).children("div.ld").length == 0)
        $(target).prepend('<div class="ld ' + loaderIcon + ' ' + loaderAnimation + '"></div>');

    if ($(target).filter("body").length > 0 && loaderPos == "ld-over")
        $(target).children("div.ld").first().attr("style", "font-size:500%;");
    else if ($(target).filter("div.btn").length == 0 && $(target).filter("button").length == 0 && loaderPos == "ld-over")
        $(target).children("div.ld").first().attr("style", "font-size:200%;");
    else
        $(target).children("div.ld").first().attr("style", "font-size:110%;");

    $(target).addClass('running');
}

function markLoaderStopped(target) {
    $(target).removeClass('running');
}

function changeLoaderIcon(target, loaderIcon, loaderAnimation) {
    if ($(target).children("div.ld").length == 0)
        return;

    var ldDiv = $(target).children("div.ld").first();

    $(ldDiv).attr("class", "ld");

    if (typeof loaderIcon != 'undefined' && loaderIcon !== '')
        $(ldDiv).addClass(loaderIcon);

    if (typeof loaderAnimation != 'undefined' && loaderAnimation !== '')
        $(ldDiv).addClass(loaderAnimation);
}

function setFormAutoGenerateValueFromInline(formid, data) {
    if (data == null)
        return;

    if (typeof data.autoGenerateVals == 'undefined' || data.autoGenerateVals == null)
        return;

    var formTag = $('form#' + formid);

    for (var key in data.autoGenerateVals) {
        $(formTag).find("input.AutoNumberField[name='" + key + "']").each(function (k, t) {
            if ($(t).val() == "")
                $(t).val(data.autoGenerateVals[key]).attr("disabled", "disabled");
        });
    }
}

function setFormID(formid, id: number) {
    if (id <= 0)
        return;

    var formTag = $('form#' + formid);
    if ($(formTag).length > 0) {
        var formAction = $(formTag).attr('action');
        $(formTag).attr('data-recordid', id);
        if (formAction.toLowerCase().endsWith('/save') || formAction.toLowerCase().indexOf('/save?') >= 0) {
            var newFormAction = '/Origami/' + getControllerName() + '/Save/' + id;
            if (formAction.indexOf('?') > -1)
                newFormAction += '?' + formAction.split('?')[1];

            $(formTag).attr('action', newFormAction);
            console.log('New Form Action Set to ' + newFormAction);
        }
    }
}

function submitSaveAndContinue(formid, autoAddDomain, validateRequired, applyValidations)
{
    onClickSubmit();

    if ($('input[name="_ContinueToEditAfterSave"]').length == 0)
        $('form#' + formid).append('<input name="_ContinueToEditAfterSave" class="hidden" value="true"/>');
    else
        $('input[name="_ContinueToEditAfterSave"]').val('true');

    if (autoAddDomain) {
        if ($('input[name="_AddDomainAfterSave"]').length == 0)
            $('form#' + formid).append('<input name="_AddDomainAfterSave" class="hidden" value="' + autoAddDomain + '"/>');
        else
            $('input[name="_AddDomainAfterSave"]').val(autoAddDomain);
    }
    if (validateRequired) {
        if ($('input[name="_validateRequiredContinue"]').length == 0)
            $('form#' + formid).append('<input name="_validateRequiredContinue" class="hidden" value="' + validateRequired + '"/>');
        else
            $('input[name="_validateRequiredContinue"]').val(validateRequired);
    }

    if (applyValidations) {
        if ($('input[name="_applyValidationsContinue"]').length == 0)
            $('form#' + formid).append('<input name="_applyValidationsContinue" class="hidden" value="' + applyValidations + '"/>');
        else
            $('input[name="_applyValidationsContinue"]').val(applyValidations);
    }

    if (!beforeSaveAndContinueSubmit())
        return false;

    _skipValidateGridPanels = true;
    submitFormByID(formid);
    if (!afterSaveAndContinueSubmit())
        return false;
}

function autoAddDomainAfterLoad(domain) {
    console.log("doing auto add for Domain: " + domain);

    var clicked = false;
    $("div.ajaxGridPanel").each(function () {
        clicked = $(this).attr('data-clicked') === 'true';
        if (clicked)
            return;

        var panelDomain = $(this).data("domain");
        if (panelDomain === domain) {

            // see if the ajax grid has any data.. if it does, then this is likely a repeat
            if ($("table.dataGrid tbody tr", $(this)).length) {
                clicked = true;
                console.log("data already exists in data grid.  exiting auto-add.");
                return;
            }

            // find a new link
            var newLink = $("a.panelaction_new", $(this));
            if (newLink.length) {
                clicked = true;
                $(this).attr('data-clicked', 'true');
                newLink.trigger("click");
                return;
            }
        }

    });

    $("div[id^='gridpanel_']").each(function () {
        clicked = $(this).attr('data-clicked') === 'true';
        if (clicked)
            return;

        var panelDomain = $(this).parent().data("refreshDomain");
        if (panelDomain === domain) {

            // see if the ajax grid has any data.. if it does, then this is likely a repeat
            if ($("table.dataGrid tbody tr", $(this)).length) {
                clicked = true;
                console.log("data already exists in data grid.  exiting auto-add.");
                return;
            }

            // find a new link
            var newLink = $("a.panelaction_new", $(this));
            if (newLink.length) {
                $(this).attr('data-clicked', 'true');
                clicked = true;
                newLink.trigger("click");
                return;
            }
        }

    });

    if (!clicked)
        console.log("Could not find new link for domain: " + domain);
}

function autoSaveAfterLoad() {
    console.log("Performing auto save after load");

    // If the page is loaded via back, forward, or reload, don't attempt to auto save.
    if (!isNavigationTypeNavigate()) {
        console.log("Preventing auto save due to navigation method.");
        return;
    }

    // Check for potential error status and prevent auto save if found.  This prevents a failure during save to continually loop auto saving.
    var statusMessage = $("#message");
    var isErrorStatus = statusMessage.hasClass("error") && !statusMessage.hasClass("hidden");
    if (isErrorStatus) {
        console.log("Preventing auto save due to error status.");
        return;
    }

    // Check for page being fully initialized, if not, wait for a bit and try again
    if (!pageFullyInitialized) {
        setTimeout(function () {
            autoSaveAfterLoad();
        }, 200);
    } else {
        //
        // On save submit populateFormRequiredFieldsList is called, which identifies fields that are required on the form
        // If a field is hidden it doesn't consider it required, however, fields that are hidden via toggle formula can be in the middle of an animation
        // and not yet fully hidden if the save submit is triggered before they've had a chance to finish
        // Therefore, waiting for a bit for any UI animations to complete
        setTimeout(function () {
            autoSaveAfterFullyInitialized();
        }, 200);
    }
}

function autoSaveAfterFullyInitialized() {
    if (!pageFullyInitialized) {
        console.log("Attempted to perform autoSave before the page was fully initialized.");
        return;
    }

    console.log("Performing auto save");

    // First, try to find the save and close action
    var saveAction = $("button#useraction_saveandclose");
    if (saveAction.length !== 1) {
        // If save and close is not found, try to find the save action
        saveAction = $("button#useraction_save");
    }

    if (saveAction.length === 1) {
        // display overlay so it's clear to the user that the system is attempting to save
        $(".auto-save-overlay").show();

        saveAction.trigger("click");
        console.log("Auto save triggered.");
    } else {
        console.log("Could not auto save:  Failed to find save and close or save action.");
    }
}

function AddSaveAndContinueButton(buttonText, formid)
{
    if(typeof formid === 'undefined' || formid === null)
        formid = "entryForm";

    if (typeof buttonText === 'undefined' || buttonText === null)
        buttonText = "Save Changes And Continue Editing";

    $('button#useraction_save').closest('li').before('<li><button class="btn btn-inverse nowarn" id="useraction_saveAndContinue" onclick="submitSaveAndContinue(&quot;' + formid + '&quot;, null, false);">' + buttonText + '</button></li>');

}

var beforeSubmitFormActionHandlers = [];
var beforeSubmitFormAction = null;
var onFormSubmit = null;
function isInterviewGoingBack() {
    var val = $("input[name=_OrigamiInterviewAction]").val();
    if (val === "prev")
        return true;
    else
        return false;
}

function addBeforeSubmitFormHandler(fn) {
    beforeSubmitFormActionHandlers.push(fn);
}

function validateBeforeSubmitFormActions() {

    //don't bother with validating panels if in interview, and step is going backwards
    if (isInterviewGoingBack())
        return true;

    if (Array.isArray(beforeSubmitFormActionHandlers) && beforeSubmitFormActionHandlers.length > 0) {
        for (var i = 0; i < beforeSubmitFormActionHandlers.length; i++) {
            if (typeof beforeSubmitFormActionHandlers[i] === 'function') {
                if (!beforeSubmitFormActionHandlers[i].call())
                    return false;
            }
        }
    }

    return true;
}

var _expandTopLevelPanels = false;


function prepareFormForSubmission(formID) {
    var submitForm = true;

    if (!validateBeforeSubmitFormActions()) {
        submitForm = false;
        return submitForm;
    }

    if (!validateDynamicMinMaxFields()) {
        submitForm = false;
        return submitForm;
    }

    if (!validateDynamicRequiredFields()) {
        submitForm = false;
        return submitForm;
    }

    if (!validateGridPanels()) {
        submitForm = false;
        return submitForm;
    }

    if (_expandTopLevelPanels)
        expandTopLevelCollapsedPanels(formID);

    clearHiddenPanels(formID);

    if (!goBackwards) {
        populateFormRequiredFieldsList(formID);
        populateRequiredFormulaMessage(formID);
    }

    goBackwards = false;

    // remove all "disabled" so elements submit on post (but do it in a way that allows these elements to be re-disabled later)
    //ORDEV-38132 ignore sensitive fields that are masked
    const disabledInputs = $("li.disabled :input").filter(function () {
        // if not sensitive, it's normal, include it
        return !$(this).hasClass('sensitiveField')
            // if it has this class, we want to save the value, so include it
            || $(this).hasClass('sensitiveFieldChanged')
            // if it has an unmasked button sibling, we want to save the value, so include it
            || $(this).siblings('button.sensitiveFieldButton.unmasked').length > 0;
    });
    disabledInputs.addClass("redisableLater");
    disabledInputs.removeAttr("disabled");

    //any disabled child code dependencies should post
    $(":input.codeDepDisabled").removeAttr("disabled");

    return submitForm;
}

function submitFormByID(formID: string, ajaxURL?: string, ajaxSuccessFunction?: any, ajaxFailureFunction?: any, includeQueryString: boolean = false) {
    var submitFunction = function () {
        if (ajaxURL === undefined) {
            // append tpaclientid to the url
            var selector = "#" + formID;
            var form = $(selector);

            var url = form.attr("action");
            url = appendTPAClientID(url);

            if (includeQueryString) {
                // Get current query string values
                var queryString = window.location.search;
                if (queryString) {
                    // Append query string to the form action URL
                    if (url.indexOf('?') === -1) {
                        url += queryString;
                    } else {
                        url += '&' + queryString.substring(1);
                    }
                }
            }

            form.attr("action", url);

            $('#ajax_processing').addClass("submit").show();
            form.trigger("submit");
        }
        else {
            if (ajaxSuccessFunction === undefined) {
                return "If you define an ajax URL, you must also define a function to run when the ajax call succeeds.";
            }

            if (ajaxFailureFunction === undefined) {
                return "If you define an ajax URL, you must also define a function to run when the ajax call fails.";
            }

            $.ajax({
                type: 'POST',
                url: ajaxURL,
                dataType: 'json',
                data: $("#" + formID).serialize(),
                async: true,
                success: function (data) {
                    if (data.status === 'success') {
                        ajaxSuccessFunction(data);
                    }
                    else {
                        ajaxFailureFunction(data);
                    }
                }
            });
        }

        // Redisable the inputs that were enabled for submission
        $(".redisableLater").prop("disabled", true);
        $(".redisableLater").attr("disabled", "disabled");
    }

    if (typeof onFormSubmit === "function") {
        onFormSubmit(submitFunction);
    }

    submitFormAction(function () {
        if (prepareFormForSubmission(formID)) {
            if (beforeSubmitFormAction != null) {
                if (!beforeSubmitFormAction(submitFunction))
                    return;
            }

            submitFunction();
        }
    });
}

function submitFormAction(formAction) {
    if (isExpirationCookieValid()) {
        formAction();
    }
    else {
        // first validate that the cookie is still valid
        var checkUrl = getServerAppRoot() + "Account/CheckCookie";
        $.getJSON(checkUrl, function (data) {

            if (data.status == "success") {

                if (data.authenticated == "authenticated") {
                    formAction();

                }
                else if (data.authenticated == "sso") {

                    // open a new browser window instead of a thickbox to use
                    var relayUrl = getServerAppRoot() + "Account/TimeoutMessage?clientID=" + getCurrentClientID();
                    window.open(relayUrl, "Origami.TimeoutReturnPage", "toolbar=no, status=no, location=no");

                }
                else if (data.authenticated == "expired" && data.issilentlogin == "true") {
                    var relayUrl = getServerAppRoot() + "Account/Inactive";
                    setWindowLocationOnce(relayUrl, false);
                }
                else {

                    // open a new window to a login page
                    var timeoutUrl = getServerAppRoot() + "Account/TimeoutLogin?account=" +
                        encodeURIComponent(getCurrentAccountLogin()) + "&clientID=" + getCurrentClientID();

                    openThickboxPopup(timeoutUrl, "timeoutLogin");

                }

            } else {

                statusErrorMessage("Failed to validate session cookie.");
                formAction();
            }
        });
    }
}

function validateDynamicMinMaxFields() {
	var dynamicFields = '';
	$("input[data-origami-minvalueformula]").each(function () {
		var test = $(this).val();
		if (test == null) return;
		if (test.trim().length == 0) return;

        var testNum = GetRawInvariantNumber(test);
        var min = parseFloat($(this).data("origami-minvalue"));
        if (isNaN(min) || min <= testNum) return;

        var message = $(this).data("origami-required-formula-message");

		if (message != null) {
			dynamicFields += '<div>' + message.escapeHTML() + '</div>';
			return;
		}
		//get the "text" from only the immediate label node in the dom and ignore the other text.
		message = $("label", $(this).closest("li")).clone().children().remove().end().text();
		if (message != null)
			message = message.replace('*', '');

		if (message == null || message.trim().length == 0)
			message = 'Value below minimum (' + $(this).attr('name') + ')';
		else
			message = message + ': Value below minimum.';

		dynamicFields += '<div>' + message.escapeHTML() + '</div>';
    });

    $("input[data-origami-maxvalueformula]").each(function () {
        var test = $(this).val();
        if (test == null) return;
        if (test.trim().length == 0) return;

        var testNum = GetRawInvariantNumber(test);
        var max = parseFloat($(this).data("origami-maxvalue"));
        if (isNaN(max) || max >= testNum) return;

        var message = $(this).data("origami-required-formula-message");

        if (message != null) {
            dynamicFields += '<div>' + message.escapeHTML() + '</div>';
            return;
        }
        //get the "text" from only the immediate label node in the dom and ignore the other text.
        message = $("label", $(this).closest("li")).clone().children().remove().end().text();
        if (message != null)
            message = message.replace('*', '');

        if (message == null || message.trim().length == 0)
            message = 'Value above maximum (' + $(this).attr('name') + ')';
        else
            message = message + ': Value above maximum.';

        dynamicFields += '<div>' + message.escapeHTML() + '</div>';
    });

	if (dynamicFields === '')
		return true;

	statusMessageHtml('error', 'Please correct the following:' + dynamicFields);
	return false;
}

function validateDynamicRequiredFields() {
    var dynamicFields = '';
    $(":data('origami-dynamic-required')").each(function () {
        $(this).removeClass("input-validation-error");

        var required = $(this).data("origami-dynamic-required");
        if (required != "true")
            return;

        var test = $(this).val();
        if (test != null && test.trim().length > 0)
            return;

        $(this).addClass("input-validation-error");
        var message = $(this).data("origami-required-formula-message");

        if (message != null) {
            dynamicFields += '<div>' + message.escapeHTML() + '</div>';
            return;
        }
        //get the "text" from only the immediate label node in the dom and ignore the other text.
        message = $("label", $(this).closest("li")).clone().children().remove().end().text();
        if (message != null)
            message = message.replace('*', '');

        if (message == null || message.trim().length == 0)
            message = 'Required field missing (' + $(this).attr('name') + ')';
        else
            message = message + ': A value is required.';

        dynamicFields += '<div>' + message.escapeHTML() + '</div>';
    });

    if (dynamicFields === '')
        return true;

    statusMessageHtml('error', 'Please correct the following:' + dynamicFields);
    return false;
}

function validateGridPanels() {
    if (_skipValidateGridPanels) {
        _skipValidateGridPanels = false;
        return true;
    }

    $(":data('origami-dynamic-required')").each(function () {
    });

    var isValid = true;
    $(".panel-validation:visible").each(function () {

        var validationFormula = $(this).data('validationformula');
        if (validationFormula) {
            var items = createItemsArrayFromGridPanelTable($(this));
            var validationResult = eval(validationFormula);
            if (!validationResult) {
                var validationMessage = $(this).data('validationmessage');
                statusMessageHtml('error', validationMessage);
                isValid = false;
            }
        }
    });

    return isValid;
}

function createItemsArrayFromGridPanelTable(gridPanel) {
    var items = [];

    try {
        var table = $("table.dataGrid", gridPanel);
        var columns = [];
        $("thead tr th", table).each(function () {
            var fieldName = $(this).data("fieldname");
            columns.push(fieldName || "");
        });

        $("tbody tr:not([class*='editablegrid'])", table).each(function (rowIndex, row) {
            var item = {};
            $("td", row).each(function (cellIndex, cell) {
                var fieldValue = $(this).data("fieldvalue");
                var column = columns[cellIndex];
                item[column] = fieldValue;
            });
            items.push(item);
        });

        return items;
    }
    catch (error) {
        return items;
    }
}

function populateRequiredFormulaMessage(formID) {

    var placeholder = $("#" + formID + " input[name=_OrigamiFormRequiredFormulaMessages]");
    if (placeholder.length == 0)
        return;

    if (placeholder.length > 1)
        placeholder.not(placeholder.first()).remove();

    var requiredMessageList = [];
    $("#" + formID + " li.required:visible input, #" + formID + " li.required:visible select, #" + formID + " li.required:visible textarea").each(function () {

        var formulaMessage = $(this).data('origami-required-formula-message');
        if (typeof formulaMessage == 'undefined' || formulaMessage == '')
            return true;

        var name: any = $(this).attr('name');
        if (typeof name !== 'undefined' && name !== false) {
            if (name.startsWith("__multiselect_")) {
                var checkName = name.substring(14);
                if ($.inArray(checkName, requiredMessageList) == -1)
                    requiredMessageList.push({ FieldName: checkName, Message: formulaMessage });
            }
            else {
                var isHidden = document.getElementById(name) && (document.getElementById(name).style.display == "none" || document.getElementById(name).style.visibility == "hidden");
                if ($(this).is("input.lookupID") || !isHidden)
                    requiredMessageList.push({ FieldName: name, Message: formulaMessage });
            }
        }
    });

    if (requiredMessageList.length == 0)
        placeholder.val("");
    else
        placeholder.val(window.JSON.stringify(requiredMessageList));
}

function populateFormRequiredFieldsList(formID) {

    if ($("input[name='BypassRequiredFieldsDuringSubmission']").length > 0 && $("input[name='BypassRequiredFieldsDuringSubmission']").val() == "True")
        return;

    var placeholder = $("#_OrigamiFormRequiredFields");
    if (placeholder.length == 0)
        return;

    //JIRA 8240 - Expand any collapsed panels w/required fields so required fields are added to requiredList
    expandCollapsedPanelsWithRequiredFields(formID);

    var requiredList = [];
    var required = $("#" + formID +
        " li.required:visible input, #" + formID +
        " li.required:visible select, #" + formID +
        " li.required:visible textarea, #" + formID +
        " li.required:visible div.fr-box div.fr-wrapper div.fr-element.fr-view").each(function () {
            var name: any = $(this).attr('name');

            //JIRA 8240 - Textarea elements rendered using the new RTF control are hidden and overlayed.
            //            If a field renders as a textarea and makes use of the new RTF control, get name of underlying text area element
            var visibleRTF = false;
            if ($(this).is('div.fr-box div.fr-wrapper div.fr-element.fr-view:visible')) {
                name = $(this).closest('li.required').find('textarea').attr('name'); //Get name from underlying textarea element
                visibleRTF = true;
            }

            if (typeof name !== 'undefined' && name !== false) {
                if (name.startsWith("__multiselect_")) {
                    var checkName = name.substring(14);
                    if ($.inArray(checkName, requiredList) == -1)
                        requiredList.push(checkName);
                }
                else {
                    var isHidden = document.getElementById(name) && (document.getElementById(name).style.display == "none" || document.getElementById(name).style.visibility == "hidden");

                    //JIRA 8240 - Override hidden when underlying element is hidden but visibleRTF is not
                    if (isHidden && visibleRTF)
                        isHidden = false;

                    if ($(this).is("input.lookupID") || !isHidden)
                        requiredList.push(name);
                }
            }
        });

    if (requiredList.length == 0)
        placeholder.val("");
    else
        placeholder.val(requiredList.join());
}

function changeMasterForMultiCodeDependency(input, master, dependency) {
    var dependencyValue = $(master).val();

    //ORDEV-11173
    if ((master.length > 1) && ('radio' === $(master[0]).attr('type')))
        dependencyValue = master.filter(':checked').val();

    var filters = $(input).data("filters");
    var dependencyparam = dependency;
    if (filters != null && filters.indexOf('_codedependencytypeid') > -1)
        dependencyparam = '_codedependencymasterid';

    if (isMasterMultiSelect(input)) {
        var masterInputName = getMasterInputName(input, dependency);
        if (masterInputName) {
            var multiSelectValues = [];
            $.each($("input[name='" + masterInputName + "']:checked,select[name='" + masterInputName + "']"), function () {
                var itemValue = $(this).val();
                if (Array.isArray(itemValue)) {
                    Array.prototype.push.apply(multiSelectValues, itemValue);
                } else {
                    multiSelectValues.push(itemValue);
                }
            });

            dependencyValue = multiSelectValues.join(",");
        }
    }

    var rowPrefix = $(input).closest("tr").data("prefix");
    if (rowPrefix) {
        dependencyparam = dependencyparam.replace(rowPrefix + ".", "");
    }

    filters = insertParameter(filters, dependencyparam, dependencyValue);
    $(input).data("filters", filters);

    var url = $(input).data("lookupurl") + '?filters=' + encodeURIComponent(filters);
    //console.log(url);

    $.getJSON(url, function (data) {

        //console.log('Number of applicable codes: ' + data.length);

        $("li", input).each(function () {
            var check = $(":checkbox", this);
            var id = check.attr("value");
            var found = false;
            for (var i in data) {
                var row = data[i];
                if (row.ID == id)
                    found = true;
            }

            if (!found) {
                check.prop("checked", false).trigger("change");
                $(this).hide();
            } else {
                $(this).show();
            }
        });


        var isMultiSelect = false;
        var name: any = $(input).attr('name');
        if (typeof name !== 'undefined' && name !== false) {
            if (name.startsWith("__multiselect_")) {
                isMultiSelect = true;
            }
        }

        $("option", input).each(function () {
            var option = $(this);
            var id = option.attr("value");
            var selectElement = option.closest('select');

            if (isMultiSelect && selectElement.val() !== null && selectElement.val() !== '') {
                var currentValues = selectElement.val() || [];

                var newValues = data.map(row => row.ID);
                var combinedValues = Array.from(new Set([...currentValues, ...newValues]));

                // Skip processing if all values are already selected
                if (combinedValues.length === currentValues.length) {
                    return;
                }
            }

            var found = false;
            for (var i in data) {
                var row = data[i];
                if (row.ID == id) {
                    found = true;
                }       
            }

            if (!found) {
				if(isMultiSelect){
					option.prop({disabled: true});
				}
				else{
					option.prop({disabled: true}).trigger("change");
				}
                $(this).remove();
            } else {
                $(this).show();
            }
        });

        //label contains:
        //   [ ] Child Check Box A
        //   [ ] Child Check Box B
        //   [ ] ... 
        $("label", input).each(function () {

            var check = $(":checkbox", this);
            var id = check.attr("value");
            var found = false;
            for (var i in data) {
                var row = data[i];
                if (row.ID === id) {
                    found = true;
                }
            }

            var br = $(this).next();
            if (!found) {
                check.prop("checked", false).trigger("change");
                $(this).prop({ disabled: true });
                if (br !== null && br !== undefined && br.length > 0 && br.is('BR')) {
                    br.hide(); //each label is followed by the BR. Eliminate that extra spacing when removing an individual UI checkbox.
                }
                $(this).hide();
            } else {
                $(this).show();
                if (br !== null && br !== undefined && br.length > 0 && br.is('BR')) {
                    br.show(); //each label is followed by the BR. Eliminate that extra spacing when removing an individual UI checkbox.
                }
            }
        }); //end for each "label" which is the parent of an individual checkbox

        window.setTimeout(function () {
            $('.chosen-select').trigger('chosen:updated');
        }, 750);
    });
}

function isMasterMultiSelect(input) {

    var isMasterMultiSelectStr = $(input).data("masterismultiselect");
    return (isMasterMultiSelectStr && isMasterMultiSelectStr.toLowerCase()) === "true";
}

function getMasterInputName(input, dependency) {
    if (!dependency) {
        dependency = $(input).data("dependency");
        if (!dependency)
            return "";
    }

    if (isMasterMultiSelect(input)) {
        dependency = "__multiselect_" + dependency;
    }

    return dependency;
}

function setupCodeDependencies(subset) {
    //JIRA 6397
    if (typeof(removeFieldsFromDefinitionAlreadyInView) === 'function') {
        removeFieldsFromDefinitionAlreadyInView();
    }

    $("input.inputLookup", subset).each(function () {
        var dependency = $(this).data("dependency");
        if (dependency != undefined)
            setupCodeDependency(this, dependency, false, $(this).data("childfkfield"));
    });

    $("select", subset).each(function () {
        var dependency = $(this).data("dependency");
        if (dependency != undefined)
            setupCodeDependency(this, dependency, true, $(this).data("childfkfield"));
    });

    $("div.dependentrbl", subset).each(function () {
        var dependency = $(this).data("dependency");
        if (dependency != undefined)
            setupCodeDependency(this, dependency, false, $(this).data("childfkfield"));
    });

    $("ul.multiselectcheckboxlist", subset).each(function () {
        var dependency = $(this).data("dependency");
        if (dependency == undefined)
            return;

        var masterInputName = getMasterInputName(this, dependency);
        var master = $("input[name='" + masterInputName + "'],select[name='" + masterInputName + "']");
        if (master.length == 0)
            return;

        setupMultiCodeDependency(this, master, dependency);
        changeMasterForMultiCodeDependency(this, master, dependency);
    });

    $("div.multiselectcheckboxlist", subset).each(function () {
        //the default vertical multi select control rendered as checkboxes (Plain HTML).
        var dependency = $(this).data("dependency");
        if (dependency == undefined)
            return;

        var masterInputName = getMasterInputName(this, dependency);
        var master = $("input[name='" + masterInputName + "'],select[name='" + masterInputName + "']");
        if (master.length === 0)
            return;

        setupMultiCodeDependency(this, master, dependency);
        changeMasterForMultiCodeDependency(this, master, dependency);
    });


    $("select.chosen-select", subset).each(function () {
        var dependency = $(this).data("dependency");
        if (dependency == undefined)
            return;

        var masterInputName = getMasterInputName(this, dependency);
        var master = $("input[name='" + masterInputName + "'],select[name='" + masterInputName + "']");
        if (master.length == 0)
            return;

        setupMultiCodeDependency(this, master, dependency);
        changeMasterForMultiCodeDependency(this, master, dependency);
    });
}

function setupMultiCodeDependency(input,master,dependency)
{
    var filters = $(input).data("filters");
    var customcodedependency = (filters != null && filters.indexOf('_codedependencytypeid') > -1);

    master.on("change", function () {
        changeMasterForMultiCodeDependency(input, this, dependency);
    });
}

//JIRA 6067
var sysMasterDepFieldIDs = ['BodyPartID', 'CauseID', 'NatureID', 'AccidentTypeID', 'PolicyID', 'CarrierID', 'PolicyCoverageID', 'AgentID', 'SecondAgentID',
    'BrokerAccessGroupID', 'SecondBrokerAccessGroupID', 'BrokerOfficeID', 'JobClassificationID', 'LocationID'];

function disableEnableDependent(dep, disable) {
	if($(dep).hasClass('locked'))
	{
		return;
	}
    dep.disabled = disable;
    if(disable) {
        $(dep).addClass('codeDepDisabled');
        $(dep).attr("disabled", "disabled");
    } else {
        $(dep).removeClass('codeDepDisabled');
        $(dep).removeAttr("disabled");
    }

    var lookupImage = $(dep).next().next();
    if (lookupImage.hasClass('lookupImage')) {
        if (disable)
            lookupImage.hide();
        else
            lookupImage.show();
    }
}
//End

function setupCodeDependency(input, dependency, dropdown, fkfield) {
    if (typeof(skipCodeDependencySetup) === 'function' && skipCodeDependencySetup(input))
        return;

    var formPrefix = $(input).closest("div.origamiform").data("inputnameprefix");
    var rowPrefix = $(input).closest("tr").data("prefix");

    var depName = dependency;

    if(typeof formPrefix == 'undefined')
        formPrefix = '';

    if (formPrefix !== null && formPrefix.trim().length > 0 && !dependency.startsWith(formPrefix + '.'))
        depName = formPrefix + '.' + dependency;

    var masterInputName = getMasterInputName(input, depName);
    var master = $("input[name='" + masterInputName + "'],select[name='" + masterInputName + "']");
    var isMasterBodyPartDiagram = false;

    if (master.length == 0) {
        if (dependency === 'BodyPartID') {
            master = $("#BodyPartsSerialized");

            if (master.length == 0) {
                return;
            }

            isMasterBodyPartDiagram = true;
        }
        else {
            return;
        }
    }

    var filters = $(input).data("filters");
    var onewaydependency = (filters != null && filters.indexOf('_codedependencytypeid') > -1) ||
        ($(input).next() && $(input).next().attr("name") &&
            ((sysMasterDepFieldIDs.indexOf($(input).next().attr("name")) >= 0) || (sysMasterDepFieldIDs.indexOf($(input).next().attr("name").replace(formPrefix + ".", "")) >= 0) || //JIRA 6067
                (sysMasterDepFieldIDs.indexOf($(input).next().attr("name").replace(rowPrefix + ".", "")) >= 0)));

    var mv = master.val();
    if ((master.length > 1) && ('radio' === $(master[0]).attr('type')))
        mv = master.filter(':checked').val();

    var showAllWhenParentNull = $(input).data("parentnullshowsall") === 'True';
    var allowChildDependencyFirst = $(input).data("allowchildfirst") === 'True';
    //JIRA 6067
    disableEnableDependent(input, (mv === '') && !showAllWhenParentNull && !allowChildDependencyFirst);

    master.on("change", function () {

        var dependencyValue = $(this).val();
        if (('radio' === $(this).attr('type')) && !($(this).is(':checked')))
            dependencyValue = '';

        var filters = $(input).data("filters");
        var dependencyparam = fkfield || dependency;
        if (filters != null && (filters.indexOf('_codedependencytypeid') > -1) || showAllWhenParentNull)

            dependencyparam = '_codedependencymasterid';

        if (isMasterMultiSelect(input)) {
            var masterInputName = getMasterInputName(input, depName);
            if (masterInputName) {
                var multiSelectValues = [];
                $.each($("input[name='" + masterInputName + "']:checked,select[name='" + masterInputName + "']"), function () {
                    var itemValue = $(this).val();
                    if (Array.isArray(itemValue)) {
                        Array.prototype.push.apply(multiSelectValues, itemValue);
                    } else {
                        multiSelectValues.push(itemValue);
                    }
                });

                dependencyValue = multiSelectValues.join(",");
            }
        }
        if (isMasterBodyPartDiagram) {
            if (dependencyValue && dependencyValue.trim().length > 0) {
                try {
                    const data = JSON.parse(dependencyValue);
                    dependencyValue = data.map(item => item.BodyPartID).join(",");
                } catch (e) {
                    // If the value is not valid JSON, set it to null
                    dependencyValue = null;
                }
            }
        }
        if (formPrefix) {
            dependencyparam = dependencyparam.replace(formPrefix + ".", "");
        }
        if (rowPrefix) {
            dependencyparam = dependencyparam.replace(rowPrefix + ".", "");
        }

        filters = insertParameter(filters, dependencyparam, dependencyValue);
        $(input).data("filters", filters);

        //JIRA 6067
        disableEnableDependent(input, dependencyValue === '' && !showAllWhenParentNull && !allowChildDependencyFirst);

        if (!dropdown) {
            if ($(input).hasClass('dependentrbl')) {
                var propName = $(input).data('propname');
                var idName = $(input).data('idname');

                //ORDEV-11172 - Preserve currently selected child radio button and restore after rebuild (if currently selected still available)
                var csrb = $(input).find('input[type="radio"]:checked');
                var csv = (csrb.length === 1) ? csrb.val() : null;

                $(input).empty();
                $(input).append('<input id="rb' + idName + 'None" name="' + propName + '" type="radio" value="" style="display:none" />');

                if (dependencyValue.length > 0) {
                    var url = $(input).data("lookupurl") + '?filters=' + encodeURIComponent(filters);
                    $.getJSON(url, function (data) {
                        for (var i = 0, k = data.length; i < k; i++) {
                            var row = data[i];
                            $(input).append('<label style=\"clear:none;width:auto\"><input type="radio" id="rb' + idName + i + '" name="' + propName + '" value="' + row.ID +
                                '" onclick="clearRadio($(this))" onkeydown="radioKeyDown($(this), event)" /><span style=\"margin-left:5px;margin-right:10px\">' + row.Description + '</span></label>');

                            var curRadio = $(input).find('input:last');

                            //ORDEV-11172 - Restore previous selection if radio button still available
                            if ((csv !== null) && (csv === row.ID))
                                curRadio.attr('checked', 'checked');

                            //ORDEV-11172 - Wire up control if toggle trigger
                            if ($('[data-togglefield="' + propName + '"]').length > 0) {
                                curRadio.on("change", function() {
                                    toggleFieldChanged(propName, false);
                                });
                            }

                            //ORDEV-11172 - Wire up control if referenced by a formula
                            if ($('[data-toggleformula*="{' + propName + '}"]').length > 0) {
                                curRadio.addClass('formulaField').on('blur change', function() {
                                    evaluateFormExpressions($(this).closest("div.origamiform"));
                                });
                            }
                        }
                    });
                } else {
                    $(input).find('input[id="rb' + idName + 'None"]').attr('checked', 'checked');
                }
            } else {
                if (pageFullyInitialized) {
                    // clear the sub field if the parent field changes
                    $(input).val("");
                    $(input).next().val("");
                }

                // possible multi-select
                $("div[data-name='" + input.id.replace("_Adder", "") + "']").html("");

                var hrefUrl = $(input).next().next().attr("href");

                //support lookup formula for JobClassification on editigrids                
                var tableRow = $(input).closest('tr');
                if ($(tableRow).length && $(input).attr("alt") === "JobClassification" && ($(tableRow).hasClass('editablegridnewrow') || $(tableRow).hasClass('editing')) ) {
                    var lookupFormula = $(input).attr("data-lookupformula");
                    if (lookupFormula != null && lookupFormula.trim().length > 0 && lookupFormula.includes("LookupStateID") ) {
                        var pkid = $(input).closest("tr").data("pkid");
                        var fields = origami.getFieldsFromFormula(lookupFormula);
                        for (var i = 0; i < fields.length; i++) {
                            dependencyparam = dependencyparam.replace("clonen", "").replace("cloneh", "").replace(rowPrefix + ".", "");
                            var currentField = fields[i].replace("clonen", "").replace("cloneh", "").replace(rowPrefix + ".", "");
                            if (currentField == dependencyparam) {
                                hrefUrl = insertParameterToUrl(hrefUrl, "LookupStateID", dependencyValue);
                            }
                        }
                    }
                }
                else {
                    hrefUrl = insertParameterToUrl(hrefUrl, dependencyparam, dependencyValue);
                }

                if (dependencyparam == "_codedependencymasterid" && dependencyValue != '') {
                    if (hrefUrl.indexOf('_codedependencytypeid') <= -1 && typeof ($(input).data('dependencytypeid')) != 'undefined') {
                        var dependencyTypeID = $(input).data("dependencytypeid");
                        if (dependencyTypeID != null && dependencyTypeID != '')
                            hrefUrl = insertParameterToUrl(hrefUrl, '_codedependencytypeid', dependencyTypeID);
                    }
                }
                else if (showAllWhenParentNull) {
                    hrefUrl = removeParameterFromUrl(hrefUrl, dependencyparam);
                    hrefUrl = removeParameterFromUrl(hrefUrl, '_codedependencytypeid');
                }

                $(input).next().next().attr("href", hrefUrl);

                // reinitialize the input lookup
                var isFormulaField = $(input).is('.formulaField');
                $(input).unautocomplete();
                if (typeof formulaFieldChangeFunction === 'function' && isFormulaField) {
                    $('.formulaField').on('blur change', formulaFieldChangeFunction);
                }
                initializeInputLookup(input);
            }
        }
        else {
            var toSet = getAutoFillValueForDropDown(input, formPrefix);

            var valueBeforeLookup = $(input).val();
            $(input).val("");

            var url = $(input).data("lookupurl") + '?filters=' + encodeURIComponent(filters);

            if (showAllWhenParentNull && dependencyValue === '') {
                var urlFilter = removeParameter(filters, "_codedependencytypeid");
                urlFilter = removeParameter(urlFilter, "_codedependencymasterid");
                if (urlFilter.trim() != "")
                    url = $(input).data("lookupurl") + '?filters=' + encodeURIComponent(urlFilter); // used for /Origami/Lookups/Code lookups, which need a CodeTypeID even to get the unfiltered list of values
                else
                    url = $(input).data("lookupurl"); // used for /Origami/Lookups/Coverage and similar, which don't need a CodeTypeID to get the unfiltered list
            }

            $.getJSON(url, function (data) {
                var isMultiSelect = $(input).hasClass("chosen-select");

                var select: any = $(input).get(0);
                select.length = 0;   // clear the options

                if (!isMultiSelect) {
                    select.options.add(new Option("- None Selected -", ""));
                }

                //For multi-selects, their values are specifically setup as needed in another function, so we will always set beforeLookupValid to true in that case and will always set the value on the child lookup to the previous value if one existed.
                var beforeLookupValid = isMultiSelect;

                for (var i in data) {
                    var row = data[i];
					//For single-select drop-downs, verify that the value we had before the parent changed is still in our drop-down list on the child.  If it is, we will still use that value.  If it isn't, the value is cleared.
					if(!isMultiSelect && row.ID === valueBeforeLookup){
						beforeLookupValid = true;
					}
                    select.options.add(new Option(row.Description, row.ID));
                }

                if (valueBeforeLookup && beforeLookupValid)
                    $(input).val(valueBeforeLookup);

                if (toSet != null)
                    $(input).val(toSet);

                $(input)[0].dispatchEvent(new CustomEvent("origami.selectCodeDepListRefresh", { detail: select }));
            });
        }
    });

    if (!onewaydependency && !dropdown) {
        $(input).next().on("change", function () {

            var childVal = $(this).val();
            var masterVal = $(master).next().val();

            if (childVal.length > 0 && (typeof(masterVal) == "undefined" || masterVal.length == 0)) {

                var type = $(this).prev().attr("alt");
                var url = getServerAppRoot() + 'Lookups/' + type + '/Dependency/' + childVal;

                $.getJSON(url, function (data) {

                    if (data.status == "success" && data.id != '') {
                        $(master).val(data.id);
                        $(master).prev().val(data.description);
                    }
                });
            }
        });
    }

    if (allowChildDependencyFirst) {
        $(input).next().on("change", function () {

            var childVal = $(this).val();
            var masterVal = $(master).next().val();

            if (childVal.length > 0 && (typeof (masterVal) == "undefined" || masterVal.length == 0)) {

                var type = $(this).prev().attr("alt");
                var depName = $(this).prev().data("dependency");

                var masterInputName = getMasterInputName(input, depName);
                var master = $("input[name='" + masterInputName + "'],select[name='" + masterInputName + "']");
                if (master.length == 0)
                    return;

                var masterInputField = masterInputName; // field name used for lookup

                // strip any form prefixes off of the master field name
                var formPrefix = $(input).closest("div.origamiform").data("inputnameprefix");
                if (typeof formPrefix == "string" && masterInputField.startsWith(`${formPrefix}.`)) {
                    masterInputField = masterInputField.replace(`${formPrefix}.`, "");
                }

                var url = getServerAppRoot() + 'Lookups/' + type + '/DependencyMaster/' + childVal + '/' + masterInputField + '';

                $.getJSON(url, function (data) {

                    if (data.status == "success" && data.id != '') {
                        $(master).val(data.id);
                        $(master).prev().val(data.description);
                    }
                });
            }
        });
    }

    if (onewaydependency && mv != "" && $(input)[0].hasAttribute("data-codedeprefresh") && (dropdown || $(input)[0].hasAttribute("data-lookupformula")))
        master.trigger("change");
}



Date.firstDayOfWeek = 7;
Date.format = 'mm/dd/yyyy';

function getDateInputValue(input) {
    var date = ($(input).val());
    if (date == null || date.trim().length == 0)
        return null;

    return $.datepicker.parseDate(_userJqueryDateFormat, date);
}

function getDateValue(date) {
    if (date == null || date.trim().length == 0)
        return null;

    return $.datepicker.parseDate(_userJqueryDateFormat, date);
}

function convertUserDateValueToUrlDate(input) {
    return convertDateFormat(input, _userJqueryDateFormat, 'yy-mm-dd');
}

function convertUserDateValueToMdy(input) {
    return convertDateFormat(input, _userJqueryDateFormat, 'mm/dd/yy');

}

function convertUrlDateToUserDateValue(input) {
    return convertDateFormat(input, 'yy-mm-dd', _userJqueryDateFormat);
}

function convertMdyToUserDateFormat(input) {
    return convertDateFormat(input, 'mm/dd/yy', _userJqueryDateFormat);
}

function convertDateFormat(input, sourceFormat, destFormat) {
    if (input == null || input == '')
        return input;

    if (typeof sourceFormat === 'undefined' || sourceFormat == null ||
        typeof destFormat === 'undefined' || destFormat == null)
        return input;
    try {
        if (sourceFormat == destFormat) {
                if (input.substring(0, 1) == "+" || input.substring(0, 1) == "-")
                    return input;

                const output = new Date(input);
                if (output.toString() === "Invalid Date")
                    return input;
                const options: Intl.DateTimeFormatOptions = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                };
                if (destFormat === 'mm/dd/yy') {
                    return output.toLocaleDateString('en-US', options);
                }
                return output.toLocaleDateString('en-GB', options);
            }
        }
    catch (err) {
        return input;
    }
    // if input does not contain two / or - then assume it isn't a date
    var matches = input.match(/\/|-/g);
    if (matches == null || matches.length !== 2)
        return input;

    try {
        var dateValue = $.datepicker.parseDate(sourceFormat, input);
        return $.datepicker.formatDate(destFormat, dateValue);
    }
    catch (err) {
        return input;
    }
}

var applyRestrictions = false;
var workDays = [0, 1, 2, 3, 4, 5, 6];
var restrictedDays = [];
var enableRestrictedSelection = false;
var indefiniteLeaveStartDate = null;
function setDateRestrictions(restrictions) {
    applyRestrictions = true;
    workDays = restrictions.WorkDays;
    restrictedDays = restrictions.NonWorkingDays;
    indefiniteLeaveStartDate = restrictions.IndefiniteLeaveStartDate;
    enableRestrictedSelection = restrictions.EnableRestrictedSelection;
}
function clearDateRestrictions(restrictions) {
    applyRestrictions = false;
    workDays = [0, 1, 2, 3, 4, 5, 6];
    restrictedDays = [];
    indefiniteLeaveStartDate = null;
    enableRestrictedSelection = false;
}
function getRestrictedDay(targetDate) {
    if (!restrictedDays) {
        return null;
    }
    for (var i = 0; i < restrictedDays.length; i++) {
        if (restrictedDays[i].Date === targetDate) {
            return restrictedDays[i];
        }
    }
    return null;
}
function isWorkDay(day) {
    for (var i = 0; i < workDays.length; i++) {
        if (workDays[i] === day) {
            return true;
        }
    }
    return false;
}
function isDateAvailable(date) {
    if (!applyRestrictions)
        return [true, ""];
    var compareDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    if (!isWorkDay(date.getDay())) {
        return [enableRestrictedSelection, "nonWorkingDay", "Non-work Day"];
    }
    if (indefiniteLeaveStartDate !== null && indefiniteLeaveStartDate !== "") {
        var current = new Date(compareDate);
        var startDate = new Date(indefiniteLeaveStartDate);
        if (current >= startDate) {
            return [enableRestrictedSelection, "OOO", "OOO (Open Ended)"];
        }
    }
    var restrictedDay = getRestrictedDay(compareDate);
    if (restrictedDay !== null) {
        return [enableRestrictedSelection, (restrictedDay.Description.substr(0, 3) === "OOO" ? "OOO" : "Holiday"), restrictedDay.Description];
    }
    return [true, "availableDate"];
}

function initializeIntegerSpinnerControl(input) {
    if (typeof input == 'undefined')
        return;

    if ($(input).is(":disabled") || $(input).hasClass("locked"))
        return;

    $(input).origamiSpinner({
        step: 1,
        pageStep: 10
    });
}

function initializeDateControl(input) {
    applyDateInputMasking($(input));

    if ($.datepicker) {
        var defaultMinDate = new Date(1753, 0, 1);
        var defaultMaxDate = new Date(9999, 11, 31);

        // Use these dates if they're set, otherwise use the defaults
        var minDateAttribute = input.attributes["data-min-date"]?.value;
        var maxDateAttribute = input.attributes["data-max-date"]?.value;

        // Internal function to parse date string or return default date
        function parseDate(dateString, defaultDate) {
            try {
                if (dateString) {
                    var [year, month, day] = dateString.split("-").map(Number);
                    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
                        return new Date(year, month - 1, day);
                    }
                }
            }
            catch (e) {
                console.error("Error parsing date:", e);
            }

            //Fall back on default date if parsing fails
            return defaultDate;
        }

        var minDate = parseDate(minDateAttribute, defaultMinDate);
        var maxDate = parseDate(maxDateAttribute, defaultMaxDate);

        $(input).datepicker({
            showOn: "button",
            buttonText: "<i class='fal fa-calendar-alt toolTipIconDefaultColor datePickerIconDefault' style='position:relative;top:-2px;'></i>",
            duration: 200,
            showAnim: "slideDown",
            constrainInput: false,
            minDate: minDate,
            maxDate: maxDate,
            closeAtTop: false,
            changeMonth: true,
            changeYear: true,
            showOtherMonths: true,
            selectOtherMonths: true,
            yearRange: '-100:+30',
            onSelect: function () {
                $(input).trigger("focus");
                $(input).trigger("change");
            }
        });
    }
}

function applyDateInputMasking(input) {
    var inputMaskOptions = {
        jitMasking: true,
        mask: _userDateFormatMask.toLowerCase().replaceAll("m", "9").replaceAll("d","9").replaceAll("y","9")
    };

    $(input).on("keydown", function(event) {

        if ((event.key != '/' && event.keyCode != 8) || $(this).val().trim() == '')
            return;

        if ($(this).val().trim().slice(-1) == "/" && event.key == '/')
            return false;

        if ($(this).val().trim().slice(-1) == "/" && event.keyCode == 8)
            $(this).val($(this).val().trim().substring(0,$(this).val().trim().length-1));

        return;
    });

    $(input).on("keyup", function(event) {
        var initVal = $(this).val().trim();

        if(initVal.substring(0,1) == "+" || initVal.substring(0,1) == "-")
            return;

        var currInputParts = initVal.split("/");
        var maskParts = inputMaskOptions.mask.split("/");
        var adjustedVal = "";

        for(var i=0; i < maskParts.length; i++)
        {
            if(!(currInputParts.length > i + 1)) {
                adjustedVal += currInputParts[i];
                break;
            }
            
            if(currInputParts[i].length == 1 && maskParts[i].length == 2)
                adjustedVal += "0" + currInputParts[i] + "/";
            else
                adjustedVal += currInputParts[i] + "/";
        }

        if(adjustedVal != initVal)
            initVal = adjustedVal;

        var formattedDate = Inputmask.format(initVal, inputMaskOptions);

        if(formattedDate != '' && initVal.length <= formattedDate.length)
            $(input).val(formattedDate.trim());
    });

    $(input).on("blur", function () {
        if (typeof _userDateFormatMask == 'undefined' || _userDateFormatMask != 'MM/dd/yyyy')
            return;

        var currVal = $(this).val();
        if (typeof currVal == 'undefined' || currVal == null || currVal == '')
            return;

        var currInputParts = currVal.split("/");
        if (currVal.length == 6 && currInputParts.length == 3 && currVal.endsWith("/")) {
            $(this).val(currVal + new Date().getFullYear());
        }
    });
}

function dateInputShowRelativeDateField(input: string): boolean {
    if (input == null || input == '')
        return false;

    var matchResult = input.match(/^[+-][0-9]+($|[dmy]$)/i);

    if (matchResult != null && matchResult.length > 0)
        return true;

    return false;
}

function initializeTimeControl(input) {
    if (isMobileDevice()) {
        if (!(typeof $(input).attr("use24hour") != 'undefined' && $(input).attr("use24hour").toLowerCase() == "true")) {
            if ($(input).val() != '') {
                var convVal = convert12to24Time($(input).val());
                if (convVal != '') {
                    $(input).val(convVal);
                    $(input).attr("type", "time");
                }
            }
            else
                $(input).attr("type", "time");
        }
    }
    else {
        $(input).timeEntry({
            ampmPrefix: ' ',
            noSeparatorEntry: true,
            spinnerImage: '',
            initialField: 0.,
            useMouseWheel: !(input.disabled)
        });
    }
}

function convert12to24Time(input: string): string {
    if (input === null || input === '')
        return '';

    input = input.toLowerCase();

    if (!input.endsWith("am") && !input.endsWith("pm"))
        return input;

    var isPm = input.endsWith("pm");

    var inputElems = input.split(":");

    var hoursStr = inputElems[0];
    var hoursInt = parseInt(hoursStr);

    if (isNaN(hoursInt))
        return '';

    if (isPm && hoursInt < 12)
        hoursInt = hoursInt + 12;

    if (!isPm && hoursInt === 12)
        hoursInt = 0;

    if (hoursInt < 10)
        hoursStr = "0" + hoursInt.toString();
    else
        hoursStr = hoursInt.toString();

    var minsStr = inputElems[1].split(" ")[0];

    return hoursStr + ":" + minsStr;
}

function initializeTime24Control(input) {
    if (isMobileDevice()) {
        $(input).attr("type", "time");
        return;
    }
    else {
        $(input).timeEntry({
            show24Hours: true,
            noSeparatorEntry: true,
            ampmPrefix: ' ',
            spinnerImage: '',
            initialField: 0
        });
    }
}

function initializeDecimalControl(input) {
    var codedMask = $(input).attr("alt");
    if (codedMask == null || codedMask == "")
        codedMask = "decimal";
    if ($(input).attr("alt") != null)

        $(input).maskedInput({ mask: codedMask });
}

function initializeIntegerControl(input) {
    $(input).maskedInput({ mask: "integer" });
}

function initializeDigitsOnlyControl(input) {
    $(input).maskedInput({ mask: "digitsOnly" });
}

var pickerCurrentInput = null;
function initializeRelativeDatePicker(input) {

    $(input).next().on('click',function (e) {
        pickerCurrentInput = input;
        var menu = $('#relativeDatePicker');
        openPopup(e, $(input), null, menu);
    });

    //Ensure we follow same rules as we do everywhere else for Dates (add formatting)
    applyDateInputMasking($(input));
}

function initializeFieldPicker(input, type) {
    $(input).siblings("#fieldPickerTrigger").on('click',function (e) {
        pickerCurrentInput = input;
        var menu = $('#fieldPicker_' + type);
        openPopup(e, $(input), null, menu);
    });
}

function inputLookupDescriptionAndCode(data) {
    var str = data.Description;
    if (data.DisplayCode != null && data.DisplayCode.length > 0 && data.DisplayPatternOverwritten !== true)
        str += " (" + data.DisplayCode + ")";

    return str;
}

function inputLookupCodeAndDescription(data) {
    if (data.DisplayCode != null && data.DisplayCode.length > 0 && data.DisplayPatternOverwritten !== true)
        return data.DisplayCode + " - " + data.Description;
    else
        return data.Description;
}

function inputLookupEmailAndID(data) {
    if (data.DisplayCode != null) {
        var display = isValidEmail(data.DisplayCode) ? data.DisplayCode : data.Email;
    }
    if (display != null && data.ID != null) {
        return `${display}(ID:${data.ID})`;
    } else {
        return data.Description;
    }
}

function inputLookupDescriptionOnly(data) {
    return data.Description;
}

function applyDynamicMatchKeysFilters(filters, input) {
    if (!input)
        return filters;

    // handle any resolved match keys for <select> lookups
    var resolved = $(input).data("matchstringresolved");
    if (resolved != null && typeof resolved !== 'undefined' && resolved.trim().length>0) {
        console.log("adding filter matchKeys:" + resolved);
        if (filters)
            filters += "&";

        filters += "matchKeys=" + encodeURIComponent(resolved);
    }

    return filters;
}

function getDynamicFieldSelectList(domainID, dynamicFieldSelectListName, value, defaultOptionText, dbColumnsOnly)
{
    if (domainID == null || domainID == 'undefined' || domainID.length == 0 || domainID == 0)
        return;

    $.ajax({
        type: 'POST',
        url: getServerAppRoot() + getControllerName() + "/GetDomainFieldsSelectList",
        dataType: 'json',
        data: AddAntiForgeryToken({
            domainID: domainID,
            fieldName: dynamicFieldSelectListName,
            value: value,
            defaultOptionText: defaultOptionText,
            dbColumnsOnly: dbColumnsOnly
        }),
        async: false,
        success: function (data) {

            $('select#' + dynamicFieldSelectListName)
                .html(data.innerHtml)
                .val(data.selectedValue);
        }
    });
}

function initializeInputLookup(input) {
    if ($(input).hasClass("disableAutoComplete")) {
        if ($(input).attr("readonly")) {
            $(input).on("blur", function () {
                if ($(input).val().length == 0) {
                    if ($(input).next().val() != '') {
                        $(input).next().val('');
                        $(input).next().trigger("change");
                    }
                }
            });
            $(input).on("keydown", function (e) {
                if ($(input).val() != '' && (e.key == 'Backspace' || e.key == 'Delete')) {
                    $(input).val('');
                }
                return false;
            }).on("focus", function () {
                $(input).select();
            });
        }
        return;
    }

    $(input).attr('aria-autocomplete', 'list');
    $(input).attr('role', 'combobox');     

    var codeFirst = $(input).hasClass("codefirst");
    var valueFunc = codeFirst ? inputLookupCodeAndDescription : inputLookupDescriptionAndCode;
    var resultFunc = codeFirst ? inputLookupCodeAndDescription : inputLookupDescriptionOnly;
    var emailAndIDFormat = $(input).hasClass("showEmailAndID");
    resultFunc = emailAndIDFormat ? inputLookupEmailAndID : resultFunc;
    var minLengthValue = 2;
    var clientSpecificLookup = $(input).attr("clientspecificlookup") === "False" ? false : true;

    if (typeof $(input).attr('autocompletelength') != 'undefined')
        minLengthValue = parseInt($(input).attr('autocompletelength'));

    var filters = $(input).data("filters");
    if ($(input) && $(input).length > 0 && $(input).hasClass("inputLookup")) {

        var addFilters = lookupDataDashUrlModifiers($(input));
        if (addFilters) {
            filters = filters + addFilters;
        }

        filters = applyDynamicMatchKeysFilters(filters, input);
    }

    $(input).autocomplete(getServerAppRoot() + 'Lookups/' + $(input).attr('alt'), {
        dataType: 'json',
        multiple: $(input).hasClass("allowMultipleLookups") ? true : false,
        multipleSeparator: $(input).hasClass("allowMultipleLookups") ? ";" : ", ",
        parse: function (data) {
            $(input).data('autocompletelistopen', "true");
            var rows = [];
            for (var i = 0; i < data.length; i++) {
                rows[i] = { data: data[i], value: valueFunc(data[i]), result: resultFunc(data[i]) };
            }
            return rows;
        },
        formatItem: function (row, i, n) {
            return inputLookupDescriptionAndCode(row);
        },
        formatResult: function (row, i, n) {
            return row.Description;
        },
        delay: 200,
        width: 300,
        max: 20,
        matchSubset: false,
        matchContains: true,
        minChars: minLengthValue,
        extraParams: { filters: filters, _tpaclientid: getTPAClientID(), maxRows: 30, clientSpecificLookup: clientSpecificLookup, forTypeAhead: true  }
    }).result(function (event, data, formatted) {
        if (data) {
            $(input).next().val(data.ID);
            $(input).next().trigger("change");
            onLookupSelected($(input));

            $(input).data('oldvalue', $(input).val());
        }
    }).on("blur", function () {
        $(input).removeData('autocompletelistopen');
        if ($(input).val().length == 0) {
            if ($(input).next().val() != '') {
                $(input).next().val('');
                $(input).next().trigger("change");
            };

            //JIRA 6067 - Only attempt if not a dependent field
            if ($(input).data('dependency') === undefined) {
                var dep = $('input[data-dependency="' + input.id + '"]');
                if (dep.length === 1) {
                    $(dep).val('');
                    $(dep).next().val('');

                    disableEnableDependent(dep[0], !($(dep[0]).data("allowchildfirst")));
                }
            }
            //End
        }
        else {
            // if the codeid is empty, then invalid entry unless otherwise allowed
            if ($(input).next().val() == '' && !$(input).hasClass("allowInvalidLookups") && !$(input).hasClass("allowMultipleLookups")) {
                $(input).val('');
                let fieldName = $(input).attr('aria-label');
                if (!fieldName)
                    fieldName = 'Previous';
                screenReaderMessage(`${fieldName} field contained an invalid value and was cleared.`, true);
            }
            if ($(input).hasClass("allowMultipleLookups")) {
                if ($(input).val().endsWith(";")) {
                    var removeSemicolon = $(input).val().slice(0, -1);
                    input.val(removeSemicolon);
                }
            }
        }
    });

    $(input).on('focus', function () {

        var oldvalue = $(input).val();
        $(input).data('oldvalue', oldvalue);

    }).on('keyup', function () {
        // clear the input value
        var oldvalue = $(input).data('oldvalue');
        var newvalue = $(input).val();
        if (newvalue !== oldvalue) {
            $(input).next().val('').trigger("change");
        }
    });
}

// function handle textarea maxlength
// taken from: http://stackoverflow.com/questions/1125482/how-to-impose-maxlength-on-textarea-in-html-javascript
function handleTextAreaMaxLength() {
    var txts: any = document.getElementsByTagName('TEXTAREA');

    for (var i = 0, l = txts.length; i < l; i++) {
        if (/^[0-9]+$/.test(txts[i].getAttribute("maxlength"))) {
            var func = function () {
                var len = parseInt(this.getAttribute("maxlength"), 10);

                if ($(this).val().length > len) {
                    this.value = $(this).val().substr(0, len);
                    return false;
                }
            }

            txts[i].onkeyup = func;
            txts[i].onblur = func;
        }
    }
}

function handleTextAreaCarriageReturns() {
    $['valHooks'].textarea = {
        get: function (elem) {
            return elem.value.replace(/\r?\n/g, "\r\n");
        }
    };
}

function collapseDetails(marker) {
    $(marker).after("<div class='expandCollapse'><i id='full-details-expader' class='far fa-chevron-circle-down' alt='Full Details'>&nbsp;</i><a class='fullDetails' href='#'>Full Details</a></div>");
    $(marker).nextAll("div.panel").hide();
}
//#endregion

//#region lookups and auto-fill

var hiddenFieldList, visibleFieldList

function InitializeAutoFillComponents() {

    if (!$('input[name="_DelayedAutoFillTokens"]').length)
        $('body').append("<input name=\"_DelayedAutoFillTokens\" type=\"hidden\" value = \"\">");

    hiddenFieldList = "";
    visibleFieldList = "";

    var controls: any = document.querySelectorAll("input, select, textarea");

    for (let index = 0; index < controls.length; ++index) {

        var forceInclude = controls[index].getAttribute("autoFillForceInclude");
        var useAutoFillName = controls[index].getAttribute("useAutoFillName");

        var name = controls[index].name;

        if(useAutoFillName){
            name = useAutoFillName;
        }

        if (name.substring(0, 27) == "__origamilookupdescription_")
            name = name.substring(27, name.length);

        if (name.substring(0, 8) != "Origami.")
        {
            if (name.indexOf('.') !== -1)
                name = name.split('.').pop();

            if ((visibleFieldList.trim().length == 0 || visibleFieldList.indexOf(';' + name + ';') == -1) &&
                (hiddenFieldList.trim().length == 0 || hiddenFieldList.indexOf(';' + name + ';') == -1))
            {
                if (controls[index].type == "hidden" && forceInclude != "true")
                {
                    if (hiddenFieldList == null || hiddenFieldList.trim().length == 0)
                        hiddenFieldList = ';' + name + ';';
                    else
                        hiddenFieldList = hiddenFieldList + name + ';';
                }
                else
                {
                    if (visibleFieldList == null || visibleFieldList.trim().length == 0)
                        visibleFieldList = ';' + name + ';';
                    else
                        visibleFieldList = visibleFieldList + name + ';';
                }
            }
        }
    }

    if (hiddenFieldList.length)
        hiddenFieldList = hiddenFieldList.substring(1, hiddenFieldList.length - 1)

    if (visibleFieldList.length)
        visibleFieldList = visibleFieldList.substring(1, visibleFieldList.length - 1)
}

function setLookupValueForControl(controlID, id, description) {
    hidePopup();
    var trigger = $("#" + controlID);
    setLookupValueForTrigger(trigger, id, description);
    $(trigger).trigger("focus");
    setSelectOption(trigger);
}

function setLookupValueForHiddenControl(controlID, id, description) {
    hidePopup();
    var trigger = $("#" + controlID);
    trigger.val(id);
    $(trigger).trigger("focus");
    setSelectOption(trigger);
}

function onSetLookupValueForTrigger(trigger, id, description): boolean {
    return false;
}

function setLookupValueForTrigger(trigger, id, description) {
    if (onSetLookupValueForTrigger(trigger, id, description) == true)
        return;

    if (trigger.hasClass("inputLookup")) {
        trigger.val(description).next().val(id).trigger("change");
        trigger.trigger("change");
        clearTemporaryValueForTrigger(trigger);
        onLookupSelected(trigger);
    }
    else if (trigger.hasClass("autofill")) {
        autoFillFromTrigger(trigger, id);
    }
}

function setLookupTemporaryValueForTrigger(trigger, id, description) {
    if (trigger.hasClass("inputLookup")) {
        var triggerInputName = trigger.next().attr("name");
        var temporaryInputName = "TemporaryValue." + triggerInputName;
        var temporaryInput = $("input[name='" + temporaryInputName + "']");
        if (temporaryInput.length === 0) {

            var newHiddenInput = $("<input type=\"hidden\" name=\"" + temporaryInputName + "\" />");
            var triggerForm = trigger.closest("form");
            triggerForm.append(newHiddenInput);

            temporaryInput = $("input[name='" + temporaryInputName + "']");
        }

        trigger.val(description).next().val("").trigger("change");
        temporaryInput.val(id).trigger("change");
        trigger.trigger("change");
        onLookupSelected(trigger);
    }
    else if (trigger.hasClass("autofill")) {
        autoFillFromTrigger(trigger, id);
    }
}

function clearTemporaryValueForTrigger(trigger) {
    if (trigger.hasClass("inputLookup")) {
        var triggerInputName = trigger.next().attr("name");
        var temporaryInputName = "TemporaryValue." + triggerInputName;
        var temporaryInput = $("input[name='" + temporaryInputName + "']");
        if (temporaryInput.length !== 0) {
            temporaryInput.val("").trigger("change");
        }
    }
}

function setLookupValue(id, description) {

    hidePopup();

    setLookupValueWork(id, description);
}

function setLookupValueWork(id, description) {

    var controlID;

    if (_currentLookupControl)
        controlID = _currentLookupControl.attr('id');
    else
        controlID = $('#jqmParams').val();

    if (controlID.length > 0) {
        var trigger;

        if (_currentLookupControl)
            trigger = _currentLookupControl;
        else
            trigger = $("#" + controlID);

        setLookupValueForTrigger(trigger, id, description);
    }
}

function setLookupTemporaryValue(id, description) {

    hidePopup();

    var controlID;

    if (_currentLookupControl)
        controlID = _currentLookupControl.attr('id');
    else
        controlID = $('#jqmParams').val();

    if (controlID.length > 0) {
        var trigger;

        if (_currentLookupControl)
            trigger = _currentLookupControl;
        else
            trigger = $("#" + controlID);

        setLookupTemporaryValueForTrigger(trigger, id, description);
    }
}

function getLookupValue() {
    var controlID = $('#jqmParams').val();
    if (controlID.length > 0) {
        var input = $("#" + controlID);
        if (input.hasClass("inputLookup"))
            return input.next().val();
    }
    return null;
}


function autoFillForm(sourceDomain, formDomain, setName, id, inputnameprefix, additionalFilterParam = null) {
    if (hiddenFieldList == null || hiddenFieldList.trim().length == 0 || visibleFieldList == null || visibleFieldList.trim().length == 0)
        InitializeAutoFillComponents();

    var url = appendTPAClientID(getServerAppRoot() + "Forms/AutoFillStandard");

    $.ajax({
        url: url,
        data: AddAntiForgeryToken({ setName: setName, sourceDomain: sourceDomain, formDomain: formDomain, sourceId: id, includeFields: visibleFieldList, excludeFields: hiddenFieldList, additionalFilterParam: additionalFilterParam }),
        type: 'post',
        success: function (data) {
            if (data.status == "success") {

                if (data.excludedFieldSetGUID.length > 0) {
                    var guids = $('input[name="_DelayedAutoFillTokens"]').val();

                    if (guids.length > 0)
                        guids += ';' + data.excludedFieldSetGUID;
                    else
                        guids = data.excludedFieldSetGUID;

                    $('input[name="_DelayedAutoFillTokens"]').val(guids);
                }

                autoFillFormFields(data.items, inputnameprefix);
            }
            else
                alert("Could not locate record.");
        }
    });
}

function autoFillFormByFilter(sourceDomain, formDomain, setName, filter) {

    if (hiddenFieldList == null || hiddenFieldList.trim().length == 0 || visibleFieldList == null || visibleFieldList.trim().length == 0)
        InitializeAutoFillComponents();

    var url = appendTPAClientID(getServerAppRoot() + "Forms/AutoFillByFilter");

    $.ajax({
        url: url,
        data: AddAntiForgeryToken({ setName: setName, sourceDomain: sourceDomain, formDomain: formDomain, sourceQuery: encodeURIComponent(filter), includeFields: visibleFieldList, excludeFields: hiddenFieldList }),
        type: 'post',
        success: function (data) {
            if (data.status == "success") {

                if (data.excludedFieldSetGUID.length > 0) {
                    var guids = $('input[name="_DelayedAutoFillTokens"]').val();

                    if (guids.length > 0)
                        guids += ';' + data.excludedFieldSetGUID;
                    else
                        guids = data.excludedFieldSetGUID;

                    $('input[name="_DelayedAutoFillTokens"]').val(guids);
                }

                autoFillFormFields(data.items, inputnameprefix);
            }
            else
                alert("Could not locate record.");
        }
    });
}


var _autoFillingItems = null;
function getAutoFillValueForDropDown(input, prefix) {
    if (_autoFillingItems==null)
        return null;

    if (prefix.length > 0)
        prefix += "_";

    for (var i in _autoFillingItems) {
        var item = _autoFillingItems[i];

        if ($(input).is("#" + prefix + item.name))
            return item.value;
    }

    return null;
}

function autoFillFormFields(items, inputnameprefix) {
    _autoFillingItems = items;

    var prefix = "#";
    if (inputnameprefix != null && inputnameprefix.trim().length > 0)
        prefix = "#" + inputnameprefix + "_";

    for (var i in items) {
        var item = items[i];
        var value = item.value;
        var idselector = prefix + item.name;

        if ($(idselector).data('sensitive-readonly')) {
            // if this is a readonly sensitive field, clear as sf functionality and just make it standard readonly after autofill
            $(idselector).removeClass('sensitiveField').attr('placeholder', null).parent().find('button.sensitiveFieldButton').remove();
        }

        if (item.type == "lookup" || $(idselector).is(".inputLookup")) {
            if ($(idselector).attr('type') == "hidden")
                $(idselector).val(item.value);
            else
                $(idselector).val(item.description).next().val(item.value).trigger("change");
        }
        else if (item.type == "boolean") {
            var check = $(idselector);
            if (check.is(":checkbox"))
                check.prop('checked', (item.value == "True" || item.value == true)).trigger("change");
            else if ($("input[type='radio'][name='" + item.name + "']").is(":radio")) {
                $("input[name=" + item.name + "][value=" + value + "]").prop('checked', true);
            }
            // Looks like the naming of some or all(?) radio buttons changed, the conditional above may not be necessary, but keeping it here for now
            else if ($("input[type='radio'][name='rb" + item.name + "']").is(":radio")) {
                $("input[name=rb" + item.name + "][value=" + value + "]").prop('checked', true);
            }
            else
                check.val(value).trigger("change");
        }
        else if (item.type == "date") {
            if (value != null && value.trim().length > 0)
                value = convertUrlDateToUserDateValue(value);

            $(idselector).val(value).trigger("change");
        }
        else if (idselector.includes("CustomMultiSelectCode")) {
            var dropDownSelector = $("select[name='__multiselect_" + item.name + "']");
            if (dropDownSelector[0]) { //If this was configured to be a dropdown
                value.split(',').filter(x => x).forEach(function (v) {
                    var optSelector = $("select[name='__multiselect_" + item.name + "'] option[value='" + v + "']");
                    optSelector.prop('selected', true);
                });
                dropDownSelector.trigger("chosen:updated");
            }
            else {
                value.split(',').filter(x => x).forEach(function (v) {
                    var optSelector = $("input[name='__multiselect_" + item.name + "'][value='" + v + "']");
                    optSelector.prop('checked', true);
                    optSelector.trigger("change");
                });
            }
        }
        else {
            var nameSelector = idselector.slice(1).replace('_', '.');
            if ($("input[type='radio'][name='rb" + nameSelector + "']").length) {
                $("[name='rb" + nameSelector + "']").removeAttr('checked');
                $("input[name='rb" + nameSelector + "'][value = '" + value + "']").prop('checked', true);
                $(`input[name=${nameSelector}]`).val(value).trigger("change");
            }
            else {
                var input = $(idselector);
                if (input.is(".buttonGroupInput")) {
                    var ul = input.next();
                    $("li", ul).removeClass("selected");

                    if (value != null && value.trim().length > 0)
                        $('li[data-value="' + value + '"]', ul).addClass("selected");
                }
                input.val(value).trigger("change");
            }
        }
    }

    _autoFillingItems = null;
}


function onLookupSelected(lookup) {

    if (!lookup.hasClass("autofill"))
        return;

    var id = lookup.next().val();
    if (id == null || id.length == 0)
        return;

    autoFillFromTrigger(lookup, id);
}

function autoFillFromTrigger(trigger, id) {

    var sourceDomain = trigger.attr("sourceDomain");
    var formDomain = trigger.attr("formDomain");
    var setName = trigger.attr("setName");
    var inputnameprefix = trigger.attr("inputnameprefix");
    var additionalFilterParam = trigger.attr("additionalFilterParam");

    var prompt = trigger.attr("autoFillPrompt");
    if (prompt != null && prompt.length > 0) {
        if (!confirm(prompt))
            return;
    }

    autoFillForm(sourceDomain, formDomain, setName, id, inputnameprefix, additionalFilterParam);
}
//#endregion

//#region navigation menu
function openMenu(e) {
    //var button = $(this).addClass('active');
    var button = $(this);
    var menu = $('#' + button.attr('name'));

    openPopup(e, button, button, menu);
}

var hidePopupListeners = [];
function addHidePopupListener(fn) {
    hidePopupListeners.push(fn);
}

function hidePopup() {
    if (window.origami.settings.UseNewModalWindow) {
        $('#or-modal-popup').dialog("close");
        $('#or-modal-popup-frame').attr('src', '');
        $('#or-modal-popup-frame').html('');
    } else {
        if (jQuery().jqmHide)
            $('#modalWindow').jqmHide();
    }

    for (var i in hidePopupListeners) {
        var callback = hidePopupListeners[i];
        callback();
    }
}

function closeMinModal() {
    hidePopup();
    $("#minimizedModalWindow").hide();
}

function minimizeModal(headerText) {
    var bgColor = $('div.titleArea').css('backgroundColor');
    var color = $('div.titleArea').css('color');

    $("#minimizedModalWindow").css('backgroundColor', bgColor);
    $("#minimizedModalWindow").css('color', color);
    $("span#minModalText").text(headerText);

    if (window.origami.settings.UseNewModalWindow) {
        $('.ui-widget-overlay').hide();
        $(".or-modal-popup").animate({ top: '100%', left: '97%', width: '100px', height: '10px' },
            150,
            function () {
                $('#or-modal-popup').dialog('close');
                $(".or-modal-popup").css({ top: null, left: null, width: null, height: null });
                $("#minimizedModalWindow").show();
            }
        );
    } else {
        $("div.jqmOverlay").hide();
        $("#modalWindow").hide();
        $("#minimizedModalWindow").show();
    }
}

function maximizeModal() {
    if (window.origami.settings.UseNewModalWindow) {
        $('#or-modal-popup').dialog('open');
        resizeModal();
    } else {
        $("div.jqmOverlay").show();
        $("#modalWindow").show();
    }
    $("#minimizedModalWindow").hide();
}

function callMinimizeModal(elem) {
    //This assumes it will be called from a modal.
    var toolbarTitle = $('div.title').text().trim();
    if (!toolbarTitle) {
        toolbarTitle = $('span.pagetitle').data('title');
    }
    window.parent.minimizeModal(toolbarTitle);
}

function hidePopupAndReload() {
    hidePopup();
    window.location.reload();
}

// An element's position is relative to the closest ancestor element that is positioned,
// but the offset value is relative to the viewport. To set an element's position using 
// offset values, you must first subtract the offset values of the position context.
function getPositionContextOffset(element: JQuery) : JQueryCoordinates {
    let parent = element.parent();
    if(!parent.offset()) {
        return element.offset();
    } else if(parent.css("position") == "static") {
        return getPositionContextOffset(parent)
    } else {
        return parent.offset();
    }
}


function openPopup(e, align, button, menu, above = false, callbackfunc = closePopupCallback) {
    var offset = align.offset();
    var parentOffset = getPositionContextOffset(menu);
    var h = (align.outerHeight) ? align.outerHeight() : align.height();
    var w = (align.outerWidth) ? align.outerWidth() : align.width();
    var wmenu = (menu.outerWidth) ? menu.outerWidth() : menu.width();

    var isFixed = $(menu).css("position");
    if (isFixed === "fixed") {
        h = h - $(window).scrollTop();
        w = w - $(window).scrollLeft();
    }

    var left = offset.left - parentOffset.left + w - wmenu;
    if (left < 0)
        left = 0;

    var top = offset.top - parentOffset.top + h;
    if (above)
        top = top - menu.height() - h; 

    if (shouldLockNavAndSidePanelsWhenOpeningPopup(menu, top)) {
        menu.addClass('active').css({
            'bottom': 0, 'left': left
        }).on('click', function (e) { e.stopPropagation(); }).slideDown(200, function () {
            $(document).one('click', { button: button, menu: menu }, closePopupCallback);
        });
    }
    else {
        menu.addClass('active').css({
            'top': top, 'left': left
        }).on('click', function (e) { e.stopPropagation(); }).slideDown(200, function () {
            $(document).one('click', { button: button, menu: menu }, closePopupCallback);
            menu.off("actionMenu.origami");
        });
    }
    menu.one("actionMenu.origami", customMenuOnEvent(e, null));
    menu.triggerHandler("actionMenu.origami", null);

    $("a:not(.ui-datepicker-prev,.ui-datepicker-next)", menu).one('click', { button: button, menu: menu }, closePopupCallback);
    $(menu).find("a").first().trigger("focus");
}

function shouldLockNavAndSidePanelsWhenOpeningPopup(menu, top) {
    const setting = window.origami.settings.LockNavAndSidePanels;
    const totalHeight = $("body").height();
    const menuId = $(menu).attr("id") || "";
    const excludedMenuLists = ["moreActionsMenu"];

    if (!setting || excludedMenuLists.indexOf(menuId) >= 0) {
        return false; // setting is turned off; or the menu element is excluded
    }

    return (window == window.top) && ((top + 450) > totalHeight);
}

function closePopupCallback(e) {
    closePopup(e.data.menu, e.data.button);
}

function closePopup(menu, button, callbackfunc = closePopupCallback) {
    $(document).off('click', closePopupCallback);
    $("a", menu).off('click', closePopupCallback);

    menu.removeClass('active').slideUp(100, function() {
//        if (button!=null)
//            button.removeClass('active');
    });

    if (button!=null)
        button.one('click', openMenu);
}
//#endregion

//#region toolbar positioning and manipulation
let pager_marker;
let pagerbar_div;
let headerOffsetTop = 0;

function lockTitleArea() {
    let titleArea = $('div.titleArea');
    if (titleArea.closest("nav").length > 0)
        return;

    // Only apply locking if setting enabled and window is not a modal
    if (window.origami.settings.LockNavAndSidePanels && (window == window.top)) {
        lockNavAndSidePanels();
        $(function () {
            lockNavAndSidePanels();
            //var speed = $.noty.get($(".noty_bar").attr("id")).options.animation.speed;
            $(".noty_message").click(function () { setTimeout(() => { lockNavAndSidePanels() }, 1001); });
        });
    } else {
        $(window).scroll(adjustTitleArea);
        $(window).resize(adjustTitleArea);
    }
}

// This implements many CSS adjustments to allow the locked UI to work properly. 
function lockNavAndSidePanels() {
    // Use this CSS class to conditionally set the styles in CSS files so it can be overriden in CSS as needed.
    $("body").addClass("lockNavAndSidePanels");

    let content_top = $('#content').offset().top;
    var isSelectClient = false;
    try {
        isSelectClient = (window.origami.login.isSelectClient === 'true');
    }
    catch (err) {
        console.error(err);
    }
    $('#content').css("overflow-y", "auto");
    if (isSelectClient) {
        $('#content').css("padding-top", "10px");
    }
    else {
        $('#content').css("padding-top", "0");
    }
    $('#content').css("max-height", "calc(100vh - " + content_top + "px)");

    $('#content div.panel-contents').css("margin-top", "1em");

    $('#shift').css("margin-right", "3px");
    $('#shift').css("left", "0px");
    $('#shift').css("width", "100%");

    let popupMenu_top = content_top + 5;

    $('#moreActionsMenu').css("overflow-y", "auto");
    $('#moreActionsMenu').css("max-height", "calc(100vh - " + popupMenu_top + "px)");

    // For some reason, section headers for the LockoutTagoutProcedure View Screen 
    // use a CSS class that makes them sticky, when they shouldn't be normally
    $('.tg-xqil').css("position", "relative");
    $('.tg-xqil').css("top", "0px");

    

    let sidePanel = $('#secondaryContent');
    sidePanel.css("position", "sticky");
    sidePanel.css("top", headerOffsetTop + "px");
    if (!($("#secondaryContent div[data-panel-key-desc='(Panel Key: ValidFieldsPanel)']").length))
        sidePanel.css("overflow-y", "auto");
    sidePanel.css("height", "calc(100vh - " + headerOffsetTop + "px)");
    if (sidePanel.hasClass('secondaryContentOverride') === true) {
        //sidePanel.css("width", "370px");
        sidePanel.css("padding-right", "5px");
        sidePanel.css("padding-left", "12px");
        sidePanel.addClass('sidebarLockNavAndSidePanelsOverride')
    }
    else {
        sidePanel.css("width", "19.7em");
    }
}

function adjustTitleArea() {
    const titleArea = $('div.titleArea');
    const primaryTitleArea = titleArea.not('.secondaryTitleArea, .tertiaryTitleArea');
    const secondaryTitleArea = $('.secondaryTitleArea').filter(function() {
        return $(this).outerHeight() > 0;
    });
    const tertiaryTitleArea = $('.tertiaryTitleArea');

    if (primaryTitleArea.length > 0) {
        const primaryHeight = primaryTitleArea.outerHeight();
        const primaryWidth = $('#page').width();
        const scrollTop = $(window).scrollTop();
        const primaryStickyClass = "stuckheader";
        const otherStickyClass = "fixedPositionHeader";
        let secondaryHeight = 0;

        if (secondaryTitleArea.length > 0) {
            secondaryHeight = secondaryTitleArea.outerHeight();
            secondaryTitleArea.each(function () {
                const currElement = $(this);
                
                if (scrollTop > headerOffsetTop) {
                    currElement.addClass(otherStickyClass);
                    currElement.css({
                        'top': `${primaryHeight}px`,
                        'width': `${primaryWidth}px`,
                    });
                    $('#content').css('margin-top', currElement.css('height'));
                } else {
                    currElement.removeClass(otherStickyClass);
                    currElement.css({
                        'top': '',
                        'width': '',
                    });
                    $('#content').css('margin-top', '');
                }
            });
        }

        if (tertiaryTitleArea.length > 0) {
            tertiaryTitleArea.each(function () {
                const currElement = $(this);

                if (scrollTop > headerOffsetTop) {
                    currElement.addClass(otherStickyClass);
                    currElement.css({
                        'top': `${primaryHeight + secondaryHeight}px`,
                        'width': `${primaryWidth}px`,
                    });
                    $('#content').css('margin-top', currElement.css('height'));
                } else {
                    currElement.removeClass(otherStickyClass);
                    currElement.css({
                        'top': '',
                        'width': '',
                    });
                    $('#content').css('margin-top', '');
                }
            });
        }

        primaryTitleArea.each(function () {
            const currElement = $(this);

            if (scrollTop > headerOffsetTop) {
                currElement.addClass(primaryStickyClass);
                currElement.css('width', `${primaryWidth}px`);
                $('#content').css('margin-top', currElement.css('height'));
            } else {
                currElement.removeClass(primaryStickyClass);
                currElement.css('width', '');
                $('#content').css('margin-top', '');
            }
        });

        //ORDEV-46741 adds and removes the tertiaryTitleArea class to certain objects so we will have straggler elements that still have the fixed position. Remove the straggler class.
        $('.fixedPositionHeader').not('.titleArea, .secondaryTitleArea, .tertiaryTitleArea').removeClass('fixedPositionHeader');
    }
}

function highlightTitleTab() {
    let titleTabs = $('.titleTab');
    if (!(titleTabs.length > 0)) {
        return;
    }

    const actionName = getControllerAction();
    const targetTab = titleTabs.filter(`.action_${actionName}`);

    if (targetTab.length > 0) {
        targetTab.addClass('selectedTitleTab');
    }
}

function stickyPagerBar() {
    var window_bottom = $(window).scrollTop() + $(window).height();
    var marker_bottom = pager_marker.offset().top + pager_marker.height();

    if (window_bottom < marker_bottom) {
        pagerbar_div.addClass("moving");
        //var newtop = $(window).height() - pagerbar_div.height() - 5;
        //pagerbar_div.css("top", newtop + "px");
        pagerbar_div.css("bottom", "0");

        var calcwidth = $("#page").width() - pagerbar_div.offset().left - 12;
        if (window.origami.settings.LockNavAndSidePanels) {
            calcwidth = calcwidth - 5;
        }
        pagerbar_div.css("width", calcwidth + "px");
    }
    else {
        pagerbar_div.removeClass("moving");
        //pagerbar_div.css("top", "0px");
        pagerbar_div.css("width", "100%");
    }
}

function lockPagerBar() {
    pagerbar_div = $("div.pager.keepVisible");
    if (pagerbar_div.length == 1) {

        pager_marker = $("<div class='pagermarker'></div>");
        pagerbar_div.after(pager_marker);

        $(window).on("scroll", stickyPagerBar);
        $(window).on("resize", stickyPagerBar);
        stickyPagerBar();
    }
}

function ensureToolbar() {
    var toolbar = $("#toolBar");
    if (toolbar.length > 0)
        return toolbar;

    toolbar = $("<div id=\"toolBar\"><ul class=\"toolbar\"></ul></div>");
    $("#page").append(toolbar);

    return toolbar;
}

function addToolbarButton(name, onclickFunction) {
    ensureToolbar();

    var li = $("<li><button class='btn btn-inverse'>" + name.escapeHTML() + "</button></li>");
    $("#toolBar ul.toolbar").prepend(li);

    $("button", li).on('click',onclickFunction);
}
//#endregion


function positionAndShowModal(modalWindow) {
    modalWindow.show();
}

function openThickboxPopup(url, x?: any) {    
    if (window.origami.settings.UseNewModalWindow) {
        openUrlPopup(url, this, x);        
    } else {
        if (!(typeof x != 'undefined' && x == "allowCrossClient"))
            url = appendTPAClientID(url);
        //Note: jqmShow() method below calls loadInIframeModal():
        if (jQuery().jqmShow)
            $("#modalWindow").jqmShow();
        $("#modalWindow iFrame").attr("src", url);
    }
}

function openUrlPopup(url, source, x?: any) {
    screenReaderMessage('Opening modal window within current window', true);
    let trigger = $(source);
    var modal = $('#or-modal-popup');

    if (beforeLoadModal && typeof beforeLoadModal === "function") {
        beforeLoadModal(trigger, modal, function () { finishLoadInIframeModal(null, trigger, null); });
    } else {
        finishLoadInIframeModal(null, trigger, null);
    }
    if (!(typeof x != 'undefined' && x == "allowCrossClient"))
        url = appendTPAClientID(url);

    ApplyModalSizingOptions(trigger, modal);

    if (url.length >= 2048 && !isFireFox()) {
        window.origami.message.openModalPost(url);
    } else if (url.length >= 2048 && isFireFox()) {
        console.error('FireFox does not handle a URL longer than 2048 characters.');
        alert('FireFox does not handle a URL longer than 2048 characters.');
    } else {
        window.origami.message.openModal(url);
    }
}

// If the triggering link has a modal sizing attribute, apply it to our modal
function ApplyModalSizingOptions(trigger, modal)
{
    let modalSmall = "modal-small";
    if (trigger.hasClass(modalSmall)) {
        modal.addClass(modalSmall);
    }
    else {
        modal.removeClass(modalSmall);
    }

    let modalMedium = "modal-medium";
    if (trigger.hasClass(modalMedium)) {
        modal.addClass(modalMedium);
    }
    else {
        modal.removeClass(modalMedium);
    }

    let modalLarge = "modal-large";
    if (trigger.hasClass(modalLarge)) {
        modal.addClass(modalLarge);
    }
    else {
        modal.removeClass(modalLarge);
    }
}

function isFireFox() {
    return navigator.userAgent.indexOf(' Firefox/') > -1
}

function attachLookupUrlModifier(lookupInput, func) {
    // check to see if this is a lookup
    if (!lookupInput.hasClass("inputLookup")) {
        console.log("lookupInput parameter is not a lookup control.");
        return;
    }

    var ctl = lookupInput.get(0);
    if (!ctl.hasOwnProperty('LookupUrlModifiers')) {
        ctl["LookupUrlModifiers"] = [];
    }

    var modifiers = ctl.LookupUrlModifiers;
    modifiers.push(func);
}

function triggerLookupUrlModifiers(lookupInput, url) {
    var ctl = lookupInput.get(0);
    if (!ctl.hasOwnProperty('LookupUrlModifiers'))
        return url;

    var modifiers = ctl.LookupUrlModifiers;
    if (modifiers==null || modifiers.length==0)
        return url;

    for (var i in modifiers) {
        var fn = modifiers[i];
        if (fn==null)
            continue;

        url = fn(url, lookupInput);
        if (url==null)
            return url;
    }

    return url;
}

//The .autocomplete we use "locks" in the param values when the control is initialized.
//We need to add any dynamic params prior to the control being initialized.
//This will check to see if the control that will become an auto complete control has the data attribute 
//that let's it know a function needs to be ran to obtain additional client-side parameters.
//function autoCompleteAddClientSideParams(autoCompleteInput) {
function lookupDataDashUrlModifiers(autoCompleteInput) {

    var input = $(autoCompleteInput);

    if (input && input.length > 0) {

        var moduleName = input.data('attachlookupurlmodifiermodule');
        var functionName = input.data('attachlookupurlmodifierfunction');

        if (moduleName && functionName) {
            // @ts-ignore: next line will use the window to find a module and execute a function in that module.
            //this will better keep specific implementations outside of this code.
            return window[moduleName][functionName]();
        }
    }

    return "";
};

var _currentLookupControl;
var beforeLoadModal: (trigger, modal, successCallback: () => void) => void;
var loadInIframeModal = function (hash) {
    var trigger = $(hash.t);
    var modal = $(hash.w);

    if (beforeLoadModal && typeof beforeLoadModal === "function") {
        beforeLoadModal(trigger, modal, function () { finishLoadInIframeModal(hash, trigger, modal); });
        return;
    } else {
        finishLoadInIframeModal(hash, trigger, modal);
    }
};

var finishLoadInIframeModal = function (hash, trigger, modal) {
    _currentLookupControl = null;

    $(window).on("beforeunload", checkForMinimizedPopup);

    if (trigger.hasClass("lookupImage")) {
        _currentLookupControl = trigger.prev().prev();
        var controlId = _currentLookupControl.attr("id");

        $('#jqmParams').val(controlId).trigger("change");
    }
    else if (trigger.hasClass("createNewRecordFromFormButton")) {
        _currentLookupControl = trigger.prev().prev().prev();
        var controlId = _currentLookupControl.attr("id");

        $('#jqmParams').val(controlId).trigger("change");
    }
    else if (trigger.hasClass("autofill")) {
        $('#jqmParams').val(trigger.attr("id"));
    }

    var myUrl = trigger.attr('href');

    if (_currentLookupControl != null && _currentLookupControl.hasClass("inputLookup")) {
        myUrl = triggerLookupUrlModifiers(_currentLookupControl, myUrl);

        var additionalParams = lookupDataDashUrlModifiers(_currentLookupControl);

        if (additionalParams) {
            myUrl = myUrl + additionalParams;
        }

        if (myUrl == null) {
            console.log('bailing out of popup...');

            if (hash) {
                hash.a = false; // needed so subsequent popups show
                hash.o.remove();
            }
            return false;
        }
    }

    myUrl = appendTPAClientID(myUrl);
    if (modal) {
        var modalContent = $("iframe", modal);
        modalContent.html('').attr('src', myUrl);
        positionAndShowModal(modal);
    }    

    if (getCurrentUserUsesAssistiveTechnology()) {
        makeUntabbable();
    }
};

var closeIframeModal = function (hash) {
    $(window).off("beforeunload", checkForMinimizedPopup);
    if (getCurrentUserUsesAssistiveTechnology())
        restoreTabbable();
    hash.w.hide();
    hash.o.remove();
    $("#modalWindow iFrame").attr("src", null);
    $("#helpHeaderHtml").hide();

    if (typeof(afterCloseIframeModal) === 'function')
        afterCloseIframeModal();
};

var checkForMinimizedPopup = function (e) {
    if ($('#minimizedModalWindow').is(':visible')){
        maximizeModal();
        return "Close Popups Before Leaving";
    }
}
//#endregion

//#region content area and ajax panels
function refreshSidePanels()
{
    ajaxLoadPanel($('div#secondaryContent div.inlineExternal').first(), true);
}

function refreshSidePanelsAndClosePopup() {
    hidePopup();
    refreshSidePanels();
}


function addSidePanel(panel) {
    $("#secondaryContent #shift").append(panel);
}

function refreshWidgetAjaxGrid(item) {
    ajaxLoadPanel($(item), true);
}

var panelLoadListeners = [];
var initLoadedListeners = [];

function addPanelLoadListener(fn) {
    panelLoadListeners.push(fn);
}

function addInitLoadedListener(fn) {
    initLoadedListeners.push(fn);
}

function notifyPanelLoaded(panel) {
    for (var i in panelLoadListeners) {
        var listener = panelLoadListeners[i];
        if (listener !== null && typeof listener === 'function') {
            listener(panel);
        }
    }
}

function notifyInitLoaded(subset) {

    for (var i in initLoadedListeners) {
        var listener = initLoadedListeners[i];
        if (listener !== null && typeof listener === 'function') {
            listener(subset);
        }
    }
}

function ajaxLoadPanel(panel, showLoading) {

    origami.startDelayLoad();

    var src = panel.data('origamiurl');

    if (src == null || src == '')
        return;

    if (src.substr(0, 2) == '~/') {
        src = getServerAppRoot() + src.substr(2);
    }

    src = appendTPAClientID(src);
    //console.log("Loading ajax panel: " + src);

    if (showLoading) {
        var loading = panel.data('loading-message');
        var loadingIcon = panel.data('loading-message-icon');
        if (loading != null && loading != '') {
            var icon = "<img src='/content/images/ajax_panel_loading.gif' class='inlineIcon'/> ";
            if (loadingIcon != null && loadingIcon != '')
                icon = loadingIcon;

            var loadingDiv = $("<div class='loading-message'>" + icon + loading.escapeHTML() + "</div>");

            panel.append(loadingDiv);
        }
    }

    var successMethod = function (response, status, xhr) {

        origami.runPanelCompletes(this);

		// Apply drag and drop reordering to reloaded grid if it has a UserControlledSequence (and thus is denoted as a drag and drop grid)
        if (typeof(gridHandleDroppedElement) === "function") {
            $(".dragAndDropGrid tbody").sortable({
                stop: gridHandleDroppedElement
            });
        }

        $(panel).data("load-status", status);
        if (status == "error") {
            if (xhr.status != 0) {
                var msg = "<div class='loading-error'>Error loading panel: " + xhr.status + " " + xhr.statusText + "</div>";
                panel.html(msg);
            }
        }
        else {
            initLoaded(this);
            notifyPanelLoaded(this);
        }

        if (origami && origami.evaluateFormExpressions) {
            $("div.origamiform").each(function () {
                origami.evaluateFormExpressions($(this));
            });
        }

        //This will be specific to editableGrids that are reloaded and use the ajax functionality
        //In some cases we need to totally reload an EditableGrid when a records is added, modified, or deleted.
        //For example, Involved Parties has an stored procedure that runs and recalculates things that are displayed in the grid.
        //In a case like this the entire grid will be reloaded to show the newest calculations. 
        //Since the panel is reloaded from an ajax call we need to reinitialize the chosen jquery plug-in
        //Historically it doesn't appear that the chosen controls are integrated into the editableGrids
        //To prevent ripple effects into other areas (standard code, custom code, custom pages, ..) we will specifically only perform this initialization 
        //for editableGrids that have the <tr class='editablegridnewrow'
        //editablegridnewrow is the first row that is shown in the editableGrid that allows the user to enter a new record into the grid.
        $(".chosen-select").each(function (index, element) {
            var tableRow = $(element).closest('tr');
            if ($(tableRow).length && $(tableRow).hasClass('editablegridnewrow')) {
                //in this scenario we only want to initialize the chosen jquery plugin for editablegridnewrow when the page reloads.
                (<any>$(element)).chosen({
                    placeholder_text_multiple: "Select all that apply",
                    no_results_text: "No results match",
                    width: "250px",
                    search_contains: true,
                    single_backstroke_delete: false
                });
            }
        });

        origami.completeDelayLoad();
    };

    if (typeof (ajaxGridPost) !== 'undefined' && ajaxGridPost !== null && ajaxGridPost === true
        && (src.indexOf('viewFilter') !== -1 || src.indexOf('filter') !== -1)) {

        // Parse querystring formatted parameters into a JSON object, to trigger jQuery's .load method to use a POST instead of a GET call
        var queryStringIndex = src.indexOf('?');
        var url = src.substr(0, queryStringIndex);
        if (url == "") // should never occur, but just in case
            url = src;

        var queryString = src.substr(queryStringIndex + 1, src.length - queryStringIndex - 1);

        var params = {};

        if (typeof (URLSearchParams) === 'undefined') { // In IE, some older versions of other browsers
            params = parseParams(queryString);
        }
        else {
            var urlSearchParams = new URLSearchParams(queryString);
            urlSearchParams.forEach(function (value, key, parent) {
                params[key] = value;
            });
        }

        panel.load(url, params, successMethod); // Load content using POST
    }
    else {
        panel.load(src, successMethod); // Load content using GET
    }
}

function parseParams(str) {
    return str.split('&').reduce(function (params, param) {
        var paramSplit = param.split('=').map(function (value) {
            return decodeURIComponent(value.replace(/\+/g, ' '));
        });
        params[paramSplit[0]] = paramSplit[1];
        return params;
    }, {});
}

function isInSidePanel(panel) {
    var side = $(panel).closest("#secondaryContent");
    return side.length > 0;
}

function appendTPAClientID(url) {
    var tpaClientID = getTPAClientID();
    if (tpaClientID == null || tpaClientID == '')
        return url;

    if (url == null || typeof url === 'undefined' || url.trim().length==0)
        return url;

    if (url.toLowerCase().indexOf('_tpaclientid=') > -1)
        return url;

    return insertParameterToUrl(url, '_tpaclientid', tpaClientID);
}

function refreshIndexGrid() {
    var container = $("#_IndexRefreshContainer");
    if (container.length == 0)
        return;

    var url = window.location + " #_IndexRefreshContent";
    $("#_IndexRefreshContainer").on('load', url, function () {
        initLoaded(container);
    });
}

function refreshAjaxGridByClassName(className) {
    var count = refreshPartials(className);

    if (count == 0) {
        // nothing to refresh, then just reload the page
        // show the status message after reload so that reloading doesn't inadvertently hide it
        var messageHtml = $("#message:not(.hidden)").data("messageHtml");
        var messageStyle = $("#message").attr("class");
        if(messageHtml)
            nextStatusMessageHtml(messageStyle, messageHtml);
        window.location.reload();
    }
}

function fullyRefreshCardsAndParentAjaxGridByClassName(className,id) {
    
    //If this is called then the user created a contact, employee, location, territory outside the normal flow from within a CARD.
    //we will add the new card using the domain and primary key that was returned

    //then refresh all the cards within the UI and all the grids that deal with this className/domain

    // @ts-ignore: next line will use the editableCard module which should be loaded since we are working with cards in this case.
    editableCard.ipCallBackSaveAndRefreshCards(id);
}


function initLoaded(container) {
    initializeAll(container);

    if (!window.origami.settings.UseNewModalWindow && jQuery().jqmAddTrigger) {
        $('a.thickbox, .lookupImage, img.thickbox, button.thickbox', container).each(function () {
            $('#modalWindow').jqmAddTrigger(this);
        });
    }
};

function refreshPartials(domain) {
    if (!domain)
        return;

    var count = 0;
    $("div.inlineExternal,div.ajaxGrid").each(function () {
        var refresh = $(this).data("refresh-domain");
        // Fix for JIRA #15404, only for custom entities 
        if (domain.startsWith("custom_")) {
            domain = domain.replace("custom_", "Custom.");
        }

        var domainName = domain.toLowerCase();

        if (refresh == null)
            return;

        var refreshDomains = refresh.toLowerCase().split(',');
        if ($.inArray(domainName, refreshDomains) == -1)
            return;

        count++;
        ajaxLoadPanel($(this), false);
    });

    $(".cardViewPanel").each(function () {

        //loop through each card view panel and make sure they are refreshed in case any information has changes since it was initially shown.
        var parentDomainID = $(this).data("parentdomainid");
        var parentDomainPrimaryKeyName = $(this).data("parentdomainprimarykeyname");
        var parentDomainPrimaryKeyValue = $(this).data("parentdomainprimarykeyvalue");
        var cardViewPanelGuidId = $(this).data("cardviewpanelguidid");
        if(parentDomainID && parentDomainPrimaryKeyName && parentDomainPrimaryKeyValue && cardViewPanelGuidId){
            
           // @ts-ignore: next line will use the editableCard module which should be loaded since we are working with cards in this case.
            if(editableCard){
                count++;
                // @ts-ignore: next line will use the editableCard module which should be loaded since we are working with cards in this case.
                editableCard.fullyRefreshCards(parentDomainID, parentDomainPrimaryKeyName, parentDomainPrimaryKeyValue, cardViewPanelGuidId);
            }
        }
    }); //end looping through all card view panels

    $("div.tabbedGrids").each(function () {
        var refresh = $(this).data("refresh-domains");
        // Fix for JIRA #15404, only for custom entities 
        if (domain.startsWith("custom_")) {
            domain = domain.replace("custom_", "Custom.");
        }

        var domainName = domain.toLowerCase();

        if (refresh == null)
            return;

        var refreshDomains = refresh.toLowerCase().split(',');
        if ($.inArray(domainName, refreshDomains) == -1 && $(this).attr('id').toLowerCase() != domainName)
            return;

        count++;
        ajaxLoadPanel($(this), false);
    });


    return count;
}
//#endregion

//#region grid actions
var afterJsonDeleteAction = null;
var clearRowAfterJsonDelete = true;

function doJsonDeleteAction(clickedObject, action, confirmMessage) {
    clearStatusMessage();

    if ((confirmMessage != undefined) && (confirmMessage != null) && (confirmMessage.length != 0))
        if (!confirm(confirmMessage))
            return;

    var row = $(clickedObject).closest("tr");
    var prefix;

    if (action.indexOf("?") > 0)
        prefix = "&";
    else
        prefix = "?";

    $.post(action + prefix + "json=true", AddAntiForgeryToken({}),
        function (data) {
            if (data.status == "success") {
                var didRefreshPartials = false;
                if (clearRowAfterJsonDelete)
                    row.hide('fast', function () {
                        row.remove();
                        // re-evaluate the form expression if refreshPartials didn't reload the panel
                        if (!didRefreshPartials) {
                            if (origami && origami.evaluateFormExpressions) {
                                $("div.origamiform").each(function () {
                                    origami.evaluateFormExpressions($(this));
                                });
                            }
                        }
                    });

                var table = $(row).closest("table");
                if (table.length) {
                    var domain = table.data("origamidomain");
                    if (domain != null) {
                        var refreshCount = refreshPartials(domain);
                        didRefreshPartials = refreshCount > 0;
                    }
                }

                if (afterJsonDeleteAction != null && typeof afterJsonDeleteAction == 'function')
                    afterJsonDeleteAction(table, row);
            }
            else if (data.status == "fail") {
                statusErrorMessage(data.message);
                window.scrollTo(0, 0);
            }
        });
}

function postJsonActionWithRedirect(action, confirmMessage) {
    if ((confirmMessage != undefined) && (confirmMessage != null) && (confirmMessage.length != 0))
        if (!confirm(confirmMessage))
            return;

    $.post(action, AddAntiForgeryToken({}),
        function (data) {
            if (data.status == "success") {
                window.location = data.redirectAction;
            }
            else if (data.status == "fail") {
                statusErrorMessage(data.message);
            }
        });
}
//#endregion


//#region multiselect lists
var _listsForGrid = '';
var _currentMultiSelectList = null;
var _simpleMultiSelectList = [];
var _selectedDescriptions = [];
var _lockedMultiSelectList = [];

function initializeGridLists(gridName, preSelectedIDs, lockedIDs = []) {
    if (_listsForGrid != gridName) {
        _listsForGrid = gridName;
        //_currentMultiSelectList = null;
        _simpleMultiSelectList = preSelectedIDs;
        _lockedMultiSelectList = lockedIDs;
    }
    else if (_simpleMultiSelectList !== preSelectedIDs || _lockedMultiSelectList !== lockedIDs) {
        _simpleMultiSelectList = preSelectedIDs;
        _lockedMultiSelectList = lockedIDs;
    }
}

function isInMultiSelectList(key, list) {
    if (list === undefined || list == null)
        list = _currentMultiSelectList;

    if (list == null){

        return (_simpleMultiSelectList.indexOf(key) >= 0);
    }

    var found = false;
    $("div.listitem", list).each(function () {
        if ($(this).data("value") == key)
            found = true;
    });

    return found;
}

function isInLockedMultiSelectList(key) {
    return (_lockedMultiSelectList.indexOf(key) >= 0);
}

function getAllLockedMultiSelectKeys() {
    return _lockedMultiSelectList;
}

function getMultiSelectKeys(list) {
    var result = [];

    if (list === undefined || list == null)
        list = _currentMultiSelectList;

    if (list == null)
        return _simpleMultiSelectList;

    $("div.listitem", list).each(function () {
        result.push($(this).data("value"));
    });

    return result;
}

// Note: This only works if the multiselect list is all shown on a single page
function reorderSinglePageMultiSelectList(movedKey, priorSelectedKey, list) {

    if (list === undefined || list == null)
        list = _currentMultiSelectList;

    if (list == null) {
        list = _simpleMultiSelectList;
    }

    if (priorSelectedKey == null)
        var idx = 0;
    else


        if (idx != 0) {
            removeMultiSelectItem(movedKey);
            idx = _simpleMultiSelectList.indexOf(priorSelectedKey) + 1;
        }
    _simpleMultiSelectList.splice(idx, 0, movedKey);
}

function addMultiSelectItem(key, description, list) {
    if (list === undefined || list == null)
        list = _currentMultiSelectList;

    if (list == null){
        if (!isInMultiSelectList(key, list)){
            _simpleMultiSelectList.push(key);
            _selectedDescriptions.push(description);
        }
        return;
    }

    if (isInMultiSelectList(key, list))
        return;

    var name = $(list).data("name");
    var div = $("<div class=\"listitem\" data-value=\"" + key + "\">" + description.escapeHTML() +
        "<img src=\"/content/images/small_delete.gif\" alt=\"Delete\" class=\"clickable\ deletelistitem\"/>" +
        "<input type=\"hidden\" name=\"" + name + "\" value=\"" + key + "\"/><div>");

    $(list).append(div);
    $(list).scrollTop($(list).scrollTop() + $(div).position().top);

    // attach the on-delete behavior
    $("img.deletelistitem", div).on("click", function () {
        $(this).closest("div.listitem").remove();
    });
}

function removeMultiSelectItem(key, list?) {
    if (list === undefined || list == null)
        list = _currentMultiSelectList;

    if (list == null){
        var idx = _simpleMultiSelectList.indexOf(key);
        if (idx >= 0){
            _simpleMultiSelectList.splice(idx, 1);
            _selectedDescriptions.splice(idx, 1);
        }
        return;
    }

    var item = null;
    $("div.listitem", list).each(function () {
        if ($(this).data("value") == key)
            item = $(this);
    });

    if (item != null)
        $(item).remove();
}

function clearBulkActionSelections() {
    var url = window.frames[0].location.href
    if (url.includes("BulkAction")) {
        _simpleMultiSelectList = [];
        _selectedDescriptions = [];
    }
}

function initGridCollapseColumns(subset)
{
    var showMore = function (e) {
        $(e.currentTarget).parent().addClass('hidden');
        $(e.currentTarget).parent().next().removeClass('hidden').find('a.showLessGridColumn').attr("aria-expanded", "true").focus();
        e.preventDefault();
    }

    var showLess = function (e) {
        $(e.currentTarget).parent().addClass('hidden');
        $(e.currentTarget).parent().prev().removeClass('hidden').find('a.showMoreGridColumn').attr("aria-expanded", "false").focus();
        e.preventDefault();
    }

    //listening keydown on space bar is necessary for accessibility
    $(subset).find('a.showMoreGridColumn').click(showMore).keydown(function (e) { if (e.which == 32) showMore(e) });
    $(subset).find('a.showLessGridColumn').click(showLess).keydown(function (e) { if (e.which == 32) showLess(e) });
}

// see grouping logic in GridBase
function initGridGroupExpandCollapse(subset) {
    $(subset).find("button.grid-group-toggle").on("click", function (this) {

        const $button = $(this);

        const shouldCollapse: boolean = !$button.data("inactive");
        const $groupRows = $button.closest("tr.group-header").nextUntil("tr.group-header");

        if (shouldCollapse) {
            $groupRows.hide();
        }
        else {
            $groupRows.show();
        }

        $button.html($button.data(shouldCollapse ? "inactive-icon" : "active-icon"));
        $button.data("inactive", shouldCollapse);

        if (pager_marker) {
            // reset sticky grid footer, because grid size might have changed
            stickyPagerBar();
        }
    });
}

function initMultiSelects(subset) {
    $("div.multiselectlookuplist", subset).each(function () {
        var initial = $(this).data("initialvalues");

        if (initial != null && initial.length > 0) {
            var keys = eval(initial);
            for (var i in keys) {
                var code = keys[i];
                addMultiSelectItem(code.Key, code.Description, this);
            }
        }
    });

    $("div.multiselectlookuplist div.listitem img.deletelistitem", subset).on("click", function () {
        $(this).closest("div.listitem").remove();
    });

    $("input.multiselectadderid:hidden", subset).on("change", function () {

        var input = $("input.inputLookup", $(this).closest("div.adder"));

        var key = $(this).val();
        if (key == null || key.trim().length == 0) {
            return;
        }

        var text = $(input).val();

        var list = $("div.multiselectlookuplist", $(this).closest("div.multiselectlookup"));
        addMultiSelectItem(key, text, list);

        $(this).val("");
        $(input).val("");

        $(input).trigger("focus");
    });
}

function doSearch(trigger, url) {

    console.log('Search URL: ' + url);

    if (trigger) {
        var inline = $(trigger).closest("div.inlineExternal");
        if (inline.length > 0) {

            inline.data("origamiurl", url);
            ajaxLoadPanel(inline, false);
            return;

        }
    }

    window.location = url;
}

//#endregion

var csrfHrefCalled = false;

function handlePostActionLinks(subset) {
    $(".postAction[onclick]", subset).each(function (k, t) {
        var onclickAttr = $(this).attr("onclick");
        $(t).attr("onclick", null);
        $(t).attr("data-onclick", onclickAttr);
    });

    $(".postAction", subset).on('click',function (event) {
        event.stopImmediatePropagation();
        event.preventDefault();
        event.stopPropagation();
        var onclickAttr = $(this).attr("data-onclick");
        if (typeof onclickAttr != 'undefined' && onclickAttr != '') {
            var onclickFunc = new Function(onclickAttr);
            if (onclickFunc.call(this) === false)
                return false;
        }

        if (!csrfHrefCalled)
            postCRSFHref($(this).attr("href"));
        return false;
    });
}

function postCRSFHref(href) {
    csrfHrefCalled = true;
    var cloneInput = $("#_csrfPostForm > input[name='__AjaxRequestVerificationToken']").clone();

    $(cloneInput).attr("name", "__RequestVerificationToken");

    var form;
    form = $('<form />', {
        action: href,
        method: "post",
        style: 'display: none;'
    });

    $(cloneInput).appendTo(form);
    form.appendTo('body').trigger("submit");
}

function initializeAll(subset) {

    try {

        handlePostActionLinks(subset);

        handleTextAreaCarriageReturns();

        handleTextAreaMaxLength();

        initMultiSelects(subset);

        initGridCollapseColumns(subset);

        initGridGroupExpandCollapse(subset);

        $("div.origamiformidentifier[data-formrepoids]", subset).each(function () {
            var repoids = $(this).attr("data-formrepoids");
            var allids = repoids.split(",");
            if (allids == null || allids.length == 0)
                return;

            var baseUrl = window.location.origin + getServerAppRoot();
            var formsUrl = baseUrl + "Forms/ViewByRepoID?repoID=";

            if (allids.length == 1) {
                console.log("Form Definition RepoID: " + allids[0] + " -> " + formsUrl + encodeURIComponent(allids[0]));
            }
            else if (allids.length > 1) {
                console.log("Form Definition RepoIDs:");
                for (var i in allids) {
                    console.log("  " + allids[i] + " -> " + formsUrl + encodeURIComponent(allids[i]));
                }
            }
        });

        $("input.formCheckbox", subset).on("change", function () {

            $(this).next().val($(this).prop("checked") ? "True" : "False").trigger("change");

        });

        $("a.thumbnail-preview, span.thumbnail-preview", subset).each(function () {
            var myThis: any = $(this)[0];
            var ThumbnailHoverConfig =
            {
                sensitivity: 3, // number = sensitivity threshold (must be 1 or higher)
                interval: 500, // number = milliseconds for onMouseOver polling interval
                timeout: 0, // number = milliseconds delay before onMouseOut
                over: function (e) {
                    myThis.t = myThis.title;
                    myThis.title = "";
                    var xOffset = 30;
                    var yOffset = 30;
                    var maxWidth = 400;
                    var xInitial;
                    var caption = (myThis.t != "") ? "<br/>" + myThis.t : "";
                    $("body").append("<div id='thumbpreview'><img alt='Image preview' />" + caption + "</div>");

                    if (e.pageX > ($(window).width() / 2))
                        xInitial = e.pageX - $("#thumbpreview").width() - xOffset;
                    else
                        xInitial = e.pageX + xOffset;

                    $("#thumbpreview")
                        .css("top", (e.pageY - yOffset) + "px")
                        .css("left", (xInitial) + "px")
                        .fadeIn("slow");

                    $("#thumbpreview img").attr('src', $(myThis).data('src'));

                    //attach event handler
                    $("#thumbpreview img").on('load', function () {
                        var windowBottom = $(window).scrollTop() + $(window).height();
                        var windowRight = $(window).width();
                        var imgHeight = $(this).height();
                        var imgWidth = $(this).width();
                        var imgTop = $(this).offset().top;
                        var imgLeft = $(this).offset().left;

                        if ((imgTop + imgHeight) > windowBottom - 75) {
                            $("#thumbpreview")
                                .css("top", (windowBottom - imgHeight - 75) + "px");
                        }
                        if ((imgLeft + imgWidth) > windowRight - 300) {
                            $("#thumbpreview")
                                .css("left", (e.pageX - imgWidth - xOffset) + "px");
                        }
                    });

                },
                out: function () {
                    myThis.title = myThis.t;
                    $("#thumbpreview").remove();
                }
            }

            $(this).hoverIntent(ThumbnailHoverConfig);
        });

        const measureSpan = $("<span></span>", { "class": "pageNumber-measure" }).appendTo($("div.pager"));
        const pageNumberInput = $("div.pager input.pageNumber", subset);
        const syncWidth = () => {
            $(measureSpan).html(pageNumberInput.val());
            pageNumberInput.width(`${measureSpan.width()}px`);
        };
        syncWidth(); // make sure the width is adjusted when page is loaded
        pageNumberInput.on('keyup', function (event) {

            if (event.keyCode == 13) {
                var newPage = $(this).val();
                var pageCount = $(this).data("pagecount");
                if ((pageCount > 0 && newPage > pageCount) || newPage <= 0) {
                    alert("Invalid Page entry.");
                    return false;
                }
                var url = $(this).data("src").replace("page={pageN}", "page=" + newPage);
                window.location = url;
            }
            else { // allow the width of the pageNumber input field to dynamically adjust
                syncWidth();
            }
        });

        if (jQuery().qtip) {
            $("a.jTipAjax", subset).each(function () {
                $(this).qtip({
                    content: {
                        text: 'Loading...',
                        ajax: {
                            url: $(this).attr('rel')
                        },
                        title: {
                            text: $(this).attr('name')
                        }
                    },
                    position: {
                        my: 'left center',
                        at: 'right center',
                        viewport: $(window),
                        effect: false
                    },
                    style: {
                        classes: 'qtip-origami ' + $(this).data('tooltipstyle')
                    }
                })
            });

            $("a.jTipInline", subset).each(function () {
                var style = $(this).data('tooltipstyle');
                if (style != '' && style != null && style != undefined)
                    style = ' ' + style;
                else
                    style = '';

                $(this).qtip({
                    content: {
                        text: $("div.tooltipcontent", this).text(),
                        title: {
                            text: $(this).attr('name')
                        }
                    },
                    position: {
                        my: 'left center',
                        at: 'right center',
                        viewport: $(window),
                        effect: false
                    },
                    style: {
                        classes: 'qtip-origami' + style
                    }
                })
            });
        }

        $("a.cancelPopup", subset).on('click', function () {
            var searchParams = new URLSearchParams(window.location.search);

            TryHideParentPopup();
        });

        $(".linkIcon").on('click',function () {
            var href: any = $(this).attr("href");
            if (href != null && href.length > 0) {
                if ($(this).hasClass("thickbox")) {
                    openThickboxPopup(href);
                } else {
                    window.location = href;
                }
            }
        });

        $('button.search', subset).each(function () {
            var divId = $(this).data('divid');
            if (divId == undefined || divId == null)
                return;

            var button = $(this);

            $(this).closest("#" + divId).find(":input").on("keydown", function (event) {
                if (event.keyCode == 13) {
                    event.preventDefault();
                    button.trigger("click");
                }
            });
        });

        $('button.clearSearch', subset).on('click',function () {

            var divId = $(this).data('divid');
            if (divId == undefined || divId == null)
                return;

            // Clear the hidden inputs for the multi-select searches
            $('input[type=hidden][name^=__multiselectsearch_]').each(function () {
                $(this).val('');
            });

            // Clear the checkboxes for the multi-select searches
            $('input[type=checkbox][name^=__multiselectsearch_]').each(function () {
                $(this).prop("checked", false);
            });

            // reset all values
            $(this).closest("#" + divId).find(":input:not(.constant,:button)").val("");

            $(this).closest("#" + divId).find(".chosen-select").val('').trigger("chosen:updated");
        });

        // popup menu
        $('button.menu', subset).one('click', openMenu);

        $('td.money', subset).each(function () {
            if (parseFloat(GetRawInvariantNumber($(this).text())) < 0) {
                $(this).addClass('red');
            }
        });

        $('td.link', subset).on("mouseenter", function () {
            $(this).addClass('highlight');
        }).on("mouseleave",
            function () {
                $(this).removeClass('highlight');
            }
        );

        //Search Control - Date Fields:
        $('input.searchInputDate:not(.inputDate)', subset).each(function () {
            applyDateInputMasking($(this));
        });

        $("input[type='text']", subset).addClass('textInput');

        $("input.socialsecurity", subset).maskedInput({ mask: "ssn" });

        $("input.socialsecurity_partial", subset).maskedInput({ mask: "ssn_partial" });
        $("input.socialsecurity_partial", subset).attr("placeholder", "9999");

        $("input.fein", subset).maskedInput({ mask: "fein" });

        $("span.passwordInputShow", subset).on('click',function () {
            var textField = $(this).closest("span.value").find('input[name]')[0];
            if (typeof textField == 'undefined')
                return;

            var showText = $(this).hasClass("faded");

            if (showText)
                $(textField).attr('type', 'text');
            else
                $(textField).attr('type', 'password');

            $(this).toggleClass("faded");
        });

        $('input.inputDate', subset).each(function () {
            //Don't add a date lookup button if the input field is read-only.  ORDEV-10718
            if (!$(this).attr("readOnly")) {
                initializeDateControl(this);
            }
        });

        $('input.integerPicker', subset).each(function () {
            initializeIntegerSpinnerControl(this);
        });

        $(".ui-datepicker-trigger").each(function () {
            $(this).attr('aria-label', 'Click to select date from calendar');
            $(this).attr('title', 'Click to select date from calendar');
        });

        $('input.relativeDatePicker', subset).each(function () {
            initializeRelativeDatePicker(this);
        });

        // ensure that maskedInput function is loaded
        if (typeof initMaskedInput == 'function') {
            $('input.masked', subset).maskedInput();
            $('input.maskedDecimal', subset).each(function () { initializeDecimalControl(this) });
            $('input.maskedInteger', subset).each(function () { initializeIntegerControl(this) });
            $('input.maskedDigitsOnly', subset).each(function () { initializeDigitsOnlyControl(this) });
        }

		// Disable inputs (including buttons) in disabled li, but still allow unmasking of sensitive fields
        $("li.disabled :input:not(.sensitiveFieldButton)").attr("disabled", "disabled").addClass("locked");
        $("li.disabled .lookupImage").hide();
        $("li.disabled .createNewRecordFromFormButton").hide();
        $("li.disabled .ui-datepicker-trigger").hide();

        $('input.inputTime', subset).each(function () {
            initializeTimeControl(this);
        });

        $('input.inputTime24', subset).each(function () {
            initializeTime24Control(this);
        });

        $('input.inputLookup', subset).each(function () {
            initializeInputLookup(this);
        });

        $('#relativeDatePicker a', subset).on('click',function () {
            $(pickerCurrentInput).val($(this).attr("alt"));
            $(pickerCurrentInput).trigger("change");
            closePopup($("#relativeDatePicker"), null);
        });

        if ($.datepicker) {
            $('#relativeDatePicker_staticDate', subset).datepicker({
                changeMonth: true,
                changeYear: true,
                showOtherMonths: true,
                selectOtherMonths: true,
                beforeShowDay: isDateAvailable,
                yearRange: '-100:+30',
                onSelect: function (dateText) {
                    $(pickerCurrentInput).val(dateText);
                    $(pickerCurrentInput).trigger("change");
                    closePopup($("#relativeDatePicker"), null);
                }
            });
        }

        $('div.fieldPicker a', subset).on('click',function () {
            $(pickerCurrentInput).val($(this).attr("alt"));
        });

        $('div.inlineExternal', subset).each(function () {

            if ($(this).is('.hidden-saveAndContinue'))
                return;

            ajaxLoadPanel($(this), true);
        });

        $(".inlineAnchor", subset).on('click',function () {

            var url = $(this).data("origamiurl");
            if (url == null || url.trim().length == 0)
                return;

            var parent = $(this).closest("div.inlineExternal");
            if (parent.length == 0)
                return;

            parent.data("origamiurl", url);
            ajaxLoadPanel(parent, false);
        });

        $('div.collapseDetails div.collapseMarker:first', subset).each(function () { collapseDetails(this); });

        initializeExpanders(subset);

        initializeConfigurablePanels();

        //OUT OF OFFICE
        $('a.turnoffoutofficebanner', subset).on('click',function () {
            var url = getServerAppRoot() + "OutOfOfficeDetails/CloseOutOfOfficeFromBanner";
            $.get(url, function (data) {
                if (data.status == "fail") {
                    statusErrorMessage(data.message);
                } else {
                    $('div.outofoffice.message').hide();
                }
            });
        });

        //Save and Continue Button on Grid Panels
        $("button.saveAndContinueGridPanel", subset).on('click', function () {
            var autoAddDomain = null;
            var validateRequired = ($(this).hasClass("validateRequired"));
            var applyValidations = ($(this).hasClass("applyValidations"));
            if ($(this).hasClass("autoAdd")) {
                autoAddDomain = $(this).data("domain");
            }

            if ($(this).hasClass("inlineSave"))
                saveAndContinueInline($(this), 'entryForm', validateRequired, applyValidations);
            else
                submitSaveAndContinue('entryForm', autoAddDomain, validateRequired, applyValidations);
        });

        $("ul.buttonGroup:not(.viewonly)", subset).each(function () {
            var fieldname = $(this).data("fieldname");
            if (fieldname == null)
                return;

            var inputctl = $(":hidden[name='" + fieldname + "']");
            var startval = inputctl.val();
            if (startval != "") {
                $('li[data-value="' + startval + '"]', this).addClass("selected");
            }

            $("li", this).on('click',function () {
                if ($(this).hasClass("selected")) {
                    $(this).removeClass("selected");
                    $(inputctl).val("").trigger("change");
                    return;
                }

                var ul = $(this).closest("ul");
                $("li", ul).removeClass("selected");

                $(this).addClass("selected");
                $(inputctl).val($(this).data("value")).trigger("change");
            });
        });

        $("div.image-slideshow", subset).each(function () {
            var images = $(".slide-image", this);
            if (images.length == 0)
                return;

            $(images).eq(0).addClass("active").show();

            var fadeInSeconds = $(this).data("fadeInSeconds");
            var retainSeconds = $(this).data("retainSeconds");

            if (fadeInSeconds == null)
                fadeInSeconds = 3;

            if (retainSeconds == null)
                retainSeconds = 5;

            var div = $(this);

            setInterval(function () { cycleSlideShow(div, fadeInSeconds * 1000) }, retainSeconds * 1000);
        });

        initSensitiveFields(subset);

        initializeToolTips(subset);

        initializeSignalRProxies();
    }
    catch (err) {
        console.error(err);
    }
    finally {
        notifyInitLoaded(subset);
    }
}

function cycleSlideShow(div, fadeIn) {

    var $active = $('.slide-image.active', div);
    var $next = ($active.next('.slide-image').length > 0) ? $active.next('.slide-image') : $('.slide-image', div).first();

    $next.css('z-index', 2).show();
    $active.fadeOut(fadeIn, function () {
        $active.css('z-index', 1).show().removeClass('active');
        $next.css('z-index', 3).addClass('active');
    });

}

function ieOrOldEdge() {
    return (document.documentMode || /Edge/.test(navigator.userAgent));
}

function initializeToolTips(subset) {

    var tippyDefaultOptions = {
        theme: (typeof getToolTipTheme === 'function' ? getToolTipTheme() : 'dark'),
        animateFill: false,
        interactive: true,
        placement: "top-start",
        a11y: (typeof getCurrentUserUsesAssistiveTechnology === 'function' ? getCurrentUserUsesAssistiveTechnology() : 0) == 1
    };

    var tippyAjaxDefaultOptions = {
        content: 'Loading...',
        animateFill: false,
        animation: 'fade',
        flipOnUpdate: true,
        a11y: (typeof getCurrentUserUsesAssistiveTechnology === 'function' ? getCurrentUserUsesAssistiveTechnology() : 0) == 1
    };

    $("[data-tippy-content]", subset).each(function () {
        var useOptions: any = tippyDefaultOptions;
        if (typeof $(this).attr('data-tippy-max-width') != 'undefined')
            useOptions.maxWidth = $(this).attr('data-tippy-max-width');

        if (ieOrOldEdge()) {
            if ($(this).parent('label[title]').length > 0)
                useOptions.placement = "right-start";
        }

        var thisTippy = tippy(this, useOptions);

        if (thisTippy) {
            thisTippy.props.onMount = function (instance) {
                shrinkTooltipIfNecessary(instance);
            }
        }
    });

    $("[data-tippy-image]", subset).each(function () {
        var useOptions: any = tippyDefaultOptions;
        var srcUrl = $(this).attr('data-tippy-image');
        var title = $(this).attr('data-title') || "";
        var maxWidth = $(this).attr('data-tippy-max-width') || "400px";
        var lightbox = $(this).is("[data-uselightbox]");

        useOptions.maxWidth = maxWidth;
        useOptions.placement = "left-end";
        useOptions.theme = "dark";
        useOptions.interactive = true;
        useOptions.delay = [500,0];

        var thisTippy = tippy(this, useOptions);
        if (thisTippy === undefined)
            return;

        thisTippy.props.onShow = function (instance) {
            if (instance.state.ajax === undefined) {
                instance.state.ajax = {
                    isFetching: false,
                    canFetch: true
                };
            }

            if (instance.state.ajax.isFetching || !instance.state.ajax.canFetch) {
                return;
            }

            const divThumbnail = document.createElement("div");
            divThumbnail.classList.add("tippy-image");
            divThumbnail.style.display = "block";

            const spanContainer = document.createElement("div");
            spanContainer.classList.add("tippy-filename-icon");
            spanContainer.innerHTML = "<i class=\"fas fa-spinner fa-pulse\"></i> " + title;
            spanContainer.style["padding-bottom"] = "4px";
            spanContainer.style["text-align"] = "center";
            spanContainer.style.display = "block";

            const imgContainer = document.createElement("div");
            imgContainer.style.display = 'block';

            const image = new Image()
            image.style["max-width"] = maxWidth;
            image.src = srcUrl;
            image.style["text-align"] = "center";
            image.style.display = "none";
            
            if(lightbox)
                image.title = "Click to show full screen";

            imgContainer.appendChild(image);

            divThumbnail.appendChild(spanContainer);
            divThumbnail.appendChild(imgContainer);

            instance.setContent(divThumbnail)

            $(image).on('load', function(){
                instance.state.ajax.isFetching = false;
                $(image).parent().siblings().find("i").remove();

                if(lightbox)
                {
                    $(image).addClass("clickable");
                    $(image).on('click',function() {
                        if(typeof instance.reference != 'undefined')
                        {
                            $(instance.reference).siblings("a[data-lightbox]").trigger("click");
                            instance.hide(300);
                        }
                    });
                }

                $(image).fadeIn(300);
            });
        };

        thisTippy.props.onHidden = function (instance) {
            instance.setContent('Loading...');
            instance.state.ajax.canFetch = true;
        };
    });

    $("[data-tippy-ajax-file]", subset).each(function () {

        var useOptions: any = tippyDefaultOptions;
        for (var attrname in tippyAjaxDefaultOptions) { useOptions[attrname] = tippyAjaxDefaultOptions[attrname]; }

        if (typeof $(this).attr('data-tippy-max-width') != 'undefined')
            useOptions.maxWidth = $(this).attr('data-tippy-max-width');

        var thisTippy = tippy(this, useOptions);


        try {

            thisTippy.props.onShow = function (instance) {
                if (instance.state.ajax === undefined) {
                    instance.state.ajax = {
                        isFetching: false,
                        canFetch: true
                    };
                }

                if (instance.state.ajax.isFetching || !instance.state.ajax.canFetch) {
                    return;
                }

                $.get($(instance.reference).attr('data-tippy-ajax-file'), function (data) {
                    instance.setContent(data);

                    if (data != null && data.includes("googleMap")) {
                        $("div.googleMap", instance.popper).each(function () {
                            initializeMap(this);
                        });
                    }

                    if (data != null && !data.includes("googleMap")) {
                        shrinkTooltipIfNecessary(instance);
                    }
                })
                    .always(function () {
                        instance.state.ajax.isFetching = false;
                    });
            };

            thisTippy.props.onHidden = function (instance) {
                instance.setContent('Loading...');
                instance.state.ajax.canFetch = true;
            };

        } catch (error) {
          //console.error(error);
          // expected output: ReferenceError: nonExistentFunction is not defined
          // Note - error messages will vary depending on browser
        }
    });
}

function initializeExpanders(subset) {

    $(subset).find('.expander.expanded img').not('.white').attr('src', '/Content/images/expanded-arrow-down.png');

    $(subset).find('.expander.expanded img.white').attr('src', '/Content/images/expanded-arrow-down-white.png');

    $(subset).find('.expander.collapsed img').not('.white').attr('src', '/Content/images/collapsed-arrow-right.png');

    $(subset).find('.expander.collapsed img.white').attr('src', '/Content/images/collapsed-arrow-right-white.png');

    $(subset).find('.expander.collapsed').each(function () {
        $(this).closest('.expand-section').siblings('.expand-content').hide();
    });

    $(subset).find('.expander').on('click', function () {
        return togglePanelExpander($(this));
    });
}

function togglePanelExpander(expander) {
    var hide = false;
    //If we're clicking somewhere in the div other than the element with the expanded/collapsed class on it, we don't trigger the expand/collapse.
    if (!expander.hasClass("expanded") && !expander.hasClass("collapsed")) {
        return;
    }
    if (expander.hasClass('expanded')) {
        hide = true;
    }

    if (hide == true) {
        expander.closest('.expand-section').siblings('.expand-content').slideUp('fast');
        expander.find('img').not('.white, .inlineIcon').attr('src', '/Content/images/collapsed-arrow-right.png');
        expander.find('img.white').attr('src', '/Content/images/collapsed-arrow-right-white.png');
        screenReaderMessage('Section collapsed', false);
    }
    else {
        expander.closest('.expand-section').siblings('.expand-content').slideDown('fast');
        expander.find('img').not('.white, .inlineIcon').attr('src', '/Content/images/expanded-arrow-down.png');
        expander.find('img.white').attr('src', '/Content/images/expanded-arrow-down-white.png');
        screenReaderMessage('Section expanded', false);
    }
    expander.toggleClass('expanded');
    expander.toggleClass('collapsed');
    return true;
}

function onPanelExpanderClick() {
    var hide = false;
    if ($(this).hasClass('expanded'))
        hide = true;

    var header = $(this).parent();
    var content = $(header).siblings();

    if (hide == true) {
        $(content).each(function () {
            $(this).slideUp('fast');
        });
        $(this).removeClass('expanded');
        $(this).addClass('collapsed');
        $(this).find('img').not('.white').attr('src', '/Content/images/collapsed-arrow-right.png');
        $(this).find('img.white').attr('src', '/Content/images/collapsed-arrow-right-white.png');
    }
    else {
        $(content).each(function () {
            $(this).slideDown('fast');
        });
        $(this).addClass('expanded');
        $(this).removeClass('collapsed');
        $(this).find('img').not('.white').attr('src', '/Content/images/expanded-arrow-down.png');
        $(this).find('img.white').attr('src', '/Content/images/expanded-arrow-down-white.png');
    }

    return true;
}

function initializeConfigurablePanels() {

    $(document).find('.expandable-panel').each(function () {
        if (!$(this).data("initialized") === true) {
            // get expandable panel header (assuming that the expandable-panel contains div.panel with an h3 as the title of the panel)
            var header = $(this).find('div.panel-contents > div.panel > h3').first();
            if (header.length === 0) {
                // check for lazy loading panel
                var lazyLoadedPanel = $(this).find('div.panel-contents > div.inlineExternal');
                if (lazyLoadedPanel.data("loadStatus") === "success") {
                    // if the panel has been loaded get the expandable panel header from the new contents
                    header = $(lazyLoadedPanel).find('div.panel > h3').first();
                }

                if (header.length === 0) return;
            }

            // prepare the header by adding an expander button next to it
            var initialState = $(this).data("initialState");

            var initialImgSrc = initialState === "collapsed" ? "/Content/images/collapsed-arrow-right.png" : "/Content/images/expanded-arrow-down.png";

            //Only add an expander if one doesn't already exist.  Some panels, like the BasicGridPanel may add their own expander based on panel-specific form definitions (ex: The GridPanel panelSortOrder Collapse attribute).  If it already exists, initialize the image and state, if necessary.
            var existingExpander = $(header).find("a.expander");
            if ($(existingExpander).length) {
                //If the existing expander has a different initial state than what it should have, change it here
                if (!$(existingExpander).hasClass(initialState)) {
                    $(existingExpander).removeClass("expanded");
                    $(existingExpander).removeClass("collapsed");
                    $(existingExpander).addClass(initialState);
                }
                $(existingExpander).find("img").attr("src", initialImgSrc)
            }
            else {
                var expanderButtonHtml = '<a class="expander ' + initialState + '" href="javascript:void(0)" aria-label="Click to expand and collapse section"  role="button"><img src="' + initialImgSrc + '" alt="Click to expand and collapse section" /></a>';
                header.prepend(expanderButtonHtml).find('.expander').on('click',onPanelExpanderClick);
            }

            // if the initial state of the expandable-panel is 'collapsed' then collapse each sibling to the header.  Otherwise, ensure they are shown.
            if (initialState === "collapsed") {
                var content = $(header).siblings();
                $(content).each(function () {
                    $(this).hide();
                });
            }
            else {
                var content = $(header).siblings();
                $(content).each(function () {
                    $(this).show();
                });
            }

            // identify the expandable-panel as initialized so it's not initialized again
            $(this).data("initialized", true);
        }
    });
}

function expandCollapsedPanelsWithRequiredFields(formID) {
    if ((formID === null) || (formID === undefined) || (formID === ''))
        return;

    $('#' + formID + ' a.expander.collapsed').each(function() {
       if ($(this).closest('.expand-section').siblings('.expand-content').find('li.required').length > 0) {
          $(this).find('img').not('.white').attr('src', '/Content/images/expanded-arrow-down.png');
          $(this).find('img.white').attr('src', '/Content/images/expanded-arrow-down-white.png');
          $(this).closest('.expand-section').siblings('.expand-content').show();
          $(this).toggleClass('expanded');
       }
    });
}

function expandTopLevelCollapsedPanels(formID) {
    if ((formID === null) || (formID === undefined) || (formID === ''))
        return;

    $('#' + formID + ' a.expander.collapsed.toplevel').each(function () {
        $(this).find('img').not('.white').attr('src', '/Content/images/expanded-arrow-down.png');
        $(this).find('img.white').attr('src', '/Content/images/expanded-arrow-down-white.png');
        $(this).closest('.expand-section').siblings('.expand-content').show();
        $(this).toggleClass('expanded');
    });
}

function resizeIframeIfNecessary() {

    if (window == window.top)
        return;

    if ($("div.jqmWindow").length == 0)
        return;

    $("div.jqmWindow").addClass("innerWindow");
}

// #region origami namespace 
var origami = origami = origami || {};

origami._pageCompletes = [];
origami._panelCompletes = [];
origami._delayLoadRefCount = 0;

origami.pageComplete = function(callback) {
    origami._pageCompletes.push(callback);
}

origami.panelComplete = function (callback) {
    origami._panelCompletes.push(callback);
}

origami.runPageCompletes = function () {
    for (var i in origami._pageCompletes)
        origami._pageCompletes[i]();
}

origami.runPanelCompletes = function (panel) {
    for (var i in origami._panelCompletes)
        origami._panelCompletes[i](panel);
}

origami.startDelayLoad = function() {
    origami._delayLoadRefCount++;
}

origami.completeDelayLoad = function () {
    origami._delayLoadRefCount--;
    if (origami._delayLoadRefCount <= 0)
        origami.runPageCompletes();
}

origami.createItemsArrayFromGridPanelTable = function (gridPanel) {
    return createItemsArrayFromGridPanelTable(gridPanel);
};
// #endregion 

function receiveMessage(event) {
    switch (event.data.type) {
        case "hidePopup":
            hidePopup();
            break;
        case "refreshAjaxGridByClassName":
            refreshAjaxGridByClassName(event.data.className);
            break;
        case "setLocation":
            window.location = event.data.location;
            break;
        case "reload":
            window.location.reload();
            break;
        case "setLookupValueForControl":
            setLookupValueForControl(event.data.controlID, event.data.id, event.data.description);
            break;
        case "setLookupValue":
            setLookupValue(event.data.id, event.data.description);
            break;
        case "setLookupValueMaintainPopup":
            setLookupValueWork(event.data.id, event.data.description);
            break;
        case "statusMessage":
            statusMessage(event.data.statustype, event.data.message);
            break;
        case "refreshSidePanels":
            refreshSidePanels();
            break;
        default:
            // to enable logging to console, run this in your browser's console: origami.debug = true
            if (origami.debug)
                console.log("Unhandled message type received."); 
            var evntLog = {};
            evntLog["isTrusted"] = event.isTrusted;
            evntLog["origin"] = event.origin;
            evntLog["data"] = event.data;
            if (origami.debug)
                console.log(evntLog);
            break;
    }
}

function TryMessageEventListener() {
    try
    {
        window.addEventListener("message", receiveMessage, false);
    }
    catch (e) {
        console.log('Unable to Add Event Listener: ' + e.Message);
    }
}

function modalVisible() {
    return $("#jqmContent").is(":visible");
}

function hideJqmModalClose() {
    $('#dialogclosebutton').addClass('hidden');
}

function showJqmModalClose() {
    $('#dialogclosebutton').removeClass('hidden');
}

var pageFullyInitialized = false;

$(function () {
    TryMessageEventListener();

    //adding this to map the css function to the depricated and removed jquery function curCSS that is used by other libraries
    jQuery.curCSS = jQuery.css;

    if ($("#_csrfPostForm input[name=__RequestVerificationToken]").length > 0) {
        $("#_csrfPostForm input[name=__RequestVerificationToken]").attr('name', '__AjaxRequestVerificationToken');
    }

    // do this first in case user clicks on links quickly
    updateBreadCrumbsWithIndexRequestLog();

    addInitLoadedListener(updateLinksWithSearchList);

    if ($.datepicker)
        $.datepicker.setDefaults({ shortYearCutoff: '+29' });

    resizeIframeIfNecessary();

    initGlobalSearch();

    origami.runPanelCompletes(window.document);
    initializeAll(this);

    if ($("#entryForm").length)
        setFormFocus("#entryForm", true);
    else if (!getCurrentUserUsesAssistiveTechnology())
        setFormFocus("#secondaryContent");
    //else
    //    setViewFocus("#hd");

    $('a.fullDetails').on("click", function () {
        var form = $(this).closest("div.collapseDetails");
        var marker = $("div.collapseMarker", form).first();
        var text = $(this).text();

        if (text == "Full Details") {
            if (!isCompatibleBrowser()) {
                $(marker).nextAll("div.panel").show();
            }
            else {
                $(marker).nextAll("div.panel").slideDown("fast");
            }

            $('#full-details-expader').removeClass('fa-chevron-circle-down').addClass('fa-chevron-circle-up');
            $(this).text("Hide Details");
        }
        else if (text == "Hide Details") {
            if (!isCompatibleBrowser()) {
                $(marker).nextAll("div.panel").hide();
            }
            else {
                $(marker).nextAll("div.panel").slideUp("fast");
            }

            $('#full-details-expader').removeClass('fa-chevron-circle-up').addClass('fa-chevron-circle-down');
            $(this).text("Full Details");
        }
    });

    $("#jqmParams").on("change", function () {
        _currentMultiSelectList = null;

        var id = $(this).val();
        if (id == null || id.trim().length == 0)
            return;

        var control = $("#" + id);
        if (!control.hasClass("multiselectadder"))
            return;

        _currentMultiSelectList = $("div.multiselectlookuplist", control.closest("div.multiselectlookup"));
    });

    lockTitleArea();
    lockPagerBar();
    InitFavoriteRecord();
    highlightTitleTab();

    decorateValidationErrorLinks();

    // if no ajax loading
    if ($("div.inlineExternal").length == 0)
        origami.runPageCompletes();

    $(function() {
        //This is the only script file we have with a nested ready function
        //This function will run after all other ready functions
        pageFullyInitialized = true;
    });
});

var globalSearchTimer;
var globalSearchMinKeyStrokes = 3;
var globalSearchSearchDelay = 750;
var globalSearchLoaderTag = "#globalSearchInputWrapper";
var globalSearchActiveDomains: Array<string> = [];

function initGlobalSearch() {
    if ($("#globalSearchWrapper").length == 0)
        return;

    document.addEventListener('click', function (e) {
        var isGlobalSearch = (e.target as Element).closest("#globalSearchWrapper") != null;
        if (isGlobalSearch) {
            if (!(e.target as Element).closest("#globalSearchWrapper").classList.contains("active")) {
                activateGlobalSearch();
            }
        }
        else {
            deactivateGlobalSearch();
        }
    });

    document.addEventListener("keyup", e => {
        if (isResponsiveMobileMode())
            return;

        if (e.key !== "/" || e.shiftKey || e.ctrlKey || e.metaKey) return;
        if (/^(?:input|textarea|select|button)$/i.test((e.target as HTMLInputElement).tagName)) return;

        if ($(e.target).hasClass("fr-element"))
            return;

        e.preventDefault();
        activateGlobalSearch();
    });

    document.addEventListener('keydown', function (e) {
        if (isResponsiveMobileMode())
            return;

        if (e.keyCode === 27) { // ESC
            deactivateGlobalSearch();
        }
    });

    $("#header_globalSearchInput").on("focus", function () {
        fetchGlobalSearchRecentDocs();
        activateGlobalSearch();
    });

    $('#header_globalSearchInput').on("keyup", function () {
        if (isResponsiveMobileMode())
            return;

        var searchValue = this.value;

        if (searchValue !== "") {
            showHideGlobalSearchAreaByID("recentdocs", true);
            showHideGlobalSearchAreaByID("searchall", false);
        }
        else {
            showHideGlobalSearchAreaByID("recentdocs", false);
            showHideGlobalSearchAreaByID("searchall", true);
            showHideGlobalSearchAreaByID("topmatches", true);
            showHideGlobalSearchAreaByID("nomatchfound", true);
        }

        if (searchValue.length >= globalSearchMinKeyStrokes) {

            if ($("#header_globalSearchInput").data("last-search-text") === searchValue) {
                return;
            }

            if (globalSearchTimer) {
                clearTimeout(globalSearchTimer);
            }
            globalSearchTimer = setTimeout(function () {
                $("#header_globalSearchInput").data("last-search-text", searchValue);
                showHideGlobalSearchAreaByID("topmatches", true);
                showHideGlobalSearchAreaByID("nomatchfound", true);

                var target = $("#globalSearch_quickresults #globalSearch_topmatches");
                markLoaderRunning($(globalSearchLoaderTag), "ld-ring", "ld-spin", "ld-ext-left");

                var quickSearchDomainNames = [];
                if ($("#header_globalSearchDomains").val() === "*") {
                    $("#header_globalSearchDomains option").each(function (k, elem) {
                        if ($(elem).attr("value") === "*")
                            return;

                        quickSearchDomainNames.push($(elem).val());
                    });
                }
                else
                    quickSearchDomainNames.push($("#header_globalSearchDomains").val());

                $("#globalSearchWrapper #globalSearch_quickresults #globalSearch_topmatches div.globalSearch_results[data-domain]").each(function (i, e) {
                    if (quickSearchDomainNames.indexOf($(e).attr("data-domain")) < 0)
                        $(e).remove();
                });

                globalSearchActiveDomains = quickSearchDomainNames;

                for (var i = 0; i < quickSearchDomainNames.length; i++) {
                    fetchGlobalQuickSearch(quickSearchDomainNames[i], quickSearchDomainNames.length);
                }

            }, globalSearchSearchDelay);
        }
    });
}

function showHideGlobalSearchAreaByID(idName: string, hide: boolean) {
    var selector = "#globalSearchWrapper #globalSearch_quickresults #globalSearch_" + idName;
    if (hide)
        $(selector).removeClass("active");
    else
        $(selector).addClass("active");
}

function deactivateGlobalSearch() {
    if ($("#globalSearchWrapper").length == 0)
        return;

    $("#header_globalSearchDomains").hide();
    document.getElementById("globalSearchWrapper").classList.remove("active");
    $("#globalSearchWrapper #globalSearch_quickresults").removeClass("active");
    $("#globalSearchWrapper #globalSearch_quickresults").attr('aria-expanded', 'false');
    $("#globalSearchWrapper #globalSearch_quickresults").attr('tabIndex', '-1');
    $(".quickresultlink").attr('tabIndex', '-1');
    $("#header_globalSearchDomains").attr('tabIndex', '-1');    

    $("#header_globalSearchInput").val("");
    $("#header_globalSearchInput").removeData();
    if ($("#header_globalSearchInput").is(":focus"))
        $("#header_globalSearchInput").trigger("blur");
    showHideGlobalSearchAreaByID("searchall", true);
    showHideGlobalSearchAreaByID("recentdocs", true);
    showHideGlobalSearchAreaByID("nomatchfound", true);
    showHideGlobalSearchAreaByID("topmatches", true);
    markLoaderStopped($(globalSearchLoaderTag));
}

function removeFromGlobalSearchActiveDomains(domainName: string) {
    globalSearchActiveDomains = globalSearchActiveDomains.filter(function (item) {
        return item !== domainName;
    });

    if (globalSearchActiveDomains.length == 0)
        markLoaderStopped($(globalSearchLoaderTag));

    if ($("#globalSearch_quickresults #globalSearch_topmatches div.globalSearch_results[data-domain]").length > 0) {
        showHideGlobalSearchAreaByID("topmatches", false);
        showHideGlobalSearchAreaByID("nomatchfound", true);
    }
    else {
        showHideGlobalSearchAreaByID("topmatches", true);
        showHideGlobalSearchAreaByID("nomatchfound", false);
    }
}

function activateGlobalSearch() {
    if ($("#globalSearchWrapper").length == 0)
        return;

    $("#header_globalSearchDomains").show();
    $("#globalSearchWrapper").addClass("active");
    $('#globalSearch_quickresults').attr('aria-expanded', 'true');
    $("#globalSearch_quickresults").attr('tabIndex', '0');
    $(".quickresultlink").attr('tabIndex', '0');
    $("#header_globalSearchDomains").attr('tabIndex', '0');
    document.getElementById("header_globalSearchInput").focus();
}

function fetchGlobalQuickSearch(domainName: string, numDomains: number) {
    var searchInput = $("#header_globalSearchInput").val();
    if (searchInput.length < globalSearchMinKeyStrokes) {
        removeFromGlobalSearchActiveDomains(domainName);
        return;
    }

    var quickSearchUrl = appendTPAClientID(getServerAppRoot() + "Search/QuickSearch");

    var reqData = {};
    reqData["domainName"] = domainName;
    reqData["filter"] = searchInput;
    reqData["numDomains"] = numDomains;

    $.ajax({
        type: 'GET',
        url: quickSearchUrl,
        dataType: 'json',
        data: reqData,
        async: true,
        success: function (result) {
            refreshGlobalSearchDomainResults(domainName, result);
        },
        error: function (xhr: any, status, error) {
            try {
                var err = eval("(" + xhr.responseText + ")");
                console.log(err);
            }
            catch {
                console.log(xhr.responseText);
            }
            removeFromGlobalSearchActiveDomains(domainName);
        }
    });
}

function refreshGlobalSearchDomainResults(domainName, result) {
    var mainTarget = $("#globalSearch_quickresults #globalSearch_topmatches");

    var domainSectionSelector = "#globalSearch_quickresults #globalSearch_topmatches div.globalSearch_results[data-domain='" + result.domainName + "']";

    var exists = $(domainSectionSelector).length > 0;

    if (exists && result.data.length == 0)
        $(domainSectionSelector).remove();

    if (result.data.length == 0) {
        removeFromGlobalSearchActiveDomains(domainName);
        return;
    }

    var topMatches = `<div class='globalSearch_resultTitle'>${result.domainDescription.escapeHTML()}</div><ul>`;
    for (var i = 0; i < result.data.length; i++) {
        var recentObj = result.data[i];
        var liItem = $("<li></li>");
        var linkItem = $("<a></a>");
        $(linkItem).html(`<div class="itemDescription">${recentObj.Value.escapeHTML()}</div>`);
        $(linkItem).attr("href", appendTPAClientID(getServerAppRoot() + result.controllerName +  "/View/" + recentObj.Key));
        $(liItem).prepend(linkItem);
        topMatches += $(liItem)[0].outerHTML;
    }
    topMatches += "</ul>";

    if (exists)
        $(domainSectionSelector).html(topMatches);
    else {
        mainTarget.append(`<div class="globalSearch_results" data-domain="${result.domainName}">${topMatches}</div>`);
    }
    removeFromGlobalSearchActiveDomains(domainName);
}

function fetchGlobalSearchRecentDocs() {
    if (isResponsiveMobileMode())
        return;

    if ($("#header_globalSearchInput").length == 0 || $("#header_globalSearchInput").val() !== "") {
        $("#globalSearchWrapper #globalSearch_quickresults #globalSearch_recentdocs").removeClass("active");
        return;
    }

    var recentDocsUrl = appendTPAClientID(getServerAppRoot() + "Search/GetRecentDocumentsAcrossDomains");
    var reqData = {};
    reqData["currURL"] = window.location.href;

    if (!$("#globalSearch_quickresults").hasClass("active"))
        $("#globalSearch_quickresults").addClass("active");

    if (!$("#globalSearch_recentdocs").hasClass("active"))
        $("#globalSearch_recentdocs").addClass("active");

    if ($("#globalSearch_recentdocs").hasClass("loaded"))
        return;

    $("#globalSearchWrapper #globalSearch_quickresults #globalSearch_recentdocs").prepend("<div class='globalSearch_resultTitle'>Recent Items</div><div class='globalSearch_results'></div>");
    $("#globalSearch_recentdocs").addClass("loaded");

    var target = $("#globalSearch_quickresults #globalSearch_recentdocs div.globalSearch_results");
    markLoaderRunning($(globalSearchLoaderTag), "ld-ring", "ld-spin", "ld-ext-left");

    $.ajax({
        type: 'GET',
        url: recentDocsUrl,
        dataType: 'json',
        data: reqData,
        async: true,
        success: function (result) {
            if (result.status == 'success') {
                console.log(result);
                var recents = "<ul>";
                for (var i = 0; i < result.data.length; i++) {
                    var recentObj = result.data[i];
                    var liItem = $("<li></li>");
                    var linkItem = $(`<a class="quickresultlink" tabIndex="-1"></a>`);
                    $(linkItem).html(`<div class="itemDescription">${recentObj.description.escapeHTML()}</div><div class="itemDomain faded">${recentObj.domainName.escapeHTML()}</div><div class="itemAccessed faded">${recentObj.lastAccessed.escapeHTML()}</div>`);
                    $(linkItem).attr("href", recentObj.actionLink);
                    $(liItem).prepend(linkItem);
                    recents += $(liItem)[0].outerHTML;
                }
                recents += "</ul>";
                $(target).prepend(recents);
                markLoaderStopped($(globalSearchLoaderTag));
            }
            else {
                console.log(result);
                markLoaderStopped($(globalSearchLoaderTag));
            }
        },
        error: function (xhr: any, status, error) {
            try {
                var err = eval("(" + xhr.responseText + ")");
                console.log(err);
            }
            catch {
                console.log(xhr.responseText);
            }
            markLoaderStopped($(globalSearchLoaderTag));
        }
    });
}

function decorateValidationErrorLinks() {
    $("ul.validationSummary span.fieldName").each(function (k, t) {
        var internalField = $(this).attr("for");
        var origLabel = $(this).text();

        var inputElement = null;

        if (typeof internalField !== "undefined" && internalField.length > 0)
            inputElement = $("li[for='" + internalField + "'] :input[id]");
        else
            inputElement = $("li[label='" + origLabel + "'] :input[id]");

        if (typeof inputElement === 'undefined' || inputElement === null || inputElement.length === 0) {
            if (typeof internalField !== "undefined" && internalField.length > 0) {
                var labelOnlyElement = $("li[for='" + internalField + "']");
                if (typeof labelOnlyElement !== "undefined" && labelOnlyElement.length > 0) {
                    if (labelOnlyElement.attr("label") !== "" && labelOnlyElement.attr("label") !== origLabel)
                        $(this).text(labelOnlyElement.attr("label"));
                }
            }
            return;
        }

        if ($(inputElement).is(":visible")) {
            var parentLi = $(inputElement).closest("li[label]");

            if (typeof parentLi !== "undefined" && parentLi.length > 0) {
                if (parentLi.attr("label") !== "" && parentLi.attr("label") !== origLabel)
                    $(this).text(parentLi.attr("label"));
            }

            if (!$(inputElement).hasClass("input-validation-error"))
                $(inputElement).addClass("input-validation-error");

            $(this).addClass("clickableunderline").attr("title", "Click to navigate to field on form").attr("onclick", "goToValidationErrorField(this);");
        }
    });
}

function goToValidationErrorField(element) {
    var internalField = $(element).attr("for");
    var origLabel = $(element).text();

    var inputElement = null;

    if (typeof internalField !== "undefined" && internalField.length > 0)
        inputElement = $("li[for='" + internalField + "'] :input[id]");
    else
        inputElement = $("li[label='" + origLabel + "'] :input[id]");

    if (typeof inputElement === 'undefined' || inputElement === null || inputElement.length === 0)
        return;

    if ($(inputElement).is(":visible")) {
        $(inputElement).trigger("focus");
    }
}

function InitFavoriteRecord()
{
    $(".FavoriteRecordStar").each(
        function () {
            //Favorite Records Icon Hover Handler
                $(this).on("mouseenter",
                    function () {
                        if ($(this).data("isfavorite") != "True")
                        {
                            $(this).addClass('fas');
                            $(this).removeClass('fal');
                            $(this).attr('aria-label', 'Click to remove from favorites');
                        }
                    }).on("mouseleave",
                    function () {
                        if ($(this).data("isfavorite") != "True")
                        {
                            $(this).addClass('fal');
                            $(this).removeClass('fas');
                            $(this).attr('aria-label', 'Click to remove from favorites');
                        }
                    }
                );

            //Favorite Records Click Handler
            $(this).on('click',function () {
                toggleFavorite(this);
            });

            $(this).on('keypress', function (e) {
                if (e.which == 13) {
                    toggleFavorite(this);
                }
            });
        });
}

function toggleFavorite(source) {
    var domainID = $(source).data("domainid");
    var recordID = $(source).data("recordid") || "0";
    var secondaryKey = $(source).data("secondarykey") || "";
    var isfavorite = $(source).data("isfavorite");
    var star = $(source);
    const url = getServerAppRoot() + getControllerName() + "/SetFavorite?domainID=" + domainID + "&recordID=" + recordID + "&secondaryKey=" + secondaryKey + "&isCurrentFavorite=" + isfavorite;
    $(source).prop('disabled', true);

    $.getJSON(url, function (data) {
        if (data.status == "success") {
            if (isfavorite == "True") {
                $(star).data("isfavorite", "False");
                $(star).addClass('fal');
                $(star).removeClass('fas');
                $(star).attr("title", "Click to add to My Favorites list.");
                screenReaderMessage('Dashboard removed from favorites', false);
            }
            else {
                $(star).data("isfavorite", "True");
                $(star).addClass('fas');
                $(star).removeClass('fal');
                $(star).attr("title", "Click to remove from My Favorites list.");
                screenReaderMessage('Dashboard added to favorites', false);
            }
            $(this).prop('disabled', false);
            $(star).trigger("origami.onfavoriterecordchange", { detail: { priorStatus: isfavorite } });
        } else {
            statusErrorMessage(data.message);
            $(this).prop('disabled', false);
        }
    });
}

// http://stackoverflow.com/questions/2830542/prevent-double-submission-of-forms-in-jquery
jQuery.fn.preventDoubleSubmission = function() {
  $(this).on('submit',function(e){
    var $form = $(this);

        if ($form.data('submitted') === true) {
            // Previously submitted - don't submit again
            e.preventDefault();
        } else {
            // Mark it so that the next submit can be ignored
            $form.data('submitted', true);
        }
    });

    // Keep chainability
    return this;
};

var _globalwindowloc = null;
function setWindowLocationOnce(url, postAction, includeQueryString = false) {
    if (_globalwindowloc == url)
        return;

    _globalwindowloc = url;

    if (includeQueryString) {
        // Get current query string values
        var queryString = window.location.search;
        if (queryString) {
            // Append query string to the action URL
            if (url.indexOf('?') === -1) {
                url += queryString;
            } else {
                url += '&' + queryString.substring(1);
            }
        }
    }

    if (typeof postAction != 'undefined' && postAction == 'true')
        postCRSFHref(url);
    else
        window.location = url;
}

function openChildWindow(windowName, options, url, useCookies) {
    var windowOptions;
    //explicitly use cookies and not options 
    if (useCookies && !options){
        var cookiePrefix = 'origami.' + windowName; 
        var left = getCookie(cookiePrefix + '.left');
        var top = getCookie(cookiePrefix + '.top');
        var width = getCookie(cookiePrefix + '.width');
        var height = getCookie(cookiePrefix + '.height');
        windowOptions = 'top=' + top + ', left=' + left + ', width=' + width + ', height=' + height;
        windowOptions += ', resizable=yes, location=no, scrollbars=yes';
    }
    else if (!useCookies && options){
        windowOptions = options;
    }
    var win = window.open(url, windowName, windowOptions);
    return win;
}

function eraseCookie(name) {
    writeCookie(name, "", -1);
}

function writeCookie (key, value, days?, isEssential = true) {
    var date = new Date();
    // Default at 365 days.
    days = days || 365;
    // Get unix milliseconds at current time plus number of days
    date.setTime(+ date + (days * 86400000)); //24 * 60 * 60 * 1000

    //to qualify for the "strictly necessary exemption" for essential cookies, we need to set them to be session-only length
    var expires = enableEssentialCookiesOnly && isEssential && days > 0 ? "" : date.toUTCString();
    var shouldSetCookie = !enableEssentialCookiesOnly || isEssential;

    if (shouldSetCookie)
        window.document.cookie = key + "=" + value + "; expires=" + expires + "; path=/";

    return value;
};

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
};

function skipNavigation() {
    setViewFocus("#page");
}

function skipToSecondaryContent() {
    setViewFocus("#secondaryContent");
}

function makeUntabbable() {

    $(':tabbable').each(function () {

        var tabbableElement = $(this).attr('id');

        if (tabbableElement !== "dialogclosebutton") {

            var index: any = $(this).attr('tabindex');
            if (index == null)
                index = 0;
            $(this).data('oldTabIndex', index);
            $(this).attr('tabindex', -1);
        }
    });
}

function restoreTabbable() {
    $(':focusable').each(function () {
        var index = $(this).data('oldTabIndex');
        if (index != null)
            $(this).attr('tabindex', index);
    });
}

function isCompatibleBrowser() {
    var ua = navigator.userAgent; // The use of userAgent is strongly discouraged since some browsers allow users to modify this value.
    if (String(ua).indexOf("Trident") != -1 ) { //IE does not support includes so I had to use indexOf. Trident is the unique identifyer of IE in the user Agent.
        return false;
    }
    return true;
}

function browserSupportsDragDrop() {
    return 'draggable' in document.createElement('div');
}

function setBetaUICookie(accountID, isEnabled) {
    if(isEnabled == true)
        writeCookie('origami.usingBetaUI.' + accountID, 'true', null, false);
    else
        writeCookie('origami.usingBetaUI.' + accountID, 'false', null, false);
    window.location.reload();
}

function setUnsupportedBrowserCookie(cookieName) {
    var nameOfCookie = cookieName || 'origami.usingOldIE';
    var canDragDrop = browserSupportsDragDrop();

    if (!canDragDrop || !isCompatibleBrowser() ) {
        writeCookie(nameOfCookie, 'true');
    } else {
        writeCookie(nameOfCookie, 'false');
    }
}

function isValidDate(dateString) {
    /// <summary>Determines if a date is properly formatted (dd/MM/yyyy) and a valid.</summary>
    /// <param name="dateString" type="String">The date to validate.</param>
    /// <returns type="Boolean">The validity of the date string.</returns>
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
        return false;

    var parts = dateString.split("/");
    var day = parseInt(parts[1], 10);
    var month = parseInt(parts[0], 10);
    var year = parseInt(parts[2], 10);

    if (year < 1000 || year > 3000 || month == 0 || month > 12)
        return false;

    var monthsDaysLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
        monthsDaysLength[1] = 29;

    return day > 0 && day <= monthsDaysLength[month - 1];
};

function formatFileSize(bytes) {
    var formattedSize = bytes;
    var suffix = ["B", "KB", "MB", "GB", "TB"];
    var i = 0;

    if (formattedSize > 1024.0) {
        for (i = 0; Math.floor(formattedSize / 1024) > 0; i++)
            formattedSize /= 1024;
    }

    if (suffix[i] == "B" || suffix[i] == "KB")
        return Math.trunc(formattedSize) + " " + suffix[i];
    else
        return formattedSize.toFixed(1) + " " + suffix[i];
}

//Helper Functions to Hide/Change Buttons or More Menu Items
function hideButtonByID(id) { $('button#' + id).hide(); }
function changeButtonTextByID(id,newText){$('button#' + id).text(newText);}
function hideMoreMenuItemByID(id){$('a#' + id).hide();}
function changeMoreMenuTextByID(id,newText){$('a#' + id).text(newText);}

//Additional selectors
$.extend($.expr.pseudos, {
    data: function (elem, i, match) {
        return !!$.data(elem, match[3]);
    },

    focusable: function (element) {
        var nodeName = element.nodeName.toLowerCase(),
            tabIndex = $.attr(element, 'tabindex');
        return (/input|select|textarea|button|object/.test(nodeName)
            ? !element.disabled
            : 'a' == nodeName || 'area' == nodeName
                ? element.href || !isNaN(tabIndex)
                : !isNaN(tabIndex))
            // the element and all of its ancestors must be visible
            // the browser may report that the area is hidden
            && !$(element)['area' == nodeName ? 'parents' : 'closest'](':hidden').length;
    },

    tabbable: function (element) {
        var tabIndex = $.attr(element, 'tabindex');
        return (isNaN(tabIndex) || tabIndex >= 0) && $(element).is(':focusable');
    }
});

function renameFormSet(renameFormSetCall, formSetName) {
    var newName = prompt("Please enter a new name for this form set.", formSetName);
    if (newName == null || newName.trim().length == 0)
        return;

    if (newName == formSetName)
        return;

    window.location.href = renameFormSetCall + "?newName=" + encodeURIComponent(newName);
}


function setHighChartsLanguage() {
    if (typeof Highcharts == 'undefined')
        return;

    Highcharts.setOptions({
        lang:
        {
            thousandsSep: UseGroupSeparator(),
            decimalPoint: UseDecimalSeparator()
        }
    });
}

function DynamicQueryList(domain, select, filter, sort, skip, take)
{
    if(take == null || take > 100)
        take = 100;

    var url = getServerAppRoot() + "Dynamic/JsonQuery";
    var retObj = {};
    
        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'json',
          data: {
          typeName: domain, 
          filter: filter,
          select: select,
          sort: sort,
          skip: skip,
          take: take
          },
          async: false,
          success: function(data) {
            if (data.status=="success") {
                retObj =  data.list;
            }
        }
    });
    return retObj;
}

function DynamicSingleRecordQuery(domain, select, filter)
{
    var url = getServerAppRoot() + "Dynamic/JsonQuerySingle";
    var retObj = {};
    
        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'json',
          data: {
          typeName: domain, 
          filter: filter,
          select: select
          },
          async: false,
          success: function(data) {
            if (data.status=="success") {
              retObj = data.model;
            }
        }
    });

    return retObj;

}

//SECTION - Helper Functions to Call REST and SOAP Web Services

function MakeExternalGetRequest(rootUrl, hostName, extraParams)
{
    var useUrl = rootUrl;
    if(typeof extraParams != 'undefined' && extraParams != null)
        useUrl += '?' + $.param(extraParams);

    var retObj = {};

    $.ajax({
        url: '/Origami/Dynamic/ExternalWebGetRequest',
        data: { url: useUrl, hostname: hostName },
        type: 'GET',
        async: false,
        dataType: 'json',
        success: function (data) {
            if (data.status == 'success')
                retObj = { status: 'success', data: data.response};
            else
            {
                var errMsg = "Unable to make external request. " + data.message;
                retObj = { status: 'failed', data: null, errorMessage: errMsg };
            }
        },
        error: function (xhr: any, status, error) {
            var err = eval("(" + xhr.responseText + ")");
            var errMsg = "Unable to make external request. " + err.Message;
            retObj = { status: 'failed', data: null, errorMessage: errMsg };
        }
    });

    return retObj;
}

function MakeExternalSOAPRequest(soapAction, hostName, parameters)
{
    var retObj = {};
    var JSONstr = '';

    if (typeof parameters != 'string' && parameters != null)
        JSONstr = JSON.stringify(parameters);
    else if(typeof parameters == 'string' && parameters != null)
        JSONstr = parameters;

    $.ajax({
        url: '/Origami/Dynamic/ExternalSOAPRequest',
        data: { soapAction: soapAction, hostName: hostName, parameters: JSONstr },
        type: 'GET',
        async: false,
        dataType: 'json',
        success: function (data) {
            if (data.status == 'success')
                retObj = { status: 'success', data: data.response};
            else
            {
                var errMsg = "Unable to make external request. " + data.message;
                retObj = { status: 'failed', data: null, errorMessage: errMsg, soapException: data.soapException };
            }
        },
        error: function (xhr, status, error) {
            var err = eval("(" + xhr.responseText + ")");
            var errMsg = "Unable to make external request. " + err.Message;
            retObj = { status: 'failed', data: null, errorMessage: errMsg };
        }
    });

    return retObj;
}

function MakeWebserviceLookupRequest(webserviceLookupID, parameters, headers, runValidateParams, callback) {
    var retObj = {};
    var JSONParams = '', JSONHeaders = '';

    if (typeof parameters != 'string' && parameters != null)
        JSONParams = JSON.stringify(parameters);
    else if (typeof parameters == 'string' && parameters != null)
        JSONParams = parameters;

    if (typeof headers != 'string' && headers != null)
        JSONHeaders = JSON.stringify(headers);
    else if (typeof headers == 'string' && headers != null)
        JSONHeaders = headers;

    $.ajax({
        url: '/Origami/Dynamic/ExternalWebserviceLookupRequest',
        data: { webserviceLookupID: webserviceLookupID, parameters: JSONParams, headers: JSONHeaders, runValidateParams: runValidateParams },
        type: 'GET',
        async: true,
        dataType: 'json',
        success: function (data) {
            var retObj;
            if (data.status == 'success')
                retObj = { status: 'success', data: data.response };
            else {
                var errMsg = "Unable to make external request. " + data.message;
                retObj = { status: 'failed', data: null, message: errMsg, errorMessage: errMsg };
                if (typeof data.soapException != 'undefined' && data.soapException != null)
                    retObj.soapException = data.soapException;
            }
            if (typeof callback == 'function' && callback != null)
                return callback(retObj);
            else
                return retObj;
        },
        error: function (xhr: any, status, error) {
            var err = eval("(" + xhr.responseText + ")");
            var errMsg = "Unable to make external request. " + err.Message;
            retObj = { status: 'failed', data: null, errorMessage: errMsg };
            if (typeof callback == 'function' && callback != null)
                return callback(retObj);
            else
                return retObj;
        }
    });
}

function MakeWebserviceLookupRequestWithProcessedResponse(webServiceLookupname, parameters, callback) {
    var retObj = {};
    var JSONParams = '';

    if (typeof parameters != 'string' && parameters != null)
        JSONParams = JSON.stringify(parameters);
    else if (typeof parameters == 'string' && parameters != null)
        JSONParams = parameters;

    $.ajax({
        url: '/Origami/Dynamic/ExternalWebserviceLookupRequestWithProcessedResponse',
        data: { webServiceLookupname: webServiceLookupname, parameters: JSONParams },
        type: 'GET',
        async: true,
        dataType: 'json',
        success: function (data) {
            var retObj;
            if (data.status == 'success')
                retObj = { status: 'success', data: data.response };
            else {
                var errMsg = "Unable to make external request. " + data.message;
                retObj = { status: 'failed', data: null, message: errMsg, errorMessage: errMsg };
                if (typeof data.soapException != 'undefined' && data.soapException != null)
                    retObj.soapException = data.soapException;
            }
            if (typeof callback == 'function' && callback != null)
                return callback(retObj);
            else
                return retObj;
        },
        error: function (xhr: any, status, error) {
            var err = eval("(" + xhr.responseText + ")");
            var errMsg = "Unable to make external request. " + err.Message;
            retObj = { status: 'failed', data: null, errorMessage: errMsg };
            if (typeof callback == 'function' && callback != null)
                return callback(retObj);
            else
                return retObj;
        }
    });
}
//END SECTION

function MakeSignalRTest(name, message) {
    $.ajax({
        url: '/Origami/Dynamic/SendMessageTest',
        data: { name: name, message: message },
        type: 'GET',
        async: true,
        dataType: 'json',
        success: function (data) {
            console.log(data);
        },
        error: function (xhr: any, status, error) {
            var err = eval("(" + xhr.responseText + ")");
            console.log(err);
        }
    });
}

//https://github.com/parshap/node-sanitize-filename/blob/master/index.js
function SanitizeFileName(input, replacement) {
    var illegalRe = /[\/\?<>\\:\*\|":]/g;
    var reservedRe = /^\.+$/;
    var windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
    var windowsTrailingRe = /[\. ]+$/;

    var sanitized = input
        .replace(illegalRe, replacement)
        .replace(reservedRe, replacement)
        .replace(windowsReservedRe, replacement)
        .replace(windowsTrailingRe, replacement);
    return sanitized;
}

function generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

// Checks if navigation type was not back, forward, or reload
//   PerformanceNavigationTiming.type is the type of navigation performed and "navigate" represents:
//   Navigation started by clicking a link, entering the URL in the browser's address bar, form submission,
//   or initializing through a script operation other than reload and back_forward.
//   https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming/type
function isNavigationTypeNavigate() {
    if (typeof performance !== "undefined" && typeof performance.getEntriesByType === "function") {
        var entries = performance.getEntriesByType("navigation");
        if (entries && entries.length === 1) {
            var navigationTimingEntry = entries[0] as PerformanceNavigationTiming;
            return navigationTimingEntry.type === "navigate";
        }
    }

    return true;
}

/*https://stackoverflow.com/a/6713917/6416369*/
(function($,undefined) {
    $.fn.cloneSelects = function(withDataAndEvents, deepWithDataAndEvents) {
        var $clone = this.clone(withDataAndEvents, deepWithDataAndEvents);
        var $origSelects = $('select', this);
        var $clonedSelects = $('select', $clone);
        $origSelects.each(function(i) {
            $clonedSelects.eq(i).val($(this).val());
        });
        return $clone;
    }
})(jQuery);

function stopEventPropagation(e) {
    var evt = e ? e:window.event;
    if (evt.stopPropagation)    
        evt.stopPropagation();
    if (evt.cancelBubble!=null) 
        evt.cancelBubble = true;
}

//session timeout and login
function timeoutAlert() {
    if (confirm("Your session is about to expire. Click OK to keep your session alive.")) {
        $.ajax({
            url: getServerAppRoot() + 'Account/Keepalive'
        })
            .done(function (response) {
                var extended = false;

                //if session not yet ended: 200 response is JSON (Object)
                //if session has ended: 302->200 response is HTML (String)
                if (response != null && response.constructor.name === "Object") {
                    if (response.status === "success") {
                        setTimeout(timeoutAlert, getTimeoutDuration());
                        extended = true;
                    }
                }

                if (!extended)
                    alert("Your session could not be extended and you will need to login again.");
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                alert("Your session could not be extended and you will need to login again.");
            });
    }
}

function isExpirationCookieValid() {
    var expirationString = getCookie('ori.SessionExpiration');
    if (typeof expirationString == 'undefined' || expirationString == null || expirationString == '')
        return false;

    var jsDate = new Date(expirationString);
    var currDate = new Date();
    //console.log('jsDate: ' + jsDate + ', currDate: ' + currDate + ', jsDate > currDate: ' + (jsDate > currDate));
    return jsDate > currDate;
}

function checkIsTimedOut(forceReathenticate: boolean = false) {
    if (!forceReathenticate && isExpirationCookieValid())
        return false;

    var checkUrl = getServerAppRoot() + "Account/CheckCookie";
    var isTimedout = false;

    if (forceReathenticate)
        checkUrl += "?forceReauthenticate=true";

    $.ajax({
        type: 'GET',
        url: checkUrl,
        dataType: 'json',
        data: {},
        async: false,
        success: function (data) {

            if (data.status == "success") {
                if (data.authenticated == "authenticated") {

                    // do nothing

                }
                else if (data.authenticated == "sso") {
                    isTimedout = true;

                    // open a new browser window instead of a thickbox to use
                    var relayUrl = getServerAppRoot() + "Account/TimeoutMessage?clientID=" + getCurrentClientID();

                    if (forceReathenticate) {
                        relayUrl = relayUrl + "&_closeAndRefresh=" + forceReathenticate + "&popup=true";
                        openThickboxPopup(relayUrl);
                    }
                    else
                        window.open(relayUrl, "Origami.TimeoutReturnPage", "toolbar=no, status=no, location=no");

                }
                else if (data.authenticated == "expired" && data.issilentlogin == "true") {
                    var relayUrl = getServerAppRoot() + "Account/Inactive";
                    window.open(relayUrl, "Origami.TimeoutReturnPage", "toolbar=no, status=no, location=no");
                }
                else {

                    isTimedout = true;
                    var timeoutUrl = getServerAppRoot() + "Account/TimeoutLogin?account=" +
                        encodeURIComponent(getCurrentAccountLogin()) + "&clientID=" + getCurrentClientID();

                    if (data.issuername != "")
                        timeoutUrl += "&issuerName=" + encodeURIComponent(data.issuername);

                    openThickboxPopup(timeoutUrl, "timeoutLogin");

                }
            }
        }
    });

    return isTimedout;
}

function handleOpenUrlPopup(event) {
    var url = $(this).attr('href');
    if (url === "#") {
        // empty anchor is not a valid argument for openUrlPopup
        return;
    }
    event.stopPropagation();
    if (url) {
        openUrlPopup(url, this, null);
    }
    return false;
}

$(document).ready(function () {

    var UNAUTHENTICATED = '_UNAUTHENTICATED_';

    $.ajaxSetup({
        dataFilter: function (data, type) {
            //if JSON response is HTML from login page make it valid JSON
            if (type === 'json' && data.indexOf('<!DOCTYPE html>') > -1) {
                return JSON.stringify({ 'status': UNAUTHENTICATED });
            }
            return data;
        }
    });

    $.ajaxPrefilter('json', function (options, originalOptions: any, jqXHR) {
        if (options.url !== getServerAppRoot() + 'Account/CheckCookie') {
            options.success = function (data) {
                //if valid JSON from login page redirect
                if (data && data.status === UNAUTHENTICATED) {
                    checkIsTimedOut();
                }
                else if (originalOptions.success != null) {
                    originalOptions.success(data);
                }
            };
        }
    });

    if (getCurrentUserUsesAssistiveTechnology() || getEnableTimeoutWarning()) {
        setTimeout(timeoutAlert, getTimeoutDuration());

        if (getCurrentUserUsesAssistiveTechnology())
            if (!$('#message').hasClass('hidden') && !$('#message').hasClass('notification'))
                alert($('#message').text());
    }

    $("a.downloadLink").on('click', function () {
        return !checkIsTimedOut();  // if timed out, cancel the download so the user can log in first.
    });

    if (!window.origami.settings.UseNewModalWindow && typeof $.jqm != 'undefined') {
        $('#modalWindow').jqm({
            modal: true,
            trigger: 'a.thickbox, .lookupImage, img.thickbox, button.thickbox, .createNewRecordFromFormButton',
            target: '#jqmContent',
            onShow: loadInIframeModal,
            onHide: closeIframeModal,
            toTop: true
        });
    } else {        
        $(document).on('click', 'a.thickbox, .lookupImage, img.thickbox, button.thickbox, .createNewRecordFromFormButton', handleOpenUrlPopup); 

        $('a.thickbox, .lookupImage, img.thickbox, button.thickbox, .createNewRecordFromFormButton').on('click', handleOpenUrlPopup);
    }

    $('#skipLink').click(function () {
        $('#content').find(':focusable').first().focus();
    });

    $('.selectnoneall').each(function () {
        setSelectAllStatus(this);
    });

    verifyAllAriaLabels();

    $('select').each(function () {
        addNoneSelected(this);
    });

    $('label.required').each(function (index) {
        let id = $(this).attr('for');
        if (id)
            $(`#${id}`).attr("aria-required", "true");
    });

    $(document).on('focus', '.menu, .signout', function () {
        deactivateGlobalSearch();
    });

    if (window.origami.settings.AppendColonToFormLabels) {
        $('label').each(function (index) {
            /* add a colon + space to the end of label text. This is needed by screen readers so they insert an audible gap between 
               words that appear within and after a label. Without these chars, the words blend together as though they are part of a
               contiguous sentence rather than separate caption/value fields. */
            try {
                let text = $(this).text().trim();
                if (text === '')
                    return;
                if (!text)
                    return;
                if (!text.match(/.*\w$/)) // do not add colon if last char in string is a special char like ?><:"{)...
                    return;
                if ($(this).parent()[0].localName !== 'li')
                    return;
                if ($(this).children().length > 0)
                    return;
                $(this).html(`${$(this).html()}:&nbsp;`);
            } catch {
            }
        });
    }    

    $(document).on('focus', ':focusable', function () {
        if ($(this).closest('#moreActionsMenu').length === 0)
            $('#moreActionsMenu').hide();
    });

    $(document).on('focus', ':focusable', function () {
        if ($(this).closest('div[id^="useraction"][id$="Menu"]').length === 0)
            $('div[id^="useraction"][id$="Menu"]').hide();
    });

    let message = $('#message').text();
    if (message)
        screenReaderMessage(message, false);

    afterResize();
});

function customMenuOnEvent(event, extraParameters) {
    try {
        var target = $(event.target);
        target.off("actionMenu.origami");
        event.stopPropagation();
    } catch (x) { }
}

function isWithinIframe() {
    if (window.parent && window.parent.document)
        return (window.parent !== window)
    return false;
}

$(window).resize(function () {
    afterResize();
});

function afterResize() {
    $('#responsive-spacing').height($('.titleArea').height() + 10);
}

function verifyAllAriaLabels() {
    $('input:not([aria-label])').each(function (index) {
        verifyAriaLabel(this);
    });

    $('select:not([aria-label])').each(function (index) {
        verifyAriaLabel(this);
    });

    $('textarea:not([aria-label])').each(function (index) {
        verifyAriaLabel(this);
    });
}

function verifyAriaLabel(element) {
    let id = $(element).attr('id');
    if (id) {
        /* we attempt to pull text from associated label because if the field is required, an asterisk is appended to the label. 
         * Screen readers read that askerisk. If we extract the text here, it does not pull the asterisk, so the asterisk 
         * is not read, which is what is expected. */
        let label = $(`label[for="${id}"]`);
        if (label.length == 1) {
            $(element).attr('aria-label', label.text());
            return;
        }
        $(element).attr('aria-label', id.toTitleCase());
        return;
    }
    let name = $(element).attr('name');
    if (name) {
        $(element).attr('aria-label', name.toTitleCase());
        return;
    }
}


function copyToClipBoard(triggerElement: any, content: string) {
    if (typeof content == 'undefined') {
        if ($(triggerElement).has('[data-clipboard-content]')) {
            content = $(triggerElement).attr('data-clipboard-content');
        }
    }

    var origTip = $(triggerElement).attr('data-tippy-content');

    if (content == null || content === '')
        return false;

    if (navigator.clipboard) {
        try {
            navigator.clipboard.writeText(content);

            if (typeof triggerElement._tippy != 'undefined') {
                triggerElement._tippy.setContent('Copied to clipboard!');
                setTimeout(function () {
                    triggerElement._tippy.hide();
                }, 1000);

                setTimeout(function () {
                    triggerElement._tippy.setContent(origTip);
                }, 2000);
            }
        } catch (err) {
            console.error('Failed to copy!', err)
        }
    }
    else if (window.clipboardData) { // Internet Explorer
        try {
            window.clipboardData.setData("Text", content);
            if (typeof triggerElement._tippy != 'undefined') {
                triggerElement._tippy.setContent('Copied to clipboard!');
                setTimeout(function () {
                    triggerElement._tippy.hide();
                }, 1000);

                setTimeout(function () {
                    triggerElement._tippy.setContent(origTip);
                }, 2000);
            }
        } catch (err) {
            console.error('Failed to copy!', err)
        }
    }

    return false;
}

function AddAntiForgeryToken(data) {
    data.__RequestVerificationToken = $("#_csrfPostForm > input[name='__AjaxRequestVerificationToken']").val();
    return data;
};

function CreateAndReplaceDocumentServerPostURL(form) {
    form[0].action = CreateDocumentServerPostURL(form[0].action);
}

function CreateDocumentServerPostURL(actionUrl) {
    if (!actionUrl.includes("Documents/DocumentServerAction"))
        return actionUrl;

    actionUrl = actionUrl.replace(/&amp;/g, "&");

    var baseUrl = actionUrl + '&postAction=true';
    var finalUrl = "";

    $.ajax({
        url: baseUrl,
        type: 'GET',
        async: false,
        success: function (data) {
             finalUrl = data;
        },
        error: function (xhr: any, status, error) {
            var err = eval("(" + xhr.responseText + ")");
            console.log(err);
        }
    });

    return finalUrl;
};

function smoothScrollToElement(elem: HTMLElement, speed: string, offset: number) {
    if (typeof speed == 'undefined' || speed == null || speed === "")
        speed = "slow";

    if (typeof offset || offset == null)
        offset = -75;

    if ($(elem).length != 1)
        return;

    $("html, body").animate({ scrollTop: $(elem).offset().top + offset }, speed);
}

function logRecentLinkAccessed(selector: string, domainID: number) {
    $( selector ).on('click',function() {
        $.ajax({
            type: 'POST',
            url: getControllerName() + '/SaveLinkAccessed',
            dataType: 'json',
            data: {
                domainID: domainID,
                linkAddress: $(this).attr('href'),
                name: $(this).text(),
                },
        async: false,
        success: function(data) {}
        });
    });
}

$(document).on('change', '.selectnoneall', function () {
    setSelectAllStatus(this);
});

function setSelectAllStatus(checkbox) {
    let optionText = checkbox.checked ? 'None' : 'All Rows';
    $(checkbox).attr('aria-label', `Select ${optionText}`);
}

function getCustomFieldNameFromAlias(aliasName) {
    try {
        if (aliasName == null)
            return aliasName;
        const fieldAliases = JSON.parse($('[name="customFieldAliases"]').val());

        // remove the Alias_ part, and account for the possibility of a dot operator (e.g. "Alias_FieldName.DisplayCode") in a formula tag
        var parts = aliasName.split('Alias_').pop().split('.');
        var search = parts[0];

        for (var i in fieldAliases) {
            var alias = fieldAliases[i];
            if (alias.Alias == search) {
                var replacement = parts.length > 1 ? alias.Field + '.' + parts[1] : alias.Field;
                console.log('ALIAS: Replacing ' + aliasName + ' with ' + replacement);
                return replacement;
            }
        }

        return aliasName;
    }
    catch {
        return 'Custom field name not available.'
    }
}

function addNoneSelected(element) {
    let options = null;
    if ($(element).children().is('option')) {
        options = $(element).children();
    } else if ($(element).children().is('optgroup')) {
        options = $(element).children().children();
    }
    if (options && options.length > 0 && $(options[0]).text() === '') {
        $(options).not(options[0]).css('color', 'initial');
        $(options[0]).addClass('faded');
        $(options[0]).text(window.origami.settings.EmptyComboBoxText);
        $(options[0]).val('');
    }
    setSelectOption(element);
    $(element).change(function () {
        setSelectOption(this);
    });
}

function setSelectOption(element) {
    let opt = $(element).find(':selected');
    if ($(opt).hasClass('faded')) {
        $(element).addClass('faded');
    } else {
        $(element).removeClass('faded');
    }
}

function shrinkTooltipIfNecessary(instance) {
    let maxLines = window.origami.settings.TooltipMaximumLinesVisible;

    if (maxLines <= 0) return;

    let pC = instance.popperChildren;

    const lineHeight = Number.parseFloat($(pC.content).css("line-height"));
    const height = Number.parseFloat($(pC.content).css("height"));

    if (height <= maxLines * lineHeight) return;

    $(pC.content).css({ "height" : maxLines * lineHeight, "overflow": "hidden", "cursor": "pointer", "mask-image": `linear-gradient(to top, transparent, ${$(pC.tooltip).css("background-color")})` });
    $(pC.tooltip).append($(`<div class="tippyExpanderText ${$(pC.content).attr('class')}" data-state="visible">(click to expand)</div>`));

    $(pC.tooltip).click(() => {
        openMessagePopup($(instance.popperChildren.content).html(), "Tooltip Detail");
    })
}

function openMessagePopup(text, title = "Message") {
    window.origami.data.messageText = text;
    let url = getServerAppRoot() + `${getControllerName()}/MessageWithTitle`;
    url += "?message=placeholder&title=" + encodeURIComponent(title);
    openThickboxPopup(url);
}



/**
 * sensitive fields:
 */

const sensitiveFieldMessages = {
    confirm: 'Are you sure you want to show the value of this Sensitive Field? Access will be logged.',
    tooltips: {
        reveal: 'Click to show the value of this Sensitive Field.',
        hide: 'Click to hide the value of this Sensitive Field.',
        overwrite: 'You do not have access to show the value of this Sensitive Field. Click to overwrite it with a new value.',
        undo: 'Click to revert this Sensitive Field to its original value and undo any changes.'
    },
}

function initSensitiveFields(subset) {

    if (typeof getControllerAction !== 'function') return;
    const action = getControllerAction().toLowerCase();

    // set tooltips based on data-tooltip-key, so we can store all sensitive field tooltip strings in one place
    $("button.sensitiveFieldButton", subset).each(function () {
        setSensitiveFieldTooltip($(this));
    });

    // if we're validating (i.e. action == save) and there are sensitive fields on the page, make sure the sensitive fields are properly filled
    if (typeof getSensitiveFieldChanges === 'function' && action == 'save') {

        getSensitiveFieldChanges().forEach(data => {

            const input: JQuery = $(`[name=${data["field"]}]`);
            const radioInputs: JQuery = input.siblings('label').find('input[type="radio"]');
            const button: JQuery = input.siblings('button.sensitiveFieldButton');

            // all sensitive fields with a value on the model should have this data attribute
            if (data["hasPreviousValue"]) {
                input.data('sensitive-has-value', true);
            }

            if (!input.hasClass('sensitiveFieldChanged')) {
                input.addClass('sensitiveFieldChanged');
            }

            // radio buttons are weird, do them differently
            if (radioInputs.length) {

                // first set the hidden one
                input.val(data["value"]);

                // then, if the value isn't empty, make sure the correct radio button is checked
                if (data["value"]) {
                    clearRadio(radioInputs.filter(`[value="${data["value"]}"]`).prop('checked', true));
                }

            }
            else {

                // first, get input and set value from just submitted form, also set placeholder in case user re-masks the field
                input.val(data["value"]).data('placeholder', data['placeholder']);

                // if this is a lookup, it will have a lookupDescription, so set the display input to that description, also set placeholder in case user re-masks the field
                if (data["lookupDescription"] && input.attr('type') == 'hidden') {
                    input.siblings('input').val(data["lookupDescription"]).data('placeholder', data['placeholder']);
                }

            }

            // if hasPreviousValue, they are overwriting an old value, so the button should be set to 'undo' state. Otherwise, or if the field is readonly, remove the button
            if (data["hasPreviousValue"] && !input.data('sensitive-readonly') && button[0]) {
                toggleSensitiveField({ e: button[0], maskingType: input.hasClass('socialsecurity') ? 'SocialSecurity' : 'General', mode: button.data('tooltip-key') == 'reveal' ? 'Edit' : 'Overwrite', noAjax: true });
            } else {
                button.remove();
            }
        });
    }

    // remove all edit-page sensitive field buttons where the field doesn't yet have a value on the model
    $('button.sensitiveFieldButton', subset).not('.sensitiveFieldUndo').filter(function () {
        const input: JQuery = $(this).siblings('input, select, textarea');
        return input.length && !input.data('sensitive-has-value') && (!input.attr('disabled') || input.data('sensitive-readonly'));
    }).remove();

    // if a sensitive field (edit form) is changed through some automatic way, like a datepicker or autofill, make sure the field is set to overwrite mode
    $('input.sensitiveField, select.sensitiveField, textarea.sensitiveField', subset).filter(function () {
        // make sure radio buttons are not included
        return !$(this).is('[type="radio"]') && $(this).siblings('label').children('[type="radio"]').length == 0;
    }).on('change', (e) => {

        const button: JQuery = $(e.target).closest('span.value').find('button.sensitiveFieldButton');
        if (button.length && !button.hasClass('unmasked')) {

            // recordID and fieldName don't matter because no data is being fetched
            toggleSensitiveField({
                e: button[0],
                maskingType: $(e.target).hasClass('socialsecurity') ? 'SocialSecurity' : 'General',
                mode: button.data('tooltip-key') == 'reveal' ? 'Edit' : 'Overwrite',
                noAjax: true
            });
        }
        // Need to know if we are intentionally trying to change the value of a field we don't have permission to unmask
        else if (!button.length) {
            $(e.target).addClass('sensitiveFieldChanged');
        }

    });

    // if a sensitive field is initially masked, hide buttons that aren't the unmask button, like datepicker or lookup
    $('button.sensitiveFieldButton', subset).not('.sensitiveFieldUndo').siblings('button').not('.sensitiveFieldButton').hide();
}

/**
 * This is the onclick method used for masking/unmasking sensitive fields.
 * e: button html node
 * recordID: recordID of the record being viewed/edited
 * fieldName: fieldname, i.e. 'SocialSecurity' or 'CustomText1'
 * maskingType: currently will be 'SocialSecurity' or 'General'
 * mode: will be 'Edit' or 'View' or 'Overwrite'
 * noAjax: if true, value will not be fetched/populated, similar to overwrite
 */
function toggleSensitiveField({ e = null, recordID = 0, fieldName = '', maskingType = 'General', mode = 'Overwrite', noAjax = false }) {
    const button: JQuery = $(e);
    const input: JQuery = button.closest('span.value').find('input.sensitiveField, select.sensitiveField, textarea.sensitiveField');
    const unmasking: boolean = !button.hasClass('unmasked');

    // initially store placeholder in data, if not view mode
    if (unmasking && mode !== 'View' && input.length && !input.data('placeholder')) {
        input.data('placeholder', input.attr('placeholder'));
    }

    // this is the no permissions case:
    if (mode === 'Overwrite') {

        styleSensitiveFieldInput(input, unmasking);
        styleSensitiveFieldButton(button, mode, unmasking);

        // if masking, clear value
        if (!unmasking) {
            input.val(null);

            // make sure radio buttons are cleared
            input.filter('[type="radio"]').filter('[previouslychecked="true"]').each(function () {
                clearRadio($(this));
            });
        }

        // if ssn, toggle input masking
        if (unmasking && maskingType == 'SocialSecurity') {
            input.maskedInput({ mask: "ssn" });
        }

        toggleFieldChanged(fieldName, false);
    }

    // this is used when we want to style the field like it has been revealed, but don't want to call ajax/populate value
    else if (noAjax) {
        styleSensitiveFieldButton(button, mode, unmasking);

        if (mode == 'Edit') {

            styleSensitiveFieldInput(input, unmasking);

            if (unmasking && maskingType == 'SocialSecurity') {
                input.maskedInput({ mask: "ssn" });
            }
        }
    }

    // this is the has permissions case:
    else {                        

        if (unmasking && !confirm(sensitiveFieldMessages.confirm)) {
            return;
        }

        $.ajax({
            data: AddAntiForgeryToken({ recordID, fieldName, maskingType, unmasking }),
            type: 'POST',
            url: getServerAppRoot() + `${getControllerName()}/UnlockSensitiveField/`,
            success: (data) => {
                if (data.status == 'success') {

                    styleSensitiveFieldButton(button, mode, unmasking);

                    if (mode === 'Edit') {

                        styleSensitiveFieldInput(input, unmasking);

                        if (input.filter('[type="radio"]').length) {

                            // for radio inputs
                            input.filter('.sensitiveFieldHidden').val(unmasking ? data.value : null);

                            if (unmasking) {
                                // when unmasking, clearRadio() for radio that matches data.value
                                clearRadio(input.filter('[type="radio"]').filter(`[value="${data.value}"]`).prop('checked', true));
                            }
                            else {
                                // when masking, clearRadio() for all radios
                                input.filter('[type="radio"]').filter('[previouslychecked="true"]').each(function () {
                                    clearRadio($(this));
                                });
                            }
                        }
                        else if (input.filter('select').length) {

                            // for dropdowns
                            input.val(unmasking ? data.value : null);
                        }
                        else {

                            // for normal inputs
                            input.not('.sensitiveFieldHidden').val(unmasking ? data.display : null);    // populate display if unmasking
                            input.filter('.sensitiveFieldHidden').val(unmasking ? data.value : null);   // populate associationID if unmasking
                        }

                        // if editing, mask ssn appropriately
                        if (unmasking && maskingType == 'SocialSecurity') {
                            input.maskedInput({ mask: "ssn" });
                        }

                        toggleFieldChanged(fieldName, false);
                    }

                    else if (mode === 'View') {
                        const siblingSpan = button.siblings('span.sensitiveField');

                        if (unmasking && data.link) {
                            // if this is an associated record, the ajax will return a link to the record as well, so add that
                            siblingSpan.html(`<a href="${data.link}">${data.display}</a>`);
                        } else {
                            // otherwise, just replace with value
                            if (siblingSpan.length > 0) {
                                siblingSpan.text(data.display);
                            }
                            else {
                                // Could be a readOnly field on edit screen, in which case value is shown in a disabled input
                                const siblingInput = button.siblings('input.sensitiveField');
                                if (siblingInput.length > 0) {
                                    siblingInput.val(data.display);
                                }
                            }
                        }
                    }

                } else {

                    statusErrorMessage('An error occurred while trying to unlock a sensitive field.');
                }
            }
        });
    }

}

function styleSensitiveFieldButton(button: JQuery, mode: string, unmasking: boolean) {

    // function to remove existing icon classes and add the new one
    const toggleIcon = (maskedClass: string, unmaskedClass: string) => button.find('i').removeClass('fa-lock').removeClass('fa-undo').removeClass('fa-unlock').removeClass('fa-edit').addClass(`fa-${unmasking ? unmaskedClass : maskedClass}`);

    // function to toggle cancel button style
    const toggleUndoStyle = () => button.toggleClass('sensitiveFieldUndo', unmasking);

    // function to toggle tooltip between two keys
    const toggleTooltip = (maskedKey: string, unmaskedKey: string) => setSensitiveFieldTooltip(button, unmasking ? unmaskedKey : maskedKey);

    button.toggleClass('unmasked');

    switch (mode) {
        case 'Edit':
            toggleIcon('lock', 'undo');
            toggleTooltip('reveal', 'undo');
            toggleUndoStyle();

            break;
        case 'View':
            toggleIcon('lock', 'unlock');
            toggleTooltip('reveal', 'hide');

            break;
        case 'Overwrite':
            toggleIcon('edit', 'undo');
            toggleTooltip('overwrite', 'undo');
            toggleUndoStyle();

            break;
    }

    // remove focus from button
    button.blur();

    // toggle buttons besides the sensitive field button, for example datepicker or lookup buttons
    const siblingButtons = button.siblings('button').not('.sensitiveFieldButton');
    unmasking ? siblingButtons.show() : siblingButtons.hide();
}

function setSensitiveFieldTooltip(button: JQuery, key: string = null) {

    if (button?.children().length) {

        // get message from messages object, or use default if not available
        const message: string = sensitiveFieldMessages.tooltips[key ?? button.data('tooltip-key')] ?? 'This is a sensitive field.';

        // set tippy content
        button.children().first()[0]['_tippy']?.setContent(message);
        button.children().first().attr('data-tippy-content', message);
    }
}

function styleSensitiveFieldInput(input: JQuery, unmasking: boolean) {

    // disable when masking, enable when unmasking
    input.prop('disabled', !unmasking);

    // text fields should have placeholder when masked, no placeholder when unmasked
    input.filter('input, textarea').attr('placeholder', !unmasking ? input.data('placeholder') : null);

    const select: JQuery = input.filter('select');
    if (select.length) {

        // switch the first option's text and value based on the data attributes on the select (set in HtmlHelperExtensions)
        // setting the actual value of the select will be done after this code is run
        select.find('option').first().text(unmasking ? select.data('first-option-text') : select.data('placeholder'));
        select.find('option').first().val(unmasking ? select.data('first-option-value') : null);

        select.toggleClass('faded', !unmasking);
    }
}

// Cached Grids
var _cachedGridKeys = []

function addCachedGridKey(key) {
    _cachedGridKeys.push(key);
    $("#CachedGridKeys").val(_cachedGridKeys.join(","));
}

function reloadCachedGrids() {
    for (const key of _cachedGridKeys) {
        var url = getServerAppRoot() + "/Dynamic/ReloadCachedGrid/?gridCacheKey=" + key;
        $("div[name='cachedGridReloadContainer-" + key +"']").load(url);
    }
}

const initializeSignalRProxies = () => {
    if (!$.connection) { // bail early if the signalr library is not loaded
        return;
    }

    try {
        // Add all the client methods so the signalR connection can be established correctly for all hubs. All client methods for the hubs should be included here, but the actual event handler implementation is done in the hub itself.
        initSignalRForTextMessages();
        initSignalRForConfigMigration();

        // Close the connection when the page is navigating away
        $(window).on('beforeunload', function () {
            $.connection.hub.stop();
        });
    } catch (error) {
        console.info('Error initializing SignalR proxies', error);
    }
};

const initSignalRForTextMessages = () => {
    const textMessageHub = $.connection.MessageNotificationsHub = $.connection.hub.createHubProxy('MessageNotificationsHub');
    textMessageHub.client = {};

    const textMessageHubClientActions = ["sendMessageNotification", "sendNotificationForConversation"];
    textMessageHubClientActions.forEach(action => {
        textMessageHub.client[action] = (...params) => {
            $(document).trigger(action, params);
        };
    });
};

const initSignalRForConfigMigration = () => {
    const migrationHub = $.connection.MigrationsHub = $.connection.hub.createHubProxy('MigrationsHub');
    migrationHub.client = {};

    const migrationHubClientActions = ["sendMigrationImportStatusMessage", "promptForUserInput"];
    migrationHubClientActions.forEach(action => {
        migrationHub.client[action] = (...params) => {
            $(document).trigger(action, params);
        };
    });
};